import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { toast } from 'react-toastify';
import { queryAPI } from '../services/api';
import './TableBrowser.css';

// Table data provided by user
// Total: 5115 tables
const TABLE_DATA = [
  {"id":"anc_abs_agreement_certs_f"},
  {"id":"anc_abs_agreement_plans_f"},
  {"id":"anc_abs_agreement_plans_f_"},
  {"id":"anc_abs_certifications_f"},
  {"id":"anc_abs_certifications_f_tl"},
  {"id":"anc_abs_certifications_f_tl["},
  {"id":"anc_abs_certifications_f_tl]"},
  {"id":"anc_abs_certifications_f["},
  {"id":"anc_abs_certifications_f]"},
  {"id":"anc_abs_pattern_usages_f"},
  {"id":"anc_abs_pattern_usages_f["},
  {"id":"anc_abs_process_lock"},
  {"id":"anc_abs_type_certs_f"},
  {"id":"anc_abs_type_certs_f_"},
  {"id":"anc_abs_type_rgn_usages_f"},
  {"id":"anc_abs_type_rgn_usages_f_"},
  {"id":"anc_abs_usage_rules_f"},
  {"id":"anc_absence_agreements_f"},
  {"id":"anc_absence_agreements_f_tl"},
  {"id":"anc_absence_categories_f"},
  {"id":"anc_absence_categories_f_tl"},
  {"id":"anc_absence_categories_f_tl["},
  {"id":"anc_absence_categories_f_tl]"},
  {"id":"anc_absence_categories_f["},
  {"id":"anc_absence_categories_f]"},
  {"id":"anc_absence_pattern_rgns_f"},
  {"id":"anc_absence_pattern_rgns_f["},
  {"id":"anc_absence_patterns_f"},
  {"id":"anc_absence_patterns_f["},
  {"id":"anc_absence_plans_f"},
  {"id":"anc_absence_plans_f_"},
  {"id":"anc_absence_plans_f_tl"},
  {"id":"anc_absence_reasons_f"},
  {"id":"anc_absence_reasons_f_tl"},
  {"id":"anc_absence_type_cate_f"},
  {"id":"anc_absence_type_plans_f"},
  {"id":"anc_absence_type_plans_f_"},
  {"id":"anc_absence_type_reasons_f"},
  {"id":"anc_absence_type_reasons_f_"},
  {"id":"anc_absence_type_regions_f"},
  {"id":"anc_absence_type_regions_f_"},
  {"id":"anc_absence_types_f"},
  {"id":"anc_absence_types_f_"},
  {"id":"anc_absence_types_f_tl"},
  {"id":"anc_accrual_bands_f"},
  {"id":"anc_accrual_bands_f_"},
  {"id":"anc_app_config_params_f"},
  {"id":"anc_avail_type_breaks_b"},
  {"id":"anc_avail_type_breaks_tl"},
  {"id":"anc_availability_type_privs"},
  {"id":"anc_availability_types_b"},
  {"id":"anc_availability_types_tl"},
  {"id":"anc_cal_eventset_b"},
  {"id":"anc_cal_eventset_event"},
  {"id":"anc_cal_eventset_grp"},
  {"id":"anc_cal_eventset_tl"},
  {"id":"anc_calendar_b"},
  {"id":"anc_calendar_cal_event"},
  {"id":"anc_calendar_subscriber"},
  {"id":"anc_calendar_tl"},
  {"id":"anc_entl_bands_dtl_f"},
  {"id":"anc_entl_bands_dtl_f_"},
  {"id":"anc_entl_bands_dtl_f_tl"},
  {"id":"anc_entl_bands_f"},
  {"id":"anc_entl_bands_f_"},
  {"id":"anc_events"},
  {"id":"anc_events_tl"},
  {"id":"anc_grp_criteria"},
  {"id":"anc_job_configuration"},
  {"id":"anc_job_configuration_tl"},
  {"id":"anc_job_configuration_tl["},
  {"id":"anc_job_configuration["},
  {"id":"anc_job_runs"},
  {"id":"anc_matrix_contexts"},
  {"id":"anc_matrix_sources"},
  {"id":"anc_matrix_trxns"},
  {"id":"anc_mx_input_exps_f"},
  {"id":"anc_mx_input_params"},
  {"id":"anc_mx_input_params_tl"},
  {"id":"anc_mx_src_contexts"},
  {"id":"anc_mx_trxn_contexts"},
  {"id":"anc_mx_trxn_input_params"},
  {"id":"anc_pay_interface_header"},
  {"id":"anc_pay_interface_lines"},
  {"id":"anc_per_abs_aggregation"},
  {"id":"anc_per_abs_agrmnt_certs"},
  {"id":"anc_per_abs_agrmnt_elig"},
  {"id":"anc_per_abs_agrmnt_ent"},
  {"id":"anc_per_abs_agrmnt_ent_dtls"},
  {"id":"anc_per_abs_agrmnt_prtnrs"},
  {"id":"anc_per_abs_agrmnts"},
  {"id":"anc_per_abs_agrmnts_tl"},
  {"id":"anc_per_abs_certs"},
  {"id":"anc_per_abs_daily_dtls"},
  {"id":"anc_per_abs_ent_spl_cond"},
  {"id":"anc_per_abs_entries"},
  {"id":"anc_per_abs_entries_"},
  {"id":"anc_per_abs_entry_dtls"},
  {"id":"anc_per_abs_entry_dtls_"},
  {"id":"anc_per_abs_entry_ess_bkup"},
  {"id":"anc_per_abs_headers"},
  {"id":"anc_per_abs_maternity"},
  {"id":"anc_per_abs_maternity_"},
  {"id":"anc_per_abs_plan_entries"},
  {"id":"anc_per_abs_plan_entries_"},
  {"id":"anc_per_abs_pln_summ_ent"},
  {"id":"anc_per_abs_pln_summ_ent_"},
  {"id":"anc_per_abs_qual_entl"},
  {"id":"anc_per_abs_shift_breakdown"},
  {"id":"anc_per_abs_shift_calc_ent"},
  {"id":"anc_per_abs_typ_lnkg"},
  {"id":"anc_per_abs_type_entries"},
  {"id":"anc_per_absence_info"},
  {"id":"anc_per_accrual_entries"},
  {"id":"anc_per_accrual_entries_"},
  {"id":"anc_per_acrl_entry_dtls"},
  {"id":"anc_per_acrl_entry_dtls_"},
  {"id":"anc_per_acrl_entry_dtls_map"},
  {"id":"anc_per_acrl_xfr_entry_map"},
  {"id":"anc_per_avail_details"},
  {"id":"anc_per_availabilities"},
  {"id":"anc_per_ben_elctd_disb"},
  {"id":"anc_per_case_absences"},
  {"id":"anc_per_case_breakdown"},
  {"id":"anc_per_covr_sub_bal"},
  {"id":"anc_per_covr_sub_bal_map"},
  {"id":"anc_per_events"},
  {"id":"anc_per_plan_enrollment"},
  {"id":"anc_per_plan_enrollment_"},
  {"id":"anc_per_plan_entry_dtls"},
  {"id":"anc_per_proc_evt_que"},
  {"id":"anc_plan_elig_profiles_f"},
  {"id":"anc_plan_elig_profiles_f_"},
  {"id":"anc_plan_entries_f"},
  {"id":"anc_plan_events_f"},
  {"id":"anc_plan_events_f_"},
  {"id":"anc_process_messages"},
  {"id":"anc_reprocess_events"},
  {"id":"anc_type_events"},
  {"id":"anc_type_events_"},
  {"id":"anc_type_events_f"},
  {"id":"anc_wfm_integration_migbkp"},
  {"id":"anc_wfm_interface_header"},
  {"id":"ben_aca_reporting"},
  {"id":"ben_acrs_ptip_cvg_f"},
  {"id":"ben_actn_typ"},
  {"id":"ben_actn_typ_tl"},
  {"id":"ben_acty_base_rt_ctfn_f"},
  {"id":"ben_acty_base_rt_f"},
  {"id":"ben_acty_rt_ded_sched_f"},
  {"id":"ben_acty_rt_ptd_lmt_f"},
  {"id":"ben_acty_rt_pymt_sched_f"},
  {"id":"ben_acty_vrbl_rt_f"},
  {"id":"ben_age_fctr"},
  {"id":"ben_apld_dpnt_cvg_elig_prfl_f"},
  {"id":"ben_asgn_ptnl_ler"},
  {"id":"ben_asgn_ptnl_ler_"},
  {"id":"ben_band_abs_entitlement"},
  {"id":"ben_band_details"},
  {"id":"ben_band_entitlement_dets"},
  {"id":"ben_batch_actions"},
  {"id":"ben_batch_actn_item_info"},
  {"id":"ben_batch_bnft_cert_info"},
  {"id":"ben_batch_commu_info"},
  {"id":"ben_batch_dpnt_info"},
  {"id":"ben_batch_elctbl_chc_info"},
  {"id":"ben_batch_elig_info"},
  {"id":"ben_batch_header"},
  {"id":"ben_batch_ler_info"},
  {"id":"ben_batch_lines"},
  {"id":"ben_batch_parameter"},
  {"id":"ben_batch_proc_info"},
  {"id":"ben_batch_ranges"},
  {"id":"ben_batch_rate_info"},
  {"id":"ben_benefit_actions"},
  {"id":"ben_benefit_qstnr"},
  {"id":"ben_benefit_relations_f"},
  {"id":"ben_benfts_grp"},
  {"id":"ben_bill_calendar"},
  {"id":"ben_bill_charge_details"},
  {"id":"ben_bill_charge_details_"},
  {"id":"ben_bill_charge_payments"},
  {"id":"ben_bill_charges"},
  {"id":"ben_bill_charges_"},
  {"id":"ben_bill_comms"},
  {"id":"ben_bill_cycle"},
  {"id":"ben_bill_enrt_rslt"},
  {"id":"ben_bill_enrt_rslt_"},
  {"id":"ben_bill_payments"},
  {"id":"ben_bill_payments_"},
  {"id":"ben_bill_per_credit"},
  {"id":"ben_bnft_category"},
  {"id":"ben_bnft_category_tl"},
  {"id":"ben_bnft_rstrn_ctfn_f"},
  {"id":"ben_bnft_vrbl_rt_f"},
  {"id":"ben_bnft_vrbl_rt_rl_f"},
  {"id":"ben_bnfts_bal_f"},
  {"id":"ben_cir_mappings_f"},
  {"id":"ben_clpse_lf_evt"},
  {"id":"ben_clpse_lf_evt_f"},
  {"id":"ben_cmbn_age_los_fctr"},
  {"id":"ben_cmbn_plip_f"},
  {"id":"ben_cmbn_ptip_f"},
  {"id":"ben_cmbn_ptip_opt_f"},
  {"id":"ben_cntng_prtn_elig_prfl"},
  {"id":"ben_cntnu_prtn_ctfn_typ_f"},
  {"id":"ben_comp_lvl_fctr"},
  {"id":"ben_comp_obj_cache"},
  {"id":"ben_comp_obj_cache_row"},
  {"id":"ben_crdt_pool_spnd_rlvr_opt_f"},
  {"id":"ben_crt_ordr"},
  {"id":"ben_crt_ordr_cvrd_per"},
  {"id":"ben_crt_ordr_f"},
  {"id":"ben_crt_ordr_f_"},
  {"id":"ben_crt_ordr_pl_dpnt"},
  {"id":"ben_crt_ordr_pl_dpnt_"},
  {"id":"ben_csr_activities"},
  {"id":"ben_css_rltd_per_per_in_ler"},
  {"id":"ben_ctfn_doc_map"},
  {"id":"ben_cvg_amt_calc_mthd_f"},
  {"id":"ben_cvrd_dpnt_ctfn_prvdd"},
  {"id":"ben_ded_sched_py_freq"},
  {"id":"ben_doc_images"},
  {"id":"ben_docs_prvdd_dtls"},
  {"id":"ben_dpnt_cvg_rqd_rlshp"},
  {"id":"ben_dpnt_cvrd_anthr_oipl_cvg_f"},
  {"id":"ben_dpnt_cvrd_anthr_pl_cvg_f"},
  {"id":"ben_dsgn_rqmt_f"},
  {"id":"ben_dsgn_rqmt_rlshp_typ"},
  {"id":"ben_dsgntr_enrld_cvg"},
  {"id":"ben_elcn_rules"},
  {"id":"ben_elcn_rules_tl"},
  {"id":"ben_elctbl_chc_ctfn"},
  {"id":"ben_elig_age_prte"},
  {"id":"ben_elig_anthr_pl_prte"},
  {"id":"ben_elig_asnt_set_prte"},
  {"id":"ben_elig_benfts_grp_prte"},
  {"id":"ben_elig_brgng_unit_prte"},
  {"id":"ben_elig_bu_prte"},
  {"id":"ben_elig_category"},
  {"id":"ben_elig_cbr_quald_bnf"},
  {"id":"ben_elig_cmbn_age_los_prte"},
  {"id":"ben_elig_comp_lvl_prte"},
  {"id":"ben_elig_comptncy_prte"},
  {"id":"ben_elig_cvrd_dpnt"},
  {"id":"ben_elig_dpnt"},
  {"id":"ben_elig_dpnt_cvrd_othr_oipl"},
  {"id":"ben_elig_dpnt_cvrd_othr_pgm"},
  {"id":"ben_elig_dpnt_cvrd_othr_pl"},
  {"id":"ben_elig_dpnt_cvrd_othr_ptip"},
  {"id":"ben_elig_dpnt_cvrd_plip"},
  {"id":"ben_elig_dpnt_othr_ptip"},
  {"id":"ben_elig_dsbld_prte"},
  {"id":"ben_elig_dsbld_stat_prte_f"},
  {"id":"ben_elig_dsblty_ctg_prte"},
  {"id":"ben_elig_dsblty_dgr_prte"},
  {"id":"ben_elig_dsblty_rsn_prte"},
  {"id":"ben_elig_ee_stat_prte"},
  {"id":"ben_elig_enrld_anthr_oipl"},
  {"id":"ben_elig_enrld_anthr_pgm"},
  {"id":"ben_elig_enrld_anthr_pl"},
  {"id":"ben_elig_enrld_anthr_plip"},
  {"id":"ben_elig_enrld_anthr_ptip"},
  {"id":"ben_elig_fl_tm_pt_tm_prte"},
  {"id":"ben_elig_flx_crdt_pool_chc"},
  {"id":"ben_elig_gen_crit_prte"},
  {"id":"ben_elig_gndr_prte"},
  {"id":"ben_elig_grd_prte"},
  {"id":"ben_elig_hierarchy"},
  {"id":"ben_elig_hiredt_prte"},
  {"id":"ben_elig_hlth_cvg_prte"},
  {"id":"ben_elig_hrly_slrd_prte"},
  {"id":"ben_elig_hrs_wkd_prte"},
  {"id":"ben_elig_job_prte"},
  {"id":"ben_elig_jobfam_prte"},
  {"id":"ben_elig_jobfunc_prte"},
  {"id":"ben_elig_lbr_mmbr_prte"},
  {"id":"ben_elig_lgl_enty_prte"},
  {"id":"ben_elig_loa_rsn_prte"},
  {"id":"ben_elig_los_prte"},
  {"id":"ben_elig_lvg_rsn_prte"},
  {"id":"ben_elig_mgr_prte"},
  {"id":"ben_elig_mltry_stat_prte"},
  {"id":"ben_elig_mrtl_sts_prte"},
  {"id":"ben_elig_no_othr_cvg_prte"},
  {"id":"ben_elig_obj_elig_profl_f"},
  {"id":"ben_elig_obj_f"},
  {"id":"ben_elig_optd_mdcr_prte"},
  {"id":"ben_elig_org_unit_prte"},
  {"id":"ben_elig_othr_ptip_prte"},
  {"id":"ben_elig_pct_fl_tm_prte"},
  {"id":"ben_elig_per_elctbl_chc"},
  {"id":"ben_elig_per_f"},
  {"id":"ben_elig_per_opt_f"},
  {"id":"ben_elig_per_typ_prte"},
  {"id":"ben_elig_per_wv_pl_typ_f"},
  {"id":"ben_elig_perf_rtng_prte"},
  {"id":"ben_elig_poe_prte"},
  {"id":"ben_elig_ppl_grp_prte"},
  {"id":"ben_elig_prbtn_perd_prte"},
  {"id":"ben_elig_prtt_anthr_pgm_f"},
  {"id":"ben_elig_prtt_anthr_pl_prte"},
  {"id":"ben_elig_pstl_cd_r_rng_prte"},
  {"id":"ben_elig_pstn_prte"},
  {"id":"ben_elig_py_bss_prte"},
  {"id":"ben_elig_pyrl_prte"},
  {"id":"ben_elig_qua_in_gr_prte"},
  {"id":"ben_elig_qual_titl_prte"},
  {"id":"ben_elig_rslt_f"},
  {"id":"ben_elig_rslt_f_"},
  {"id":"ben_elig_schedd_hrs_prte"},
  {"id":"ben_elig_scre_wtg_f"},
  {"id":"ben_elig_sp_clng_prg_prte"},
  {"id":"ben_elig_stdnt_stat_cvg"},
  {"id":"ben_elig_sub_category"},
  {"id":"ben_elig_suppl_role_prte"},
  {"id":"ben_elig_svc_area_prte"},
  {"id":"ben_elig_tbco_use_prte"},
  {"id":"ben_elig_to_prte_rsn_f"},
  {"id":"ben_elig_ttl_cvg_vol_prte"},
  {"id":"ben_elig_ttl_prtt_prte"},
  {"id":"ben_elig_wk_loc_prte"},
  {"id":"ben_eligy_crit_values"},
  {"id":"ben_eligy_criteria"},
  {"id":"ben_eligy_prfl"},
  {"id":"ben_eligy_prfl_rl"},
  {"id":"ben_enrt_bnft"},
  {"id":"ben_enrt_ctfn_f"},
  {"id":"ben_enrt_enrld_anthr_oipl_f"},
  {"id":"ben_enrt_enrld_anthr_pl_f"},
  {"id":"ben_enrt_perd"},
  {"id":"ben_enrt_perd_for_pl_f"},
  {"id":"ben_enrt_rt"},
  {"id":"ben_ent_abs_attendns_typs"},
  {"id":"ben_entitlement"},
  {"id":"ben_extra_input_values"},
  {"id":"ben_extract_details_arch"},
  {"id":"ben_extract_elements"},
  {"id":"ben_extract_file_details"},
  {"id":"ben_extract_layout"},
  {"id":"ben_extract_mapping"},
  {"id":"ben_extract_req_details"},
  {"id":"ben_extract_request"},
  {"id":"ben_extract_request_arch"},
  {"id":"ben_ff_eval"},
  {"id":"ben_ff_eval_rslt"},
  {"id":"ben_flex_crdt_ldgr"},
  {"id":"ben_gap_absence_plans"},
  {"id":"ben_gap_daily_absences"},
  {"id":"ben_gap_duration_summary"},
  {"id":"ben_gd_or_svc_typ"},
  {"id":"ben_global_transfer_dtls"},
  {"id":"ben_holiday_calendar"},
  {"id":"ben_holiday_calendar_dets"},
  {"id":"ben_hrs_wkd_in_perd_fctr"},
  {"id":"ben_integration_key_map"},
  {"id":"ben_le_clsn_n_rstr"},
  {"id":"ben_le_resolutions_f"},
  {"id":"ben_lee_rsn_f"},
  {"id":"ben_lee_rsn_rl_f"},
  {"id":"ben_leg_entity_defaults"},
  {"id":"ben_legal_disclaimer"},
  {"id":"ben_ler_bnft_rstrn_ctfn_f"},
  {"id":"ben_ler_bnft_rstrn_f"},
  {"id":"ben_ler_chg_dpnt_cvg_ctfn_f"},
  {"id":"ben_ler_chg_dpnt_cvg_f"},
  {"id":"ben_ler_chg_oipl_enrt_f"},
  {"id":"ben_ler_chg_oipl_enrt_rl_f"},
  {"id":"ben_ler_chg_pgm_enrt_f"},
  {"id":"ben_ler_chg_pl_nip_enrt_f"},
  {"id":"ben_ler_chg_pl_nip_rl_f"},
  {"id":"ben_ler_chg_plip_enrt_f"},
  {"id":"ben_ler_chg_plip_enrt_rl_f"},
  {"id":"ben_ler_chg_ptip_enrt_f"},
  {"id":"ben_ler_enrt_ctfn_f"},
  {"id":"ben_ler_f"},
  {"id":"ben_ler_f_tl"},
  {"id":"ben_ler_per_info_cs_ler"},
  {"id":"ben_ler_popl_actn_typ_f"},
  {"id":"ben_ler_rl_f"},
  {"id":"ben_ler_rl_f_tl"},
  {"id":"ben_ler_rltd_per_cs_ler"},
  {"id":"ben_los_fctr"},
  {"id":"ben_oipl_f"},
  {"id":"ben_oipl_f_tl"},
  {"id":"ben_oiplip_f"},
  {"id":"ben_online_warnings"},
  {"id":"ben_opt_f"},
  {"id":"ben_opt_f_tl"},
  {"id":"ben_optip_f"},
  {"id":"ben_pct_fl_tm_fctr"},
  {"id":"ben_per_acty_log"},
  {"id":"ben_per_benefit_group_f"},
  {"id":"ben_per_bill_info_f"},
  {"id":"ben_per_bill_info_f_"},
  {"id":"ben_per_bnf_org"},
  {"id":"ben_per_bnfts_bal_f"},
  {"id":"ben_per_bnfts_bal_f_"},
  {"id":"ben_per_dlvry_mthd_f"},
  {"id":"ben_per_elig_rslt_dtls_gt"},
  {"id":"ben_per_elig_rslt_gt"},
  {"id":"ben_per_in_ler"},
  {"id":"ben_per_in_ler_"},
  {"id":"ben_per_info_chg_cs_ler"},
  {"id":"ben_per_le_habits_cov_f"},
  {"id":"ben_per_le_habits_cov_f_"},
  {"id":"ben_person_actions"},
  {"id":"ben_pgm_dpnt_cvg_ctfn_f"},
  {"id":"ben_pgm_f"},
  {"id":"ben_pgm_f_tl"},
  {"id":"ben_pil_elctbl_chc_popl"},
  {"id":"ben_pl_bnf"},
  {"id":"ben_pl_bnf_"},
  {"id":"ben_pl_bnf_ctfn_f"},
  {"id":"ben_pl_bnf_ctfn_prvdd"},
  {"id":"ben_pl_carrier"},
  {"id":"ben_pl_copy_exist_obj"},
  {"id":"ben_pl_copy_logs"},
  {"id":"ben_pl_copy_map"},
  {"id":"ben_pl_copy_params"},
  {"id":"ben_pl_dpnt_cvg_ctfn_f"},
  {"id":"ben_pl_extract_identifier_f"},
  {"id":"ben_pl_f"},
  {"id":"ben_pl_f_tl"},
  {"id":"ben_pl_gd_or_svc_f"},
  {"id":"ben_pl_gd_r_svc_ctfn_f"},
  {"id":"ben_pl_pcp"},
  {"id":"ben_pl_pcp_typ"},
  {"id":"ben_pl_regn_f"},
  {"id":"ben_pl_regy_bod_f"},
  {"id":"ben_pl_regy_prp_f"},
  {"id":"ben_pl_typ_extend_period"},
  {"id":"ben_pl_typ_f"},
  {"id":"ben_pl_typ_f_tl"},
  {"id":"ben_pl_typ_opt_typ_f"},
  {"id":"ben_plip_f"},
  {"id":"ben_pop_up_messages"},
  {"id":"ben_popl_actn_typ_f"},
  {"id":"ben_popl_enrt_typ_cycl"},
  {"id":"ben_popl_org_f"},
  {"id":"ben_popl_org_role_f"},
  {"id":"ben_popl_rptg_grp_f"},
  {"id":"ben_popl_vald_hrchy"},
  {"id":"ben_popl_yr_perd"},
  {"id":"ben_prmry_care_prvdr"},
  {"id":"ben_prtl_mo_rt_prtn_val_f"},
  {"id":"ben_prtn_elig_f"},
  {"id":"ben_prtn_elig_prfl_f"},
  {"id":"ben_prtn_eligy_rl_f"},
  {"id":"ben_prtt_assocd_instn_f"},
  {"id":"ben_prtt_clm_gd_or_svc_typ"},
  {"id":"ben_prtt_enrt_actn"},
  {"id":"ben_prtt_enrt_ctfn_prvdd"},
  {"id":"ben_prtt_enrt_rslt"},
  {"id":"ben_prtt_enrt_rslt_"},
  {"id":"ben_prtt_leg_discmr_actn"},
  {"id":"ben_prtt_rt_val"},
  {"id":"ben_prtt_rt_val_ctfn_prvdd"},
  {"id":"ben_pstl_zip_rng"},
  {"id":"ben_ptip_dpnt_cvg_ctfn_f"},
  {"id":"ben_ptip_f"},
  {"id":"ben_ptnl_ler_for_per"},
  {"id":"ben_ptnl_ler_for_per_"},
  {"id":"ben_pymt_sched_py_freq"},
  {"id":"ben_qstnr_responses"},
  {"id":"ben_regn_f"},
  {"id":"ben_regn_f_tl"},
  {"id":"ben_regn_for_regy_body_f"},
  {"id":"ben_rel_assignments_f"},
  {"id":"ben_reporting"},
  {"id":"ben_rltd_per_chg_cs_ler"},
  {"id":"ben_roll_reimb_rqst"},
  {"id":"ben_rptg_grp"},
  {"id":"ben_rptg_grp_tl"},
  {"id":"ben_schedd_enrt_rl_f"},
  {"id":"ben_ss_configuration"},
  {"id":"ben_stage_info"},
  {"id":"ben_svc_area"},
  {"id":"ben_svc_area_pstl_zip_rng"},
  {"id":"ben_tab_columns"},
  {"id":"ben_type_values"},
  {"id":"ben_types"},
  {"id":"ben_vald_hrchy_details"},
  {"id":"ben_vald_hrchy_smry"},
  {"id":"ben_vald_rpt_typ"},
  {"id":"ben_vrbl_mtchg_rt_f"},
  {"id":"ben_vrbl_rt_elig_prfl_f"},
  {"id":"ben_vrbl_rt_prfl_f"},
  {"id":"ben_vrbl_rt_prfl_rl_f"},
  {"id":"ben_vrbl_rt_rl_f"},
  {"id":"ben_vstg_age_rqmt"},
  {"id":"ben_vstg_los_rqmt"},
  {"id":"ben_vstg_sched_f"},
  {"id":"ben_work_pattern"},
  {"id":"ben_work_pattern_details"},
  {"id":"ben_wthn_yr_perd"},
  {"id":"ben_wv_prtn_rsn_ctfn_pl_f"},
  {"id":"ben_wv_prtn_rsn_ctfn_ptip_f"},
  {"id":"ben_wv_prtn_rsn_pl_f"},
  {"id":"ben_wv_prtn_rsn_ptip_f"},
  {"id":"ben_yr_perd"},
  {"id":"cmp_address_zones"},
  {"id":"cmp_attr_simple_components"},
  {"id":"cmp_attribute_elements"},
  {"id":"cmp_attribute_pay_rates"},
  {"id":"cmp_attribute_salary_basis"},
  {"id":"cmp_basis_components"},
  {"id":"cmp_basis_pay_rates"},
  {"id":"cmp_basis_simple_components"},
  {"id":"cmp_batch_errors"},
  {"id":"cmp_batch_process_info"},
  {"id":"cmp_budget_audit"},
  {"id":"cmp_budget_pools_b"},
  {"id":"cmp_budget_pools_tl"},
  {"id":"cmp_budget_usages"},
  {"id":"cmp_calc_alerts_b"},
  {"id":"cmp_calc_alerts_tl"},
  {"id":"cmp_calc_definitions"},
  {"id":"cmp_calc_expressions"},
  {"id":"cmp_components_b"},
  {"id":"cmp_components_tl"},
  {"id":"cmp_cstm_region_items_b"},
  {"id":"cmp_cstm_region_items_tl"},
  {"id":"cmp_custom_region_layouts"},
  {"id":"cmp_cwb_alerts"},
  {"id":"cmp_cwb_approval_history"},
  {"id":"cmp_cwb_assignment_segments"},
  {"id":"cmp_cwb_audit"},
  {"id":"cmp_cwb_batch_process_stats"},
  {"id":"cmp_cwb_feedback"},
  {"id":"cmp_cwb_hrchy"},
  {"id":"cmp_cwb_hrchy_cf_dn"},
  {"id":"cmp_cwb_intcpt_appr_dtls"},
  {"id":"cmp_cwb_model_b"},
  {"id":"cmp_cwb_model_batch_details"},
  {"id":"cmp_cwb_model_batch_stats"},
  {"id":"cmp_cwb_model_dtl"},
  {"id":"cmp_cwb_model_events"},
  {"id":"cmp_cwb_model_tl"},
  {"id":"cmp_cwb_perf_ratings"},
  {"id":"cmp_cwb_person_defaults"},
  {"id":"cmp_cwb_person_elements"},
  {"id":"cmp_cwb_person_groups"},
  {"id":"cmp_cwb_person_info"},
  {"id":"cmp_cwb_person_rates"},
  {"id":"cmp_cwb_plan_access"},
  {"id":"cmp_cwb_plan_definitions"},
  {"id":"cmp_cwb_post_log"},
  {"id":"cmp_cwb_post_parm_hdr"},
  {"id":"cmp_cwb_post_parms"},
  {"id":"cmp_cwb_post_person"},
  {"id":"cmp_cwb_post_run"},
  {"id":"cmp_cwb_post_sal_rates"},
  {"id":"cmp_cwb_post_simple_comp"},
  {"id":"cmp_cwb_process_logs"},
  {"id":"cmp_cwb_promotions"},
  {"id":"cmp_cwb_ranks"},
  {"id":"cmp_cwb_salary_rates"},
  {"id":"cmp_cwb_scheduled_statements"},
  {"id":"cmp_cwb_sec_hrchy_cf_dn"},
  {"id":"cmp_cwb_simple_components"},
  {"id":"cmp_cwb_single_per_prc_data"},
  {"id":"cmp_cwb_stored_asg_segments"},
  {"id":"cmp_cwb_stored_person_data"},
  {"id":"cmp_cwb_stored_statements"},
  {"id":"cmp_cwb_summary"},
  {"id":"cmp_cwb_switch_managers"},
  {"id":"cmp_cwb_xchg"},
  {"id":"cmp_dynamic_filter"},
  {"id":"cmp_eligibility"},
  {"id":"cmp_ess_actions"},
  {"id":"cmp_ess_ranges"},
  {"id":"cmp_ess_task_info"},
  {"id":"cmp_ess_tasks"},
  {"id":"cmp_external_worker_data"},
  {"id":"cmp_feedback_b"},
  {"id":"cmp_feedback_tl"},
  {"id":"cmp_gsp_elig_progressions"},
  {"id":"cmp_gsp_eligibility_f"},
  {"id":"cmp_gsp_person_info"},
  {"id":"cmp_gsp_process_log"},
  {"id":"cmp_history"},
  {"id":"cmp_instructions_b"},
  {"id":"cmp_instructions_tl"},
  {"id":"cmp_intercept_approvers"},
  {"id":"cmp_intercept_groups"},
  {"id":"cmp_lookup_usages_b"},
  {"id":"cmp_lookup_usages_tl"},
  {"id":"cmp_mkt_comp_type_config_b"},
  {"id":"cmp_mkt_comp_type_config_tl"},
  {"id":"cmp_mkt_comp_types_b"},
  {"id":"cmp_mkt_comp_types_tl"},
  {"id":"cmp_mkt_composite_config_b"},
  {"id":"cmp_mkt_composite_config_tl"},
  {"id":"cmp_mkt_composites"},
  {"id":"cmp_mkt_report_composites"},
  {"id":"cmp_mkt_segment_location"},
  {"id":"cmp_mkt_segments_b"},
  {"id":"cmp_mkt_segments_tl"},
  {"id":"cmp_mkt_survey_batch_b"},
  {"id":"cmp_mkt_survey_batch_tl"},
  {"id":"cmp_mkt_survey_data_b"},
  {"id":"cmp_mkt_survey_data_copy"},
  {"id":"cmp_mkt_vendors_b"},
  {"id":"cmp_mkt_vendors_tl"},
  {"id":"cmp_mkt_vnd_career_level_b"},
  {"id":"cmp_mkt_vnd_career_level_tl"},
  {"id":"cmp_mkt_vnd_career_stream_b"},
  {"id":"cmp_mkt_vnd_career_stream_tl"},
  {"id":"cmp_mkt_vnd_job_family_b"},
  {"id":"cmp_mkt_vnd_job_family_tl"},
  {"id":"cmp_mkt_vnd_job_function_b"},
  {"id":"cmp_mkt_vnd_job_function_tl"},
  {"id":"cmp_mkt_vnd_jobs_b"},
  {"id":"cmp_mkt_vnd_jobs_tl"},
  {"id":"cmp_mkt_vnd_loc_b"},
  {"id":"cmp_mkt_vnd_loc_map"},
  {"id":"cmp_mkt_vnd_loc_tl"},
  {"id":"cmp_mkt_vnd_other_level_b"},
  {"id":"cmp_mkt_vnd_other_level_tl"},
  {"id":"cmp_mkt_vnd_surveys_b"},
  {"id":"cmp_mkt_vnd_surveys_tl"},
  {"id":"cmp_object_names"},
  {"id":"cmp_pay_rates_b"},
  {"id":"cmp_pay_rates_tl"},
  {"id":"cmp_person_budgets"},
  {"id":"cmp_person_region_items"},
  {"id":"cmp_plan_access"},
  {"id":"cmp_plan_attributes"},
  {"id":"cmp_plan_currencies"},
  {"id":"cmp_plan_mappings"},
  {"id":"cmp_plan_notification_settings"},
  {"id":"cmp_plan_periods"},
  {"id":"cmp_plans_audit"},
  {"id":"cmp_plans_b"},
  {"id":"cmp_plans_tl"},
  {"id":"cmp_process_data"},
  {"id":"cmp_process_run_info"},
  {"id":"cmp_process_temp_logs_gt"},
  {"id":"cmp_profile_values"},
  {"id":"cmp_range_diff_values_f"},
  {"id":"cmp_range_diffs_f"},
  {"id":"cmp_range_diffs_f_tl"},
  {"id":"cmp_salary"},
  {"id":"cmp_salary_"},
  {"id":"cmp_salary_backup"},
  {"id":"cmp_salary_bases"},
  {"id":"cmp_salary_bases_tl"},
  {"id":"cmp_salary_batch_asg_info"},
  {"id":"cmp_salary_batch_change"},
  {"id":"cmp_salary_batch_info"},
  {"id":"cmp_salary_batch_rates"},
  {"id":"cmp_salary_components"},
  {"id":"cmp_salary_components_"},
  {"id":"cmp_salary_compts_backup"},
  {"id":"cmp_salary_export"},
  {"id":"cmp_salary_pay_components"},
  {"id":"cmp_salary_pay_components_"},
  {"id":"cmp_salary_simple_compnts"},
  {"id":"cmp_salary_simple_compnts_"},
  {"id":"cmp_sctn_region_items_b"},
  {"id":"cmp_sctn_region_items_tl"},
  {"id":"cmp_stmt_group_templates_b"},
  {"id":"cmp_stmt_group_templates_tl"},
  {"id":"cmp_stmt_groups_b"},
  {"id":"cmp_stmt_groups_tl"},
  {"id":"cmp_stmt_templates"},
  {"id":"cmp_stock_details"},
  {"id":"cmp_stock_profiles"},
  {"id":"cmp_tcs_all_objects_in_cat"},
  {"id":"cmp_tcs_cat"},
  {"id":"cmp_tcs_cat_item_hrchy"},
  {"id":"cmp_tcs_cat_tl"},
  {"id":"cmp_tcs_col_in_cat"},
  {"id":"cmp_tcs_col_in_cat_tl"},
  {"id":"cmp_tcs_criteria"},
  {"id":"cmp_tcs_criteria_def"},
  {"id":"cmp_tcs_criteria_tag_info"},
  {"id":"cmp_tcs_error_details"},
  {"id":"cmp_tcs_feedback_b"},
  {"id":"cmp_tcs_feedback_tl"},
  {"id":"cmp_tcs_item"},
  {"id":"cmp_tcs_item_calc_list"},
  {"id":"cmp_tcs_item_tag"},
  {"id":"cmp_tcs_item_tag_def"},
  {"id":"cmp_tcs_item_tl"},
  {"id":"cmp_tcs_per_contributions"},
  {"id":"cmp_tcs_per_item_criteria"},
  {"id":"cmp_tcs_per_item_tag_value"},
  {"id":"cmp_tcs_per_item_value"},
  {"id":"cmp_tcs_per_perd"},
  {"id":"cmp_tcs_per_perd_feedbacks"},
  {"id":"cmp_tcs_per_perd_stmt"},
  {"id":"cmp_tcs_per_perd_stmt_cat"},
  {"id":"cmp_tcs_per_perd_stmt_xml"},
  {"id":"cmp_tcs_per_row_values"},
  {"id":"cmp_tcs_report_details"},
  {"id":"cmp_tcs_row_in_cat"},
  {"id":"cmp_tcs_row_in_cat_tl"},
  {"id":"cmp_tcs_scheduled_stmts"},
  {"id":"cmp_tcs_stmt"},
  {"id":"cmp_tcs_stmt_cat"},
  {"id":"cmp_tcs_stmt_cat_tl"},
  {"id":"cmp_tcs_stmt_feedback_b"},
  {"id":"cmp_tcs_stmt_feedback_tl"},
  {"id":"cmp_tcs_stmt_page_def"},
  {"id":"cmp_tcs_stmt_page_def_tl"},
  {"id":"cmp_tcs_stmt_perd"},
  {"id":"cmp_tcs_stmt_perd_tl"},
  {"id":"cmp_tcs_stmt_rating_b"},
  {"id":"cmp_tcs_stmt_rating_tl"},
  {"id":"cmp_tcs_stmt_row_def_tl"},
  {"id":"cmp_tcs_stmt_tbl_row_def"},
  {"id":"cmp_tcs_stmt_tl"},
  {"id":"cmp_tcs_stock_grant_types"},
  {"id":"cmp_tcs_stock_history"},
  {"id":"cmp_tcs_stock_history_tl"},
  {"id":"cmp_tcs_stock_symbol"},
  {"id":"cmp_tcs_templates"},
  {"id":"cmp_transactions"},
  {"id":"cmp_vc_per_elig_plans"},
  {"id":"ff_compile_code"},
  {"id":"ff_compile_messages"},
  {"id":"ff_compiled_info"},
  {"id":"ff_contexts_b"},
  {"id":"ff_contexts_b["},
  {"id":"ff_contexts_b]"},
  {"id":"ff_contexts_tl"},
  {"id":"ff_contexts_tl["},
  {"id":"ff_contexts_tl]"},
  {"id":"ff_data_dictionary"},
  {"id":"ff_database_items_b"},
  {"id":"ff_database_items_b["},
  {"id":"ff_database_items_b]"},
  {"id":"ff_database_items_tl"},
  {"id":"ff_database_items_tl["},
  {"id":"ff_database_items_tl]"},
  {"id":"ff_dbi_groups"},
  {"id":"ff_dbi_groups_tl"},
  {"id":"ff_dbi_groups_tl["},
  {"id":"ff_dbi_groups_tl]"},
  {"id":"ff_dbi_groups["},
  {"id":"ff_dbi_groups]"},
  {"id":"ff_dbi_usages"},
  {"id":"ff_dbi_usages["},
  {"id":"ff_dbi_usages]"},
  {"id":"ff_dd_usages"},
  {"id":"ff_fdi_usages"},
  {"id":"ff_formula_types_b"},
  {"id":"ff_formula_types_b["},
  {"id":"ff_formula_types_tl"},
  {"id":"ff_formula_types_tl["},
  {"id":"ff_formulas_b_f"},
  {"id":"ff_formulas_b_f["},
  {"id":"ff_formulas_b_f]"},
  {"id":"ff_formulas_tl"},
  {"id":"ff_formulas_tl["},
  {"id":"ff_formulas_tl]"},
  {"id":"ff_ftype_context_usages"},
  {"id":"ff_ftype_context_usages["},
  {"id":"ff_ftype_context_usages]"},
  {"id":"ff_func_context_usages"},
  {"id":"ff_func_context_usages["},
  {"id":"ff_func_context_usages]"},
  {"id":"ff_function_parameters"},
  {"id":"ff_function_parameters["},
  {"id":"ff_function_parameters]"},
  {"id":"ff_functions_b"},
  {"id":"ff_functions_b["},
  {"id":"ff_functions_b]"},
  {"id":"ff_functions_tl"},
  {"id":"ff_functions_tl["},
  {"id":"ff_functions_tl]"},
  {"id":"ff_globals_b_f"},
  {"id":"ff_globals_tl"},
  {"id":"ff_route_context_usages"},
  {"id":"ff_route_context_usages["},
  {"id":"ff_route_context_usages]"},
  {"id":"ff_route_parameter_vals"},
  {"id":"ff_route_parameter_vals["},
  {"id":"ff_route_parameter_vals]"},
  {"id":"ff_route_parameters"},
  {"id":"ff_route_parameters["},
  {"id":"ff_route_parameters]"},
  {"id":"ff_route_to_descr_flexs"},
  {"id":"ff_route_to_descr_flexs["},
  {"id":"ff_route_to_descr_flexs]"},
  {"id":"ff_routes_b"},
  {"id":"ff_routes_b["},
  {"id":"ff_routes_b]"},
  {"id":"ff_routes_tl"},
  {"id":"ff_routes_tl["},
  {"id":"ff_routes_tl]"},
  {"id":"ff_rule_lines_f"},
  {"id":"ff_user_column_instances_f"},
  {"id":"ff_user_column_instances_f["},
  {"id":"ff_user_columns"},
  {"id":"ff_user_columns_tl"},
  {"id":"ff_user_entities_b"},
  {"id":"ff_user_entities_b["},
  {"id":"ff_user_entities_b]"},
  {"id":"ff_user_entities_tl"},
  {"id":"ff_user_entities_tl["},
  {"id":"ff_user_entities_tl]"},
  {"id":"ff_user_rows_f"},
  {"id":"ff_user_rows_f["},
  {"id":"ff_user_rows_f]"},
  {"id":"ff_user_rows_tl"},
  {"id":"ff_user_rows_tl["},
  {"id":"ff_user_rows_tl]"},
  {"id":"ff_user_tables"},
  {"id":"ff_user_tables_tl"},
  {"id":"ffs_action_link"},
  {"id":"ffs_action_link_condition"},
  {"id":"ffs_action_link_parameter"},
  {"id":"ffs_action_link]"},
  {"id":"ffs_activity"},
  {"id":"ffs_activity_history"},
  {"id":"ffs_activity_link"},
  {"id":"ffs_activity_link_type"},
  {"id":"ffs_activity_move_log"},
  {"id":"ffs_activity_move_log_inv"},
  {"id":"ffs_activity_move_reason"},
  {"id":"ffs_activity_property"},
  {"id":"ffs_activity_property_lv"},
  {"id":"ffs_activity_req_inventory"},
  {"id":"ffs_activity_res_pref"},
  {"id":"ffs_activity_segment_mode"},
  {"id":"ffs_activity_suggested_act"},
  {"id":"ffs_activity_tmpl"},
  {"id":"ffs_activity_tmpl_log"},
  {"id":"ffs_activity_tmpl_property"},
  {"id":"ffs_activity_tmpl_res"},
  {"id":"ffs_activity_tmpl_res_pref"},
  {"id":"ffs_activity_tmpl_ws"},
  {"id":"ffs_activity_type"},
  {"id":"ffs_activity_work_skill"},
  {"id":"ffs_application"},
  {"id":"ffs_application_permission"},
  {"id":"ffs_application_resource"},
  {"id":"ffs_assignment_log"},
  {"id":"ffs_bundling_rule"},
  {"id":"ffs_bundling_rule_form"},
  {"id":"ffs_bundling_rule_key"},
  {"id":"ffs_business_param"},
  {"id":"ffs_business_rule"},
  {"id":"ffs_catalog"},
  {"id":"ffs_catalog_chunk"},
  {"id":"ffs_catalog_item"},
  {"id":"ffs_catalog_item_type"},
  {"id":"ffs_catalog_item_weight"},
  {"id":"ffs_catalog_schema"},
  {"id":"ffs_catalog_scm"},
  {"id":"ffs_catalog_scm_map"},
  {"id":"ffs_catalog_scm_sync"},
  {"id":"ffs_catalog_user_type"},
  {"id":"ffs_catalog_version"},
  {"id":"ffs_chart"},
  {"id":"ffs_chart_dashboard"},
  {"id":"ffs_chat"},
  {"id":"ffs_chat_bc_status"},
  {"id":"ffs_chat_message"},
  {"id":"ffs_chat_participant"},
  {"id":"ffs_chat_txn_preauth"},
  {"id":"ffs_chatbot"},
  {"id":"ffs_cml_column"},
  {"id":"ffs_cml_column_upload"},
  {"id":"ffs_cml_map_layer"},
  {"id":"ffs_cml_shape"},
  {"id":"ffs_cml_shape_chunk"},
  {"id":"ffs_cml_shape_status"},
  {"id":"ffs_cml_shape_upload"},
  {"id":"ffs_collab_contact_list"},
  {"id":"ffs_collab_grp"},
  {"id":"ffs_collab_grp_member"},
  {"id":"ffs_collab_grp_resource"},
  {"id":"ffs_collab_grp_visibility"},
  {"id":"ffs_company_bounds"},
  {"id":"ffs_config_log"},
  {"id":"ffs_config_log_entity"},
  {"id":"ffs_config_pending_action"},
  {"id":"ffs_context"},
  {"id":"ffs_ctx_action_link_type"},
  {"id":"ffs_cust_module"},
  {"id":"ffs_db_identity"},
  {"id":"ffs_db_object_status"},
  {"id":"ffs_db_optimizer_state"},
  {"id":"ffs_db_partition_grp"},
  {"id":"ffs_db_partition_tab"},
  {"id":"ffs_db_rename24b_col"},
  {"id":"ffs_db_rename24b_col_rm"},
  {"id":"ffs_db_rename24b_dep"},
  {"id":"ffs_db_rename24b_tab"},
  {"id":"ffs_db_sequence_link"},
  {"id":"ffs_db_updater_hist"},
  {"id":"ffs_db_updater_undo"},
  {"id":"ffs_dbm_backup"},
  {"id":"ffs_dbm_cut_plan"},
  {"id":"ffs_dbm_step_run"},
  {"id":"ffs_dbm_task_run"},
  {"id":"ffs_display_profile"},
  {"id":"ffs_display_profile_layout"},
  {"id":"ffs_dwh_export_file"},
  {"id":"ffs_dwh_export_file_field"},
  {"id":"ffs_dwh_export_file_result"},
  {"id":"ffs_dwh_export_hist"},
  {"id":"ffs_dwh_export_hist_file"},
  {"id":"ffs_dwh_log"},
  {"id":"ffs_event_subscription"},
  {"id":"ffs_favorite_group"},
  {"id":"ffs_favorite_group_res"},
  {"id":"ffs_field_set"},
  {"id":"ffs_file_metadata"},
  {"id":"ffs_filter"},
  {"id":"ffs_filter_condition"},
  {"id":"ffs_filter_marker_type"},
  {"id":"ffs_forc"},
  {"id":"ffs_forc_calc_dt"},
  {"id":"ffs_forc_data"},
  {"id":"ffs_forc_override"},
  {"id":"ffs_forc_override_data"},
  {"id":"ffs_forc_regression"},
  {"id":"ffs_forc_series"},
  {"id":"ffs_form"},
  {"id":"ffs_form_content"},
  {"id":"ffs_form_data"},
  {"id":"ffs_form_data_file"},
  {"id":"ffs_form_history"},
  {"id":"ffs_format"},
  {"id":"ffs_geocoding_config"},
  {"id":"ffs_history_item"},
  {"id":"ffs_holiday"},
  {"id":"ffs_http_user_agent"},
  {"id":"ffs_import_queue"},
  {"id":"ffs_import_temporary_data"},
  {"id":"ffs_inventory"},
  {"id":"ffs_inventory_history"},
  {"id":"ffs_inventory_property"},
  {"id":"ffs_inventory_property_lv"},
  {"id":"ffs_inventory_type"},
  {"id":"ffs_knowledge_url_param"},
  {"id":"ffs_language"},
  {"id":"ffs_language]"},
  {"id":"ffs_layout"},
  {"id":"ffs_layout_item"},
  {"id":"ffs_layout_item_evaluation"},
  {"id":"ffs_layout_item_exclude"},
  {"id":"ffs_layout_item_parameter"},
  {"id":"ffs_layout_item_value"},
  {"id":"ffs_layout_item_value_cond"},
  {"id":"ffs_layout_item_visib"},
  {"id":"ffs_layout_item_visib_cond"},
  {"id":"ffs_layout_item]"},
  {"id":"ffs_ldap_connection"},
  {"id":"ffs_location"},
  {"id":"ffs_location_value"},
  {"id":"ffs_login_history"},
  {"id":"ffs_lookup"},
  {"id":"ffs_message_content"},
  {"id":"ffs_message_flow"},
  {"id":"ffs_message_log"},
  {"id":"ffs_message_pattern"},
  {"id":"ffs_message_queue"},
  {"id":"ffs_message_step"},
  {"id":"ffs_message_step_condition"},
  {"id":"ffs_message_step_event"},
  {"id":"ffs_msg_agent"},
  {"id":"ffs_msg_agent_credential"},
  {"id":"ffs_msg_collab_content"},
  {"id":"ffs_msg_collab_recipient"},
  {"id":"ffs_offline_sync"},
  {"id":"ffs_offline_sync_field"},
  {"id":"ffs_offline_sync_param"},
  {"id":"ffs_organization"},
  {"id":"ffs_page_translation"},
  {"id":"ffs_planned_work_time"},
  {"id":"ffs_planned_work_time_log"},
  {"id":"ffs_plugin"},
  {"id":"ffs_plugin_application"},
  {"id":"ffs_plugin_hosted"},
  {"id":"ffs_plugin_hosted_version"},
  {"id":"ffs_plugin_property"},
  {"id":"ffs_plugin]"},
  {"id":"ffs_privilege_object"},
  {"id":"ffs_privilege_object]"},
  {"id":"ffs_property_desc"},
  {"id":"ffs_property_file"},
  {"id":"ffs_property_name"},
  {"id":"ffs_qbi_booking_status"},
  {"id":"ffs_qbi_booking_status_log"},
  {"id":"ffs_qbi_capacity_area"},
  {"id":"ffs_qbi_car_category"},
  {"id":"ffs_qbi_car_interval"},
  {"id":"ffs_qbi_car_organization"},
  {"id":"ffs_qbi_car_tree_node"},
  {"id":"ffs_qbi_car_work_zone"},
  {"id":"ffs_qbi_close_schedule"},
  {"id":"ffs_qbi_close_schedule_log"},
  {"id":"ffs_qbi_fill_schedule"},
  {"id":"ffs_qbi_fill_schedule_log"},
  {"id":"ffs_qbi_quota_ctgr"},
  {"id":"ffs_qbi_quota_ctgr_log"},
  {"id":"ffs_qbi_quota_day"},
  {"id":"ffs_qbi_quota_day_log"},
  {"id":"ffs_qbi_quota_intrvl"},
  {"id":"ffs_qbi_quota_intrvl_log"},
  {"id":"ffs_qbi_quota_page"},
  {"id":"ffs_qbi_used_quota_ctgr"},
  {"id":"ffs_qbi_used_quota_day"},
  {"id":"ffs_qbi_used_quota_intrvl"},
  {"id":"ffs_qts_bucket_profile"},
  {"id":"ffs_qts_category_weight"},
  {"id":"ffs_qts_close_schedule"},
  {"id":"ffs_qts_close_schedule_log"},
  {"id":"ffs_qts_fill_schedule"},
  {"id":"ffs_qts_fill_schedule_log"},
  {"id":"ffs_qts_quota_ctgr"},
  {"id":"ffs_qts_quota_ctgr_log"},
  {"id":"ffs_qts_quota_day"},
  {"id":"ffs_qts_quota_day_log"},
  {"id":"ffs_qts_quota_page"},
  {"id":"ffs_qts_quota_ts"},
  {"id":"ffs_qts_quota_ts_log"},
  {"id":"ffs_qts_quota_wz"},
  {"id":"ffs_qts_quota_wz_log"},
  {"id":"ffs_qts_used_quota_ctgr"},
  {"id":"ffs_qts_used_quota_day"},
  {"id":"ffs_qts_used_quota_ts"},
  {"id":"ffs_quota_field"},
  {"id":"ffs_region"},
  {"id":"ffs_report"},
  {"id":"ffs_report_chart"},
  {"id":"ffs_report_chart_config"},
  {"id":"ffs_report_column"},
  {"id":"ffs_report_group"},
  {"id":"ffs_report_param"},
  {"id":"ffs_report_schedule"},
  {"id":"ffs_report_schedule_log"},
  {"id":"ffs_report_schedule_param"},
  {"id":"ffs_report_settings"},
  {"id":"ffs_report_stats"},
  {"id":"ffs_resource"},
  {"id":"ffs_resource_calendar"},
  {"id":"ffs_resource_hierarchy"},
  {"id":"ffs_resource_location"},
  {"id":"ffs_resource_log"},
  {"id":"ffs_resource_property"},
  {"id":"ffs_resource_time_slot"},
  {"id":"ffs_resource_track"},
  {"id":"ffs_resource_type"},
  {"id":"ffs_resource_util_stats"},
  {"id":"ffs_resource_work_skill"},
  {"id":"ffs_resource_work_zone"},
  {"id":"ffs_route"},
  {"id":"ffs_route_date_version"},
  {"id":"ffs_route_history"},
  {"id":"ffs_route_not_active_hist"},
  {"id":"ffs_rsa_signing_key"},
  {"id":"ffs_sched_configuration"},
  {"id":"ffs_sched_ml_config"},
  {"id":"ffs_sched_ml_value"},
  {"id":"ffs_sched_ml_violation"},
  {"id":"ffs_sched_savings_stats"},
  {"id":"ffs_schedule"},
  {"id":"ffs_schedule_item"},
  {"id":"ffs_scheduling_baseline"},
  {"id":"ffs_scheduling_plan"},
  {"id":"ffs_scheduling_profile"},
  {"id":"ffs_scheduling_run_context"},
  {"id":"ffs_scheduling_stats"},
  {"id":"ffs_sd"},
  {"id":"ffs_sd_accuracy"},
  {"id":"ffs_sd_acty_id"},
  {"id":"ffs_sd_acty_key"},
  {"id":"ffs_sd_acty_key_dict"},
  {"id":"ffs_sd_data"},
  {"id":"ffs_sd_data_buf"},
  {"id":"ffs_sd_data_external"},
  {"id":"ffs_sd_data_external_buf"},
  {"id":"ffs_sd_nl"},
  {"id":"ffs_sd_override"},
  {"id":"ffs_sd_res"},
  {"id":"ffs_sd_res_gt"},
  {"id":"ffs_sd_res_key"},
  {"id":"ffs_sd_res_key_dict"},
  {"id":"ffs_service_request"},
  {"id":"ffs_service_request_hist"},
  {"id":"ffs_service_request_prop"},
  {"id":"ffs_sk_correlation"},
  {"id":"ffs_sk_correlation_data"},
  {"id":"ffs_sp_activity_collab"},
  {"id":"ffs_sp_activity_group"},
  {"id":"ffs_sp_label_replacement"},
  {"id":"ffs_sp_reopt_filter"},
  {"id":"ffs_sp_resource_group"},
  {"id":"ffs_sp_run_log"},
  {"id":"ffs_sp_run_log_details"},
  {"id":"ffs_sp_run_time"},
  {"id":"ffs_sst_default"},
  {"id":"ffs_sst_filter"},
  {"id":"ffs_st_acty_key"},
  {"id":"ffs_st_acty_key_area"},
  {"id":"ffs_st_acty_key_area_gt"},
  {"id":"ffs_st_acty_key_bkt_avg"},
  {"id":"ffs_st_acty_key_bounds"},
  {"id":"ffs_st_acty_key_dict"},
  {"id":"ffs_st_acty_wz_key"},
  {"id":"ffs_st_acty_wz_key_dict"},
  {"id":"ffs_st_area_ext_gt"},
  {"id":"ffs_st_area_gt"},
  {"id":"ffs_st_area_location"},
  {"id":"ffs_st_area_slt_gt"},
  {"id":"ffs_st_avg"},
  {"id":"ffs_st_data"},
  {"id":"ffs_st_data_date"},
  {"id":"ffs_st_data_external"},
  {"id":"ffs_st_data_external_buf"},
  {"id":"ffs_st_formula"},
  {"id":"ffs_st_key_medoids"},
  {"id":"ffs_st_key_neighbors"},
  {"id":"ffs_st_location_gt"},
  {"id":"ffs_st_matrix"},
  {"id":"ffs_st_matrix_data"},
  {"id":"ffs_st_matrix_data_patch"},
  {"id":"ffs_st_override"},
  {"id":"ffs_st_res_key"},
  {"id":"ffs_st_res_key_dict"},
  {"id":"ffs_st_slt_data"},
  {"id":"ffs_st_spt_override"},
  {"id":"ffs_stats"},
  {"id":"ffs_stats_ext_key_gt"},
  {"id":"ffs_stats_granularity"},
  {"id":"ffs_stats_key_gt"},
  {"id":"ffs_survey"},
  {"id":"ffs_survey_answer"},
  {"id":"ffs_survey_comment"},
  {"id":"ffs_survey_question"},
  {"id":"ffs_survey_question_cond"},
  {"id":"ffs_survey_result"},
  {"id":"ffs_survey_run"},
  {"id":"ffs_survey_take"},
  {"id":"ffs_temporary_entity_id"},
  {"id":"ffs_theme"},
  {"id":"ffs_time_slot"},
  {"id":"ffs_time_slot_entity"},
  {"id":"ffs_time_zone"},
  {"id":"ffs_time_zone_diff"},
  {"id":"ffs_togglable_feature"},
  {"id":"ffs_translation"},
  {"id":"ffs_user"},
  {"id":"ffs_user_access_err_log"},
  {"id":"ffs_user_dashboard"},
  {"id":"ffs_user_log"},
  {"id":"ffs_user_preferences"},
  {"id":"ffs_user_property"},
  {"id":"ffs_user_report_chart"},
  {"id":"ffs_user_resource"},
  {"id":"ffs_utype"},
  {"id":"ffs_utype_copy_gt"},
  {"id":"ffs_utype_ctx_action_link"},
  {"id":"ffs_utype_cust_map_layer"},
  {"id":"ffs_utype_filter"},
  {"id":"ffs_utype_hierarchy"},
  {"id":"ffs_utype_permission"},
  {"id":"ffs_visit"},
  {"id":"ffs_watermark"},
  {"id":"ffs_wmt_banner"},
  {"id":"ffs_wmt_theme"},
  {"id":"ffs_work_shift"},
  {"id":"ffs_work_skill"},
  {"id":"ffs_work_skill_asgn"},
  {"id":"ffs_work_skill_asgn_cond"},
  {"id":"ffs_work_skill_asgn_depend"},
  {"id":"ffs_work_skill_group_item"},
  {"id":"ffs_work_zone"},
  {"id":"ffs_work_zone_location"},
  {"id":"ffs_work_zone_shape"},
  {"id":"gl_access_set_assign_int"},
  {"id":"gl_access_set_assignments"},
  {"id":"gl_access_set_ledgers"},
  {"id":"gl_access_set_norm_assign"},
  {"id":"gl_access_set_norm_assign_"},
  {"id":"gl_access_sets"},
  {"id":"gl_access_sets_"},
  {"id":"gl_account_aliases_b"},
  {"id":"gl_account_aliases_tl"},
  {"id":"gl_account_group_default"},
  {"id":"gl_account_group_details"},
  {"id":"gl_account_group_user_assign"},
  {"id":"gl_account_groups"},
  {"id":"gl_accts_map_bsv_gt"},
  {"id":"gl_accts_map_int_gt"},
  {"id":"gl_accts_map_seg1_gt"},
  {"id":"gl_accts_map_seg10_gt"},
  {"id":"gl_accts_map_seg11_gt"},
  {"id":"gl_accts_map_seg12_gt"},
  {"id":"gl_accts_map_seg13_gt"},
  {"id":"gl_accts_map_seg14_gt"},
  {"id":"gl_accts_map_seg15_gt"},
  {"id":"gl_accts_map_seg16_gt"},
  {"id":"gl_accts_map_seg17_gt"},
  {"id":"gl_accts_map_seg18_gt"},
  {"id":"gl_accts_map_seg19_gt"},
  {"id":"gl_accts_map_seg2_gt"},
  {"id":"gl_accts_map_seg20_gt"},
  {"id":"gl_accts_map_seg21_gt"},
  {"id":"gl_accts_map_seg22_gt"},
  {"id":"gl_accts_map_seg23_gt"},
  {"id":"gl_accts_map_seg24_gt"},
  {"id":"gl_accts_map_seg25_gt"},
  {"id":"gl_accts_map_seg26_gt"},
  {"id":"gl_accts_map_seg27_gt"},
  {"id":"gl_accts_map_seg28_gt"},
  {"id":"gl_accts_map_seg29_gt"},
  {"id":"gl_accts_map_seg3_gt"},
  {"id":"gl_accts_map_seg30_gt"},
  {"id":"gl_accts_map_seg4_gt"},
  {"id":"gl_accts_map_seg5_gt"},
  {"id":"gl_accts_map_seg6_gt"},
  {"id":"gl_accts_map_seg7_gt"},
  {"id":"gl_accts_map_seg8_gt"},
  {"id":"gl_accts_map_seg9_gt"},
  {"id":"gl_alloc_rtp"},
  {"id":"gl_alloc_rtp_"},
  {"id":"gl_alloc_rules"},
  {"id":"gl_alloc_rules_"},
  {"id":"gl_alloc_rulesets"},
  {"id":"gl_alloc_rulesets_"},
  {"id":"gl_allocation_details"},
  {"id":"gl_allocation_details_"},
  {"id":"gl_allocation_rules"},
  {"id":"gl_allocation_rules_"},
  {"id":"gl_allocation_run_history"},
  {"id":"gl_allocation_set_details"},
  {"id":"gl_allocation_set_details_"},
  {"id":"gl_allocation_sets"},
  {"id":"gl_allocation_sets_"},
  {"id":"gl_application_groups"},
  {"id":"gl_automatic_posting_options"},
  {"id":"gl_automatic_posting_options_"},
  {"id":"gl_automatic_posting_sets"},
  {"id":"gl_automatic_posting_sets_"},
  {"id":"gl_autorev_criteria_sets"},
  {"id":"gl_autorev_criteria_sets_"},
  {"id":"gl_autoreverse_options"},
  {"id":"gl_autoreverse_options_"},
  {"id":"gl_autorun_error_actions"},
  {"id":"gl_autorun_error_codes"},
  {"id":"gl_autorun_error_codes["},
  {"id":"gl_autorun_ledger_exclusions"},
  {"id":"gl_autorun_ledger_exclusions_"},
  {"id":"gl_autorun_run_errors"},
  {"id":"gl_autorun_run_notify"},
  {"id":"gl_autorun_run_notify_gt"},
  {"id":"gl_autorun_run_notify_users"},
  {"id":"gl_autorun_run_requests"},
  {"id":"gl_autorun_run_results"},
  {"id":"gl_autorun_runs"},
  {"id":"gl_autorun_setup"},
  {"id":"gl_autorun_setup_exclusions"},
  {"id":"gl_autorun_setup_notify"},
  {"id":"gl_autorun_setup_notify_"},
  {"id":"gl_autorun_setup_notify_users"},
  {"id":"gl_autorun_setup_notify_users_"},
  {"id":"gl_autorun_unprocessed_data_gt"},
  {"id":"gl_bal_cube_concurrency"},
  {"id":"gl_balance_currencies"},
  {"id":"gl_balance_init_history"},
  {"id":"gl_balance_transfer_history"},
  {"id":"gl_balances"},
  {"id":"gl_balances_cubes"},
  {"id":"gl_balances_delta"},
  {"id":"gl_balances_delta_interim"},
  {"id":"gl_budget_balances"},
  {"id":"gl_budget_interface"},
  {"id":"gl_bulk_combinations_gt"},
  {"id":"gl_bulk_combinations_int"},
  {"id":"gl_cal_confirmed_years"},
  {"id":"gl_calendars"},
  {"id":"gl_calendars_"},
  {"id":"gl_chart_of_accounts_options"},
  {"id":"gl_chart_of_accounts_options_"},
  {"id":"gl_clearing_acct_recon_gt"},
  {"id":"gl_coa_map_account_rules"},
  {"id":"gl_coa_map_account_rules_"},
  {"id":"gl_coa_map_ms_rollup_rules"},
  {"id":"gl_coa_map_multi_seg_rules"},
  {"id":"gl_coa_map_rollup_rules"},
  {"id":"gl_coa_map_rollup_rules_"},
  {"id":"gl_coa_map_rollup_rules_int"},
  {"id":"gl_coa_map_segment_rules"},
  {"id":"gl_coa_map_segment_rules_"},
  {"id":"gl_coa_map_segment_rules_int"},
  {"id":"gl_coa_mappings"},
  {"id":"gl_coa_mappings_"},
  {"id":"gl_coa_tree_versions_aggr_dtls"},
  {"id":"gl_code_combinations"},
  {"id":"gl_code_combinations_"},
  {"id":"gl_concurrency_control"},
  {"id":"gl_concurrent_schedules"},
  {"id":"gl_cross_rate_rule_dtls"},
  {"id":"gl_cross_rate_rule_dtls_"},
  {"id":"gl_cross_rate_temp"},
  {"id":"gl_cross_validation_rules_int"},
  {"id":"gl_daily_balances"},
  {"id":"gl_daily_conversion_types"},
  {"id":"gl_daily_conversion_types_"},
  {"id":"gl_daily_post_int"},
  {"id":"gl_daily_post_int1"},
  {"id":"gl_daily_post_int2"},
  {"id":"gl_daily_rates"},
  {"id":"gl_daily_rates_"},
  {"id":"gl_daily_rates_gt"},
  {"id":"gl_daily_rates_interface"},
  {"id":"gl_date_period_map"},
  {"id":"gl_doc_sequence_audit"},
  {"id":"gl_drm_hierarchy_interface"},
  {"id":"gl_drm_segvalues_interface"},
  {"id":"gl_enc_carry_forward_accts"},
  {"id":"gl_enc_carry_forward_accts_"},
  {"id":"gl_enc_carry_forward_rules"},
  {"id":"gl_enc_carry_forward_rules_"},
  {"id":"gl_encumbrance_types_b"},
  {"id":"gl_encumbrance_types_b_"},
  {"id":"gl_encumbrance_types_tl"},
  {"id":"gl_ess_filter_segments"},
  {"id":"gl_essbase_bal_rows"},
  {"id":"gl_essbase_balances_delta"},
  {"id":"gl_essbase_balances_tracking"},
  {"id":"gl_essbase_daily_bal_delta"},
  {"id":"gl_essbase_duplicate_parents"},
  {"id":"gl_expanded_acct_ranges_gt"},
  {"id":"gl_fixed_conv_rates"},
  {"id":"gl_frc_reports_b"},
  {"id":"gl_frc_reports_tl"},
  {"id":"gl_frc_user_access_report_tags"},
  {"id":"gl_frc_user_access_reports"},
  {"id":"gl_fun_infolet_configs"},
  {"id":"gl_fuse_fr_favorites"},
  {"id":"gl_hierview_ledger_info"},
  {"id":"gl_historical_rates"},
  {"id":"gl_historical_rates_"},
  {"id":"gl_historical_rates_int"},
  {"id":"gl_import_references"},
  {"id":"gl_interface"},
  {"id":"gl_interface_control"},
  {"id":"gl_interface_gt"},
  {"id":"gl_interface_history"},
  {"id":"gl_interface_summary_gt"},
  {"id":"gl_je_accrual_reversal_gt"},
  {"id":"gl_je_action_log"},
  {"id":"gl_je_batches"},
  {"id":"gl_je_batches_"},
  {"id":"gl_je_batches_gt"},
  {"id":"gl_je_bsv_replication_rules"},
  {"id":"gl_je_bsv_replication_rules_"},
  {"id":"gl_je_categories_b"},
  {"id":"gl_je_categories_b_"},
  {"id":"gl_je_categories_b["},
  {"id":"gl_je_categories_tl"},
  {"id":"gl_je_categories_tl["},
  {"id":"gl_je_error_codes"},
  {"id":"gl_je_headers"},
  {"id":"gl_je_headers_"},
  {"id":"gl_je_headers_gt"},
  {"id":"gl_je_inclusion_rules"},
  {"id":"gl_je_inclusion_rules_"},
  {"id":"gl_je_lines"},
  {"id":"gl_je_lines_"},
  {"id":"gl_je_lines_recon"},
  {"id":"gl_je_posting_batches_gt"},
  {"id":"gl_je_segment_values"},
  {"id":"gl_je_sources_b"},
  {"id":"gl_je_sources_b_"},
  {"id":"gl_je_sources_tl"},
  {"id":"gl_ji_error_codes"},
  {"id":"gl_le_value_sets"},
  {"id":"gl_ledger_bsv_gt"},
  {"id":"gl_ledger_config_details"},
  {"id":"gl_ledger_config_details_"},
  {"id":"gl_ledger_configurations"},
  {"id":"gl_ledger_configurations_"},
  {"id":"gl_ledger_le_bsv_gt"},
  {"id":"gl_ledger_norm_seg_vals"},
  {"id":"gl_ledger_norm_seg_vals_"},
  {"id":"gl_ledger_relationships"},
  {"id":"gl_ledger_relationships_"},
  {"id":"gl_ledger_segment_values"},
  {"id":"gl_ledger_set_assignments"},
  {"id":"gl_ledger_set_norm_assign"},
  {"id":"gl_ledger_set_norm_assign_"},
  {"id":"gl_ledger_set_requests"},
  {"id":"gl_ledgers"},
  {"id":"gl_ledgers_"},
  {"id":"gl_legal_entities_bsvs"},
  {"id":"gl_mc_curr_conv_gt"},
  {"id":"gl_mc_options_gt"},
  {"id":"gl_merged_child_ranges_gt"},
  {"id":"gl_multi_bal_seg_gt"},
  {"id":"gl_net_income_accounts"},
  {"id":"gl_pacs_combinations"},
  {"id":"gl_pacs_combinations_"},
  {"id":"gl_pacs_combinations_int"},
  {"id":"gl_pacs_definitions"},
  {"id":"gl_pacs_definitions_"},
  {"id":"gl_period_partitions"},
  {"id":"gl_period_sets"},
  {"id":"gl_period_statuses"},
  {"id":"gl_period_statuses_"},
  {"id":"gl_period_types"},
  {"id":"gl_periods"},
  {"id":"gl_periods_"},
  {"id":"gl_posting_acct_seq_gt"},
  {"id":"gl_posting_interim"},
  {"id":"gl_posting_sl_headers_gt"},
  {"id":"gl_purge_data_to_purge"},
  {"id":"gl_purge_setup"},
  {"id":"gl_purge_setup_"},
  {"id":"gl_purge_setup_details"},
  {"id":"gl_purge_setup_details_"},
  {"id":"gl_purge_tracking"},
  {"id":"gl_purge_tracking_details"},
  {"id":"gl_purge_tracking_errors"},
  {"id":"gl_purge_tracking_history"},
  {"id":"gl_purge_validation_gt"},
  {"id":"gl_reconciliation_rules"},
  {"id":"gl_reconciliation_rules_"},
  {"id":"gl_replication_journals"},
  {"id":"gl_request_information"},
  {"id":"gl_reval_account_ranges"},
  {"id":"gl_reval_account_ranges_"},
  {"id":"gl_reval_chd_ranges_gt"},
  {"id":"gl_reval_currencies_gt"},
  {"id":"gl_reval_exp_ranges_gt"},
  {"id":"gl_reval_fx_position_accounts"},
  {"id":"gl_reval_gainlo_accts_gt"},
  {"id":"gl_revaluations"},
  {"id":"gl_revaluations_"},
  {"id":"gl_row_multipliers"},
  {"id":"gl_seg_val_hier_cf"},
  {"id":"gl_seg_val_hier_rf"},
  {"id":"gl_seg_val_hierarchies"},
  {"id":"gl_segment_frequencies"},
  {"id":"gl_segment_hier_interface"},
  {"id":"gl_segment_values_interface"},
  {"id":"gl_segval_inherit_gt"},
  {"id":"gl_segval_inherit_history"},
  {"id":"gl_stat_account_uom"},
  {"id":"gl_stat_account_uom_"},
  {"id":"gl_storage_parameters"},
  {"id":"gl_suspense_accounts"},
  {"id":"gl_suspense_accounts_"},
  {"id":"gl_svsbf_usages"},
  {"id":"gl_svsbf_usages_"},
  {"id":"gl_system_usages"},
  {"id":"gl_tfr_fx_position_accounts"},
  {"id":"gl_track_delta_balances"},
  {"id":"gl_transaction_calendar"},
  {"id":"gl_transaction_calendar_"},
  {"id":"gl_transaction_dates"},
  {"id":"gl_transaction_dates_"},
  {"id":"gl_translation_bsv_gt"},
  {"id":"gl_translation_interim"},
  {"id":"gl_translation_statuses"},
  {"id":"gl_translation_tracking"},
  {"id":"gl_ussgl_account_pairs"},
  {"id":"gl_ussgl_transaction_codes"},
  {"id":"gl_xcc_journals_gt"},
  {"id":"gl_xfr_history"},
  {"id":"gl_xfr_history_files"},
  {"id":"gl_xfr_interface"},
  {"id":"gl_xfr_ledger_bsv_maps"},
  {"id":"gl_xfr_psft_interface"},
  {"id":"gl_xfr_psft_raw_int"},
  {"id":"gl_xfr_psft_status_gt"},
  {"id":"gl_xfr_source_systems"},
  {"id":"gl_xfr_system_ledgers"},
  {"id":"gl_xfr_tracking"},
  {"id":"gl_xlate_posting_interim"},
  {"id":"gl_xlate_rates_gt"},
  {"id":"gl_year_end_bal_gt"},
  {"id":"gl_year_end_inc_stmt_gt"},
  {"id":"hr_all_organization_units_f"},
  {"id":"hr_all_organization_units_f_"},
  {"id":"hr_all_positions_f"},
  {"id":"hr_all_positions_f_"},
  {"id":"hr_all_positions_f_tl"},
  {"id":"hr_all_positions_f_tl_"},
  {"id":"hr_api_hook_calls"},
  {"id":"hr_api_hooks"},
  {"id":"hr_api_modules"},
  {"id":"hr_api_user_hook_reports"},
  {"id":"hr_document_delivery_prefs"},
  {"id":"hr_document_delivery_prefs_"},
  {"id":"hr_document_types_b"},
  {"id":"hr_document_types_tl"},
  {"id":"hr_documents_of_record"},
  {"id":"hr_documents_of_record_"},
  {"id":"hr_documents_of_record_archive"},
  {"id":"hr_dor_mass_request_lines"},
  {"id":"hr_dor_mass_request_params"},
  {"id":"hr_dor_mass_requests"},
  {"id":"hr_gen_ai_agent_tool_mappings"},
  {"id":"hr_gen_ai_agent_tool_mappings["},
  {"id":"hr_gen_ai_agent_tool_mappings]"},
  {"id":"hr_gen_ai_agent_tools"},
  {"id":"hr_gen_ai_agents"},
  {"id":"hr_gen_ai_agents_b"},
  {"id":"hr_gen_ai_agents_b_"},
  {"id":"hr_gen_ai_agents_b["},
  {"id":"hr_gen_ai_agents_b]"},
  {"id":"hr_gen_ai_agents_tl"},
  {"id":"hr_gen_ai_agents_tl_"},
  {"id":"hr_gen_ai_agents_tl["},
  {"id":"hr_gen_ai_agents_tl]"},
  {"id":"hr_gen_ai_documents"},
  {"id":"hr_gen_ai_documents_b"},
  {"id":"hr_gen_ai_documents_tl"},
  {"id":"hr_gen_ai_prompts_seed_b"},
  {"id":"hr_gen_ai_prompts_seed_b["},
  {"id":"hr_gen_ai_prompts_seed_b]"},
  {"id":"hr_gen_ai_prompts_seed_tl"},
  {"id":"hr_gen_ai_prompts_seed_tl["},
  {"id":"hr_gen_ai_prompts_seed_tl]"},
  {"id":"hr_gen_ai_tools"},
  {"id":"hr_gen_ai_tools_b"},
  {"id":"hr_gen_ai_tools_b_"},
  {"id":"hr_gen_ai_tools_b["},
  {"id":"hr_gen_ai_tools_b]"},
  {"id":"hr_gen_ai_tools_tl"},
  {"id":"hr_gen_ai_tools_tl_"},
  {"id":"hr_gen_ai_tools_tl["},
  {"id":"hr_gen_ai_tools_tl]"},
  {"id":"hr_generative_ai_prompts"},
  {"id":"hr_name_formats"},
  {"id":"hr_org_classifications"},
  {"id":"hr_org_classifications_tl"},
  {"id":"hr_org_info_types_by_class"},
  {"id":"hr_org_info_types_by_class["},
  {"id":"hr_org_information_types"},
  {"id":"hr_org_information_types_tl"},
  {"id":"hr_org_information_types_tl["},
  {"id":"hr_org_information_types["},
  {"id":"hr_org_unit_classifications_f"},
  {"id":"hr_org_unit_classifications_f_"},
  {"id":"hr_organization_informatio_efc"},
  {"id":"hr_organization_information_f"},
  {"id":"hr_organization_information_f_"},
  {"id":"hr_organization_units_f_tl"},
  {"id":"hr_organization_units_f_tl_"},
  {"id":"hr_search_view_attributes"},
  {"id":"hr_search_view_attributes["},
  {"id":"hr_search_view_attributes]"},
  {"id":"hr_search_views"},
  {"id":"hr_search_views["},
  {"id":"hr_search_views]"},
  {"id":"hr_vbcs_adv_saved_search"},
  {"id":"hr_vbcs_lists"},
  {"id":"hra_anlyt_box_defns"},
  {"id":"hra_anlyt_box_lbls_b"},
  {"id":"hra_anlyt_box_lbls_tl"},
  {"id":"hra_auto_xfer_evaluations"},
  {"id":"hra_auto_xfer_mgr_changes"},
  {"id":"hra_check_in_meetings"},
  {"id":"hra_check_in_meetings_"},
  {"id":"hra_check_in_tmpl_rv_prds"},
  {"id":"hra_check_in_tmpls_b"},
  {"id":"hra_check_in_tmpls_tl"},
  {"id":"hra_data_integ_checks"},
  {"id":"hra_discussion_topics"},
  {"id":"hra_discussion_topics_"},
  {"id":"hra_doc_types_b"},
  {"id":"hra_doc_types_tl"},
  {"id":"hra_eval_items"},
  {"id":"hra_eval_items_"},
  {"id":"hra_eval_messages"},
  {"id":"hra_eval_participants"},
  {"id":"hra_eval_participants_"},
  {"id":"hra_eval_ratings"},
  {"id":"hra_eval_ratings_"},
  {"id":"hra_eval_role_actions"},
  {"id":"hra_eval_roles"},
  {"id":"hra_eval_sections"},
  {"id":"hra_eval_sections_"},
  {"id":"hra_eval_steps"},
  {"id":"hra_eval_steps_"},
  {"id":"hra_evaluations"},
  {"id":"hra_evaluations_"},
  {"id":"hra_feedback_req_tmpls_b"},
  {"id":"hra_feedback_req_tmpls_tl"},
  {"id":"hra_feedback_request"},
  {"id":"hra_feedback_request_objects"},
  {"id":"hra_feedback_response"},
  {"id":"hra_global_transfer_requests"},
  {"id":"hra_mass_evaluations"},
  {"id":"hra_pf_defns_b"},
  {"id":"hra_pf_defns_tl"},
  {"id":"hra_pf_task_defns_b"},
  {"id":"hra_pf_task_defns_tl"},
  {"id":"hra_pf_task_roles_b"},
  {"id":"hra_pf_task_roles_tl"},
  {"id":"hra_process_step_alerts"},
  {"id":"hra_role_defns_b"},
  {"id":"hra_role_defns_tl"},
  {"id":"hra_section_defns_b"},
  {"id":"hra_section_defns_tl"},
  {"id":"hra_section_items_b"},
  {"id":"hra_section_items_tl"},
  {"id":"hra_tmpl_defns_b"},
  {"id":"hra_tmpl_defns_tl"},
  {"id":"hra_tmpl_perd_due_dates"},
  {"id":"hra_tmpl_period_doc_types"},
  {"id":"hra_tmpl_period_qstnr"},
  {"id":"hra_tmpl_periods_b"},
  {"id":"hra_tmpl_periods_tl"},
  {"id":"hra_tmpl_role_actions"},
  {"id":"hra_tmpl_roles"},
  {"id":"hra_tmpl_sec_items"},
  {"id":"hra_tmpl_sections"},
  {"id":"hrc_alert_keeps"},
  {"id":"hrc_alert_recipients"},
  {"id":"hrc_alert_recipients["},
  {"id":"hrc_alert_recipients]"},
  {"id":"hrc_alert_run_chunks"},
  {"id":"hrc_alert_run_errors"},
  {"id":"hrc_alert_run_filters_data"},
  {"id":"hrc_alert_run_log_lines"},
  {"id":"hrc_alert_run_messages"},
  {"id":"hrc_alert_run_messages_data"},
  {"id":"hrc_alert_run_msg_attachments"},
  {"id":"hrc_alert_run_ranges"},
  {"id":"hrc_alert_run_recipients"},
  {"id":"hrc_alert_run_recipients_data"},
  {"id":"hrc_alert_runs"},
  {"id":"hrc_alert_templates_b"},
  {"id":"hrc_alert_templates_b["},
  {"id":"hrc_alert_templates_b]"},
  {"id":"hrc_alert_templates_tl"},
  {"id":"hrc_alert_templates_tl["},
  {"id":"hrc_alert_templates_tl]"},
  {"id":"hrc_alert_tokens_b"},
  {"id":"hrc_alert_tokens_b["},
  {"id":"hrc_alert_tokens_b]"},
  {"id":"hrc_alert_tokens_tl"},
  {"id":"hrc_alert_tokens_tl["},
  {"id":"hrc_alert_tokens_tl]"},
  {"id":"hrc_alerts_b"},
  {"id":"hrc_alerts_b["},
  {"id":"hrc_alerts_b]"},
  {"id":"hrc_alerts_tl"},
  {"id":"hrc_alerts_tl["},
  {"id":"hrc_alerts_tl]"},
  {"id":"hrc_arm_approval_options"},
  {"id":"hrc_arm_approval_options["},
  {"id":"hrc_arm_approval_options]"},
  {"id":"hrc_arm_composites_b"},
  {"id":"hrc_arm_composites_b["},
  {"id":"hrc_arm_composites_b]"},
  {"id":"hrc_arm_composites_tl"},
  {"id":"hrc_arm_composites_tl["},
  {"id":"hrc_arm_composites_tl]"},
  {"id":"hrc_arm_notifications_b"},
  {"id":"hrc_arm_notifications_tl"},
  {"id":"hrc_arm_process_b"},
  {"id":"hrc_arm_process_b["},
  {"id":"hrc_arm_process_b]"},
  {"id":"hrc_arm_process_tl"},
  {"id":"hrc_arm_process_tl["},
  {"id":"hrc_arm_process_tl]"},
  {"id":"hrc_atompub_collections"},
  {"id":"hrc_atompub_collections["},
  {"id":"hrc_atompub_entries"},
  {"id":"hrc_atompub_evt_attrs"},
  {"id":"hrc_atompub_evt_attrs["},
  {"id":"hrc_atompub_evt_usages"},
  {"id":"hrc_atompub_evt_usages["},
  {"id":"hrc_atompub_memberships"},
  {"id":"hrc_atompub_workspaces"},
  {"id":"hrc_communication_acc_map"},
  {"id":"hrc_communication_accounts"},
  {"id":"hrc_communication_config"},
  {"id":"hrc_communication_messages"},
  {"id":"hrc_comp_def_types_b"},
  {"id":"hrc_comp_def_types_tl"},
  {"id":"hrc_comp_def_vals_b"},
  {"id":"hrc_comp_def_vals_tl"},
  {"id":"hrc_comp_inst_vals_b"},
  {"id":"hrc_comp_inst_vals_tl"},
  {"id":"hrc_comp_items_b"},
  {"id":"hrc_comp_items_tl"},
  {"id":"hrc_comp_obj_instances"},
  {"id":"hrc_comp_templates_b"},
  {"id":"hrc_comp_templates_tl"},
  {"id":"hrc_console_fault_details_b"},
  {"id":"hrc_console_fault_details_b["},
  {"id":"hrc_console_fault_details_b]"},
  {"id":"hrc_console_fault_details_tl"},
  {"id":"hrc_console_fault_details_tl["},
  {"id":"hrc_console_fault_details_tl]"},
  {"id":"hrc_console_issue_assignment"},
  {"id":"hrc_console_issue_comments"},
  {"id":"hrc_custom_objects"},
  {"id":"hrc_de_history_gt"},
  {"id":"hrc_dl_all_parameters"},
  {"id":"hrc_dl_all_parameters["},
  {"id":"hrc_dl_arc_file_lines"},
  {"id":"hrc_dl_arc_file_rows"},
  {"id":"hrc_dl_arc_file_uk_rows"},
  {"id":"hrc_dl_arc_logical_lines"},
  {"id":"hrc_dl_arc_physical_lines"},
  {"id":"hrc_dl_audit_headers"},
  {"id":"hrc_dl_audit_lines"},
  {"id":"hrc_dl_bo_post_proc_params_b"},
  {"id":"hrc_dl_bo_post_proc_params_b["},
  {"id":"hrc_dl_bo_post_proc_params_b]"},
  {"id":"hrc_dl_bo_post_proc_params_tl"},
  {"id":"hrc_dl_bo_post_proc_params_tl["},
  {"id":"hrc_dl_bo_post_proc_params_tl]"},
  {"id":"hrc_dl_bo_post_processes_b"},
  {"id":"hrc_dl_bo_post_processes_b["},
  {"id":"hrc_dl_bo_post_processes_b]"},
  {"id":"hrc_dl_bo_post_processes_tl"},
  {"id":"hrc_dl_bo_post_processes_tl["},
  {"id":"hrc_dl_bo_post_processes_tl]"},
  {"id":"hrc_dl_bo_postproc_overrides"},
  {"id":"hrc_dl_bo_pp_param_overrides"},
  {"id":"hrc_dl_bo_role_map"},
  {"id":"hrc_dl_bo_role_map_"},
  {"id":"hrc_dl_bus_comm_attrs_b"},
  {"id":"hrc_dl_bus_comm_attrs_b["},
  {"id":"hrc_dl_bus_comm_attrs_tl"},
  {"id":"hrc_dl_bus_comm_attrs_tl["},
  {"id":"hrc_dl_bus_flex_attributes"},
  {"id":"hrc_dl_bus_flex_contexts"},
  {"id":"hrc_dl_bus_func_security"},
  {"id":"hrc_dl_bus_func_security["},
  {"id":"hrc_dl_bus_func_security]"},
  {"id":"hrc_dl_bus_obj_inclusions"},
  {"id":"hrc_dl_bus_obj_inclusions["},
  {"id":"hrc_dl_bus_obj_inclusions]"},
  {"id":"hrc_dl_bus_obj_use_exclns"},
  {"id":"hrc_dl_bus_object_attrs_b"},
  {"id":"hrc_dl_bus_object_attrs_b["},
  {"id":"hrc_dl_bus_object_attrs_b]"},
  {"id":"hrc_dl_bus_object_attrs_tl"},
  {"id":"hrc_dl_bus_object_attrs_tl["},
  {"id":"hrc_dl_bus_object_attrs_tl]"},
  {"id":"hrc_dl_business_objects"},
  {"id":"hrc_dl_business_objects["},
  {"id":"hrc_dl_business_objects]"},
  {"id":"hrc_dl_candidate_err_objs"},
  {"id":"hrc_dl_candidate_imports"},
  {"id":"hrc_dl_chunks"},
  {"id":"hrc_dl_creation_key_map"},
  {"id":"hrc_dl_data_set_bus_objs"},
  {"id":"hrc_dl_data_sets"},
  {"id":"hrc_dl_dataset_details"},
  {"id":"hrc_dl_dataset_summary"},
  {"id":"hrc_dl_ds_post_processes"},
  {"id":"hrc_dl_ds_post_processes["},
  {"id":"hrc_dl_ds_postproc_overrides"},
  {"id":"hrc_dl_dyn_bus_inclusions"},
  {"id":"hrc_dl_dyn_bus_inclusions["},
  {"id":"hrc_dl_dyn_bus_inclusions]"},
  {"id":"hrc_dl_dyn_vo_tables"},
  {"id":"hrc_dl_file_blobs"},
  {"id":"hrc_dl_file_clobs"},
  {"id":"hrc_dl_file_headers"},
  {"id":"hrc_dl_file_keys_info"},
  {"id":"hrc_dl_file_lines"},
  {"id":"hrc_dl_file_lines_clob"},
  {"id":"hrc_dl_file_parameters"},
  {"id":"hrc_dl_file_rows"},
  {"id":"hrc_dl_file_uk_rows"},
  {"id":"hrc_dl_import_chunks"},
  {"id":"hrc_dl_integration_uk_data"},
  {"id":"hrc_dl_layout_attributes_b"},
  {"id":"hrc_dl_layout_attributes_b["},
  {"id":"hrc_dl_layout_attributes_b]"},
  {"id":"hrc_dl_layout_attributes_tl"},
  {"id":"hrc_dl_layout_attributes_tl["},
  {"id":"hrc_dl_layout_attributes_tl]"},
  {"id":"hrc_dl_layout_bus_objs"},
  {"id":"hrc_dl_layout_bus_objs["},
  {"id":"hrc_dl_layout_bus_objs]"},
  {"id":"hrc_dl_layout_dyn_vc_rows"},
  {"id":"hrc_dl_layout_instrs_b"},
  {"id":"hrc_dl_layout_instrs_b["},
  {"id":"hrc_dl_layout_instrs_b]"},
  {"id":"hrc_dl_layout_instrs_tl"},
  {"id":"hrc_dl_layout_instrs_tl["},
  {"id":"hrc_dl_layout_instrs_tl]"},
  {"id":"hrc_dl_layout_params"},
  {"id":"hrc_dl_layout_params["},
  {"id":"hrc_dl_layout_params]"},
  {"id":"hrc_dl_layouts_b"},
  {"id":"hrc_dl_layouts_b["},
  {"id":"hrc_dl_layouts_b]"},
  {"id":"hrc_dl_layouts_tl"},
  {"id":"hrc_dl_layouts_tl["},
  {"id":"hrc_dl_layouts_tl]"},
  {"id":"hrc_dl_logical_lines"},
  {"id":"hrc_dl_message_lines"},
  {"id":"hrc_dl_obj_hier_components"},
  {"id":"hrc_dl_object_hierarchies"},
  {"id":"hrc_dl_os_bulk_import"},
  {"id":"hrc_dl_param_summary"},
  {"id":"hrc_dl_parameter_overrides"},
  {"id":"hrc_dl_parameter_overrides_"},
  {"id":"hrc_dl_parameters"},
  {"id":"hrc_dl_parent_keys_gt"},
  {"id":"hrc_dl_physical_lines"},
  {"id":"hrc_dl_physical_lines_src"},
  {"id":"hrc_dl_post_process_lines"},
  {"id":"hrc_dl_process_params"},
  {"id":"hrc_dl_process_summary"},
  {"id":"hrc_dl_processes"},
  {"id":"hrc_dl_rem_attributes"},
  {"id":"hrc_dl_rem_disposed_count"},
  {"id":"hrc_dl_rem_entities"},
  {"id":"hrc_dl_rem_entity_references"},
  {"id":"hrc_dl_rem_mandatory_refs"},
  {"id":"hrc_dl_rem_process_count"},
  {"id":"hrc_dl_rem_process_params"},
  {"id":"hrc_dl_rem_processes"},
  {"id":"hrc_dl_rem_ref_key_map"},
  {"id":"hrc_dl_rem_templates_b"},
  {"id":"hrc_dl_rem_templates_tl"},
  {"id":"hrc_dl_rem_tmpl_attributes"},
  {"id":"hrc_dl_rem_tmpl_entities"},
  {"id":"hrc_dl_rem_tmpl_flex_attrs"},
  {"id":"hrc_dl_rem_tmpl_flex_ctxs"},
  {"id":"hrc_dl_rem_tmpl_top_entities"},
  {"id":"hrc_dl_rem_top_entities"},
  {"id":"hrc_dl_rem_top_entities["},
  {"id":"hrc_dl_rem_top_entities]"},
  {"id":"hrc_dl_rollback_info"},
  {"id":"hrc_dl_rollback_lines"},
  {"id":"hrc_dl_rollback_log_lines"},
  {"id":"hrc_dl_rollback_phy_lines"},
  {"id":"hrc_dl_scheduled_processes"},
  {"id":"hrc_dl_service_requests"},
  {"id":"hrc_dl_so_child_level_one"},
  {"id":"hrc_dl_so_child_level_two"},
  {"id":"hrc_dl_so_parent_m"},
  {"id":"hrc_dl_so_parent_tl"},
  {"id":"hrc_dl_source_key_audit"},
  {"id":"hrc_dl_source_keys"},
  {"id":"hrc_dl_stg_file_rows"},
  {"id":"hrc_dl_stg_logical_lines"},
  {"id":"hrc_dl_stg_physical_lines"},
  {"id":"hrc_dl_templates"},
  {"id":"hrc_dl_transfer_chunks"},
  {"id":"hrc_dl_ui_bus_objects_b"},
  {"id":"hrc_dl_ui_bus_objects_b["},
  {"id":"hrc_dl_ui_bus_objects_b]"},
  {"id":"hrc_dl_ui_bus_objects_tl"},
  {"id":"hrc_dl_ui_bus_objects_tl["},
  {"id":"hrc_dl_ui_bus_objects_tl]"},
  {"id":"hrc_dl_ui_logical_lines"},
  {"id":"hrc_dl_vo_attr_maps"},
  {"id":"hrc_dl_vo_flex_maps"},
  {"id":"hrc_dl_vo_maps"},
  {"id":"hrc_dl_vo_tables"},
  {"id":"hrc_dl_vo_user_key_attrs"},
  {"id":"hrc_dl_vo_user_key_sql"},
  {"id":"hrc_evt_attribute_archive_req["},
  {"id":"hrc_evt_attribute_archive_req]"},
  {"id":"hrc_evt_attribute_archive_reqs"},
  {"id":"hrc_evt_attribute_mappings"},
  {"id":"hrc_evt_conditions"},
  {"id":"hrc_evt_conditions["},
  {"id":"hrc_evt_conditions]"},
  {"id":"hrc_evt_construction_methods"},
  {"id":"hrc_evt_context_derivations"},
  {"id":"hrc_evt_context_rules"},
  {"id":"hrc_evt_definitions"},
  {"id":"hrc_evt_handlers"},
  {"id":"hrc_evt_handlers["},
  {"id":"hrc_evt_handlers]"},
  {"id":"hrc_evt_obj_change_components"},
  {"id":"hrc_evt_obj_changes"},
  {"id":"hrc_evt_obj_chg_attributes"},
  {"id":"hrc_evt_obj_cond_usages"},
  {"id":"hrc_evt_obj_cond_usages["},
  {"id":"hrc_evt_obj_cond_usages]"},
  {"id":"hrc_evt_obj_conditions_b"},
  {"id":"hrc_evt_obj_conditions_b["},
  {"id":"hrc_evt_obj_conditions_b]"},
  {"id":"hrc_evt_obj_conditions_tl"},
  {"id":"hrc_evt_obj_conditions_tl["},
  {"id":"hrc_evt_obj_conditions_tl]"},
  {"id":"hrc_evt_obj_handler_usages"},
  {"id":"hrc_evt_payload_items"},
  {"id":"hrc_evt_source_objects"},
  {"id":"hrc_evt_source_objects["},
  {"id":"hrc_evt_source_objects]"},
  {"id":"hrc_evt_src_obj_attributes"},
  {"id":"hrc_evt_src_obj_attributes["},
  {"id":"hrc_evt_src_obj_attributes]"},
  {"id":"hrc_evt_subscription_lines"},
  {"id":"hrc_evt_subscription_sets"},
  {"id":"hrc_evt_types"},
  {"id":"hrc_evt_types["},
  {"id":"hrc_evt_types]"},
  {"id":"hrc_integration_key_map"},
  {"id":"hrc_integration_objects"},
  {"id":"hrc_integration_objects["},
  {"id":"hrc_integration_objects]"},
  {"id":"hrc_loader_batch_header"},
  {"id":"hrc_loader_batch_key_map"},
  {"id":"hrc_loader_batch_lines"},
  {"id":"hrc_loader_batch_lines_src"},
  {"id":"hrc_loader_error_lines"},
  {"id":"hrc_loader_job"},
  {"id":"hrc_loader_logical_objects"},
  {"id":"hrc_loader_metadata_registry"},
  {"id":"hrc_loader_parameters"},
  {"id":"hrc_loader_stats"},
  {"id":"hrc_message_actions_b"},
  {"id":"hrc_message_actions_tl"},
  {"id":"hrc_message_attachments"},
  {"id":"hrc_message_categories_b"},
  {"id":"hrc_message_categories_tl"},
  {"id":"hrc_message_config_b"},
  {"id":"hrc_message_config_tl"},
  {"id":"hrc_message_delivery"},
  {"id":"hrc_message_history"},
  {"id":"hrc_sdl_attr_map_defaults"},
  {"id":"hrc_sdl_attr_maps"},
  {"id":"hrc_sdl_bo_role_map"},
  {"id":"hrc_sdl_interface_header"},
  {"id":"hrc_sdl_interface_lines"},
  {"id":"hrc_sdl_layout_role_map"},
  {"id":"hrc_sdl_layout_role_map_"},
  {"id":"hrc_sdl_maps"},
  {"id":"hrc_sdl_message_logs"},
  {"id":"hrc_sem_achievements"},
  {"id":"hrc_sem_activity"},
  {"id":"hrc_sem_assessments"},
  {"id":"hrc_sem_attachments"},
  {"id":"hrc_sem_configurations"},
  {"id":"hrc_sem_contact_info"},
  {"id":"hrc_sem_dictionaries"},
  {"id":"hrc_sem_dictionary_flds"},
  {"id":"hrc_sem_dictionary_items"},
  {"id":"hrc_sem_educations"},
  {"id":"hrc_sem_extraction_files"},
  {"id":"hrc_sem_index_files"},
  {"id":"hrc_sem_indexing_events"},
  {"id":"hrc_sem_int_job_locs"},
  {"id":"hrc_sem_int_job_work_locs"},
  {"id":"hrc_sem_int_jobs_i18n"},
  {"id":"hrc_sem_internal_jobs"},
  {"id":"hrc_sem_job_locs"},
  {"id":"hrc_sem_job_work_locs"},
  {"id":"hrc_sem_jobs"},
  {"id":"hrc_sem_jobs_i18n"},
  {"id":"hrc_sem_locations"},
  {"id":"hrc_sem_locations_mv"},
  {"id":"hrc_sem_persons"},
  {"id":"hrc_sem_persons_mv"},
  {"id":"hrc_sem_skills"},
  {"id":"hrc_sem_work_experiences"},
  {"id":"hrc_sftp_configurations"},
  {"id":"hrc_subscription_queue"},
  {"id":"hrc_subscription_run_info"},
  {"id":"hrc_subscription_runs"},
  {"id":"hrc_txn_attachment"},
  {"id":"hrc_txn_bpel_ntf"},
  {"id":"hrc_txn_bpel_ntf_archive"},
  {"id":"hrc_txn_child_objects"},
  {"id":"hrc_txn_comment"},
  {"id":"hrc_txn_conditions_context"},
  {"id":"hrc_txn_conditions_lovmetadat["},
  {"id":"hrc_txn_conditions_lovmetadat]"},
  {"id":"hrc_txn_conditions_lovmetadata"},
  {"id":"hrc_txn_conditions_lovusage"},
  {"id":"hrc_txn_conditions_lovusage["},
  {"id":"hrc_txn_conditions_lovusage]"},
  {"id":"hrc_txn_config"},
  {"id":"hrc_txn_config["},
  {"id":"hrc_txn_config]"},
  {"id":"hrc_txn_console_activity"},
  {"id":"hrc_txn_console_entry"},
  {"id":"hrc_txn_console_entry_archive"},
  {"id":"hrc_txn_data"},
  {"id":"hrc_txn_data_archive"},
  {"id":"hrc_txn_denorm"},
  {"id":"hrc_txn_denorm_archive"},
  {"id":"hrc_txn_error"},
  {"id":"hrc_txn_groups"},
  {"id":"hrc_txn_header"},
  {"id":"hrc_txn_header_archive"},
  {"id":"hrc_txn_sec_prof_entry"},
  {"id":"hrc_txn_sec_prof_entry_"},
  {"id":"hrc_txn_sec_prof_sub_cat"},
  {"id":"hrc_txn_sec_prof_sub_cat_"},
  {"id":"hrc_txn_sec_profile"},
  {"id":"hrc_txn_sec_profile_"},
  {"id":"hrc_txn_tac_alert_recipient"},
  {"id":"hrc_txn_tac_alert_recipient_"},
  {"id":"hrc_txn_tac_ess"},
  {"id":"hrc_txn_tac_history"},
  {"id":"hrc_user_msg_config"},
  {"id":"hrc_xfer_job_params"},
  {"id":"hrc_xfer_jobs"},
  {"id":"hrd_career_amb_elig_process_b"},
  {"id":"hrd_career_amb_elig_process_tl"},
  {"id":"hrd_goal_intents"},
  {"id":"hrd_personal_intents"},
  {"id":"hre_touchpt_empl_evts_intrcns"},
  {"id":"hre_touchpt_empl_svy_scores"},
  {"id":"hre_touchpt_summary"},
  {"id":"hre_touchpt_survey_scores"},
  {"id":"hre_tp_consldn_batch_objects"},
  {"id":"hre_tp_consldn_batches"},
  {"id":"hre_tp_consldn_run"},
  {"id":"hrg_data_integ_checks"},
  {"id":"hrg_goal_access"},
  {"id":"hrg_goal_actions"},
  {"id":"hrg_goal_actions_"},
  {"id":"hrg_goal_alignments"},
  {"id":"hrg_goal_mass_requests"},
  {"id":"hrg_goal_measurements"},
  {"id":"hrg_goal_measurements_"},
  {"id":"hrg_goal_plan_doc_types"},
  {"id":"hrg_goal_plan_goals"},
  {"id":"hrg_goal_plan_goals_"},
  {"id":"hrg_goal_plan_set_plans"},
  {"id":"hrg_goal_plan_sets_b"},
  {"id":"hrg_goal_plan_sets_tl"},
  {"id":"hrg_goal_plans_b"},
  {"id":"hrg_goal_plans_tl"},
  {"id":"hrg_goal_pln_assignments"},
  {"id":"hrg_goal_target_outcomes"},
  {"id":"hrg_goals"},
  {"id":"hrg_goals_"},
  {"id":"hrg_mass_req_assignments"},
  {"id":"hrg_mass_req_exemptions"},
  {"id":"hrg_mass_req_hierarchies"},
  {"id":"hrg_mass_req_results"},
  {"id":"hrg_perf_cycle_groups"},
  {"id":"hrg_perf_cycle_objects"},
  {"id":"hrg_perf_cycle_phases"},
  {"id":"hrg_perf_cycles_b"},
  {"id":"hrg_perf_cycles_tl"},
  {"id":"hrl_data_feed_information"},
  {"id":"hrl_data_feed_settings_b"},
  {"id":"hrl_data_feed_settings_b["},
  {"id":"hrl_data_feed_settings_b]"},
  {"id":"hrl_data_feed_settings_tl"},
  {"id":"hrl_data_feed_settings_tl["},
  {"id":"hrl_data_feed_settings_tl]"},
  {"id":"hrm_candidate_history"},
  {"id":"hrm_owner_history"},
  {"id":"hrm_per_evt_plan_objects"},
  {"id":"hrm_person_chg_events"},
  {"id":"hrm_plan_candidates"},
  {"id":"hrm_plan_candidates_"},
  {"id":"hrm_plan_external_candidates"},
  {"id":"hrm_plan_history"},
  {"id":"hrm_plan_incumbents"},
  {"id":"hrm_plan_owners"},
  {"id":"hrm_plan_talentpools"},
  {"id":"hrm_plans"},
  {"id":"hrm_pool_sec_prof_bus_units"},
  {"id":"hrm_pool_sec_prof_bus_units_"},
  {"id":"hrm_pool_sec_prof_departments"},
  {"id":"hrm_pool_sec_prof_departments_"},
  {"id":"hrm_pool_sec_prof_job_familie_"},
  {"id":"hrm_pool_sec_prof_job_families"},
  {"id":"hrm_pool_security_profiles"},
  {"id":"hrm_pool_security_profiles_"},
  {"id":"hrq_categories_b"},
  {"id":"hrq_categories_b["},
  {"id":"hrq_categories_b]"},
  {"id":"hrq_categories_tl"},
  {"id":"hrq_categories_tl["},
  {"id":"hrq_categories_tl]"},
  {"id":"hrq_job_families"},
  {"id":"hrq_job_functions"},
  {"id":"hrq_locations"},
  {"id":"hrq_organizations"},
  {"id":"hrq_qstn_answers_b"},
  {"id":"hrq_qstn_answers_b["},
  {"id":"hrq_qstn_answers_b]"},
  {"id":"hrq_qstn_answers_tl"},
  {"id":"hrq_qstn_answers_tl["},
  {"id":"hrq_qstn_answers_tl]"},
  {"id":"hrq_qstn_participants"},
  {"id":"hrq_qstn_response_details"},
  {"id":"hrq_qstn_response_details_"},
  {"id":"hrq_qstn_responses"},
  {"id":"hrq_qstn_responses_"},
  {"id":"hrq_qstnr_answers"},
  {"id":"hrq_qstnr_dimensions_b"},
  {"id":"hrq_qstnr_dimensions_tl"},
  {"id":"hrq_qstnr_participants"},
  {"id":"hrq_qstnr_participants_"},
  {"id":"hrq_qstnr_qstn_dims"},
  {"id":"hrq_qstnr_questions"},
  {"id":"hrq_qstnr_questions["},
  {"id":"hrq_qstnr_questions]"},
  {"id":"hrq_qstnr_resp_dimensns"},
  {"id":"hrq_qstnr_responses"},
  {"id":"hrq_qstnr_responses_"},
  {"id":"hrq_qstnr_sections_b"},
  {"id":"hrq_qstnr_sections_b["},
  {"id":"hrq_qstnr_sections_b]"},
  {"id":"hrq_qstnr_sections_tl"},
  {"id":"hrq_qstnr_sections_tl["},
  {"id":"hrq_qstnr_sections_tl]"},
  {"id":"hrq_qstnr_templates_b"},
  {"id":"hrq_qstnr_templates_b["},
  {"id":"hrq_qstnr_templates_b]"},
  {"id":"hrq_qstnr_templates_tl"},
  {"id":"hrq_qstnr_templates_tl["},
  {"id":"hrq_qstnr_templates_tl]"},
  {"id":"hrq_qstnr_tmplt_formats"},
  {"id":"hrq_qstnr_tmplt_formats["},
  {"id":"hrq_qstnr_tmplt_formats]"},
  {"id":"hrq_questionnaires_b"},
  {"id":"hrq_questionnaires_b["},
  {"id":"hrq_questionnaires_b]"},
  {"id":"hrq_questionnaires_tl"},
  {"id":"hrq_questionnaires_tl["},
  {"id":"hrq_questionnaires_tl]"},
  {"id":"hrq_questions_b"},
  {"id":"hrq_questions_b["},
  {"id":"hrq_questions_b]"},
  {"id":"hrq_questions_tl"},
  {"id":"hrq_questions_tl["},
  {"id":"hrq_questions_tl]"},
  {"id":"hrq_response_types_b"},
  {"id":"hrq_response_types_b["},
  {"id":"hrq_response_types_tl"},
  {"id":"hrq_response_types_tl["},
  {"id":"hrq_sub_questions_b"},
  {"id":"hrq_sub_questions_tl"},
  {"id":"hrq_subscriber_role_maps"},
  {"id":"hrq_subscribers_b"},
  {"id":"hrq_subscribers_b["},
  {"id":"hrq_subscribers_b]"},
  {"id":"hrq_subscribers_tl"},
  {"id":"hrq_subscribers_tl["},
  {"id":"hrq_subscribers_tl]"},
  {"id":"hrr_dashboard_ratings"},
  {"id":"hrr_dashboard_tmpls_b"},
  {"id":"hrr_dashboard_tmpls_tl"},
  {"id":"hrr_dashboards"},
  {"id":"hrr_meeting_compare_history"},
  {"id":"hrr_meeting_facilitators"},
  {"id":"hrr_meeting_participants"},
  {"id":"hrr_meeting_reviewees"},
  {"id":"hrr_meeting_revw_content"},
  {"id":"hrr_meeting_succplans"},
  {"id":"hrr_meeting_talentpools"},
  {"id":"hrr_meetings"},
  {"id":"hrr_prior_rating_date_ranges"},
  {"id":"hrr_reviewee_prior_ratings"},
  {"id":"hrr_tmpl_analytic_types_b"},
  {"id":"hrr_tmpl_analytic_types_tl"},
  {"id":"hrr_tmpl_anlyt_box_lbls_b"},
  {"id":"hrr_tmpl_anlyt_box_lbls_tl"},
  {"id":"hrr_tmpl_anlyt_box_ratings"},
  {"id":"hrr_tmpl_display_optn_prefs"},
  {"id":"hrr_tmpl_metric_config"},
  {"id":"hrr_tmpl_metric_config_tl"},
  {"id":"hrs_group_space_assoc"},
  {"id":"hrt_accomplishment_items_v_"},
  {"id":"hrt_adv_readiness_items_v_"},
  {"id":"hrt_ai_ingest_batch_profiles"},
  {"id":"hrt_ai_ingest_batches"},
  {"id":"hrt_ai_ingest_run"},
  {"id":"hrt_area_of_study_items_v_"},
  {"id":"hrt_batch_processes"},
  {"id":"hrt_best_fit_processes"},
  {"id":"hrt_bookmarks_b"},
  {"id":"hrt_bookmarks_tl"},
  {"id":"hrt_career_potential_items_v_"},
  {"id":"hrt_certification_items_v_"},
  {"id":"hrt_channel_message_access"},
  {"id":"hrt_channel_messages"},
  {"id":"hrt_channel_setup_b"},
  {"id":"hrt_channel_setup_tl"},
  {"id":"hrt_channel_users"},
  {"id":"hrt_competency_items_v_"},
  {"id":"hrt_content_item_classifs_b"},
  {"id":"hrt_content_item_ext_relations"},
  {"id":"hrt_content_item_rdesc_b"},
  {"id":"hrt_content_item_rdsc_tl"},
  {"id":"hrt_content_item_rlats"},
  {"id":"hrt_content_items_b"},
  {"id":"hrt_content_items_b_"},
  {"id":"hrt_content_items_b_bk"},
  {"id":"hrt_content_items_b["},
  {"id":"hrt_content_items_b]"},
  {"id":"hrt_content_items_tl"},
  {"id":"hrt_content_items_tl_"},
  {"id":"hrt_content_items_tl_bk"},
  {"id":"hrt_content_items_tl["},
  {"id":"hrt_content_items_tl]"},
  {"id":"hrt_content_props_b"},
  {"id":"hrt_content_props_b["},
  {"id":"hrt_content_props_tl"},
  {"id":"hrt_content_props_tl["},
  {"id":"hrt_content_source_rlats"},
  {"id":"hrt_content_source_rlats_bk"},
  {"id":"hrt_content_tp_valuesets_b"},
  {"id":"hrt_content_tp_valuesets_tl"},
  {"id":"hrt_content_type_rlats"},
  {"id":"hrt_content_types_b"},
  {"id":"hrt_content_types_b["},
  {"id":"hrt_content_types_tl"},
  {"id":"hrt_content_types_tl["},
  {"id":"hrt_custom_rating_items_v_"},
  {"id":"hrt_development_activities"},
  {"id":"hrt_education_items_v_"},
  {"id":"hrt_elgblty_profile_objects"},
  {"id":"hrt_eq_content_item_rlats"},
  {"id":"hrt_eq_content_item_rlats["},
  {"id":"hrt_eq_content_item_rlats]"},
  {"id":"hrt_eq_content_items_b"},
  {"id":"hrt_eq_content_items_b["},
  {"id":"hrt_eq_content_items_b]"},
  {"id":"hrt_eq_content_items_tl"},
  {"id":"hrt_eq_content_items_tl["},
  {"id":"hrt_eq_content_items_tl]"},
  {"id":"hrt_ess_chunks"},
  {"id":"hrt_establishments_b"},
  {"id":"hrt_establishments_b_bk"},
  {"id":"hrt_establishments_tl"},
  {"id":"hrt_establishments_tl_bk"},
  {"id":"hrt_external_field_mapping"},
  {"id":"hrt_external_fields_b"},
  {"id":"hrt_external_fields_tl"},
  {"id":"hrt_favorite_colleagues"},
  {"id":"hrt_feedback_suggestions_b"},
  {"id":"hrt_feedback_suggestions_tl"},
  {"id":"hrt_fieldnames_b"},
  {"id":"hrt_fieldnames_tl"},
  {"id":"hrt_honor_items_v_"},
  {"id":"hrt_lang_keywords_b"},
  {"id":"hrt_lang_keywords_tl"},
  {"id":"hrt_lang_suggestions_b"},
  {"id":"hrt_lang_suggestions_tl"},
  {"id":"hrt_language_items_v_"},
  {"id":"hrt_membership_items_v_"},
  {"id":"hrt_note_setup"},
  {"id":"hrt_note_setup["},
  {"id":"hrt_note_setup]"},
  {"id":"hrt_notes"},
  {"id":"hrt_notes_"},
  {"id":"hrt_notif_setup_b"},
  {"id":"hrt_notif_setup_tl"},
  {"id":"hrt_obj_rating_dist_b"},
  {"id":"hrt_obj_rating_dist_tl"},
  {"id":"hrt_perf_rating_items_v_"},
  {"id":"hrt_pool_associations"},
  {"id":"hrt_pool_members"},
  {"id":"hrt_pool_members_"},
  {"id":"hrt_pool_owners"},
  {"id":"hrt_pool_subscribers"},
  {"id":"hrt_pools_b"},
  {"id":"hrt_pools_tl"},
  {"id":"hrt_prev_employment_items_v_"},
  {"id":"hrt_profile_bestfit_result"},
  {"id":"hrt_profile_coi_jobsubsc"},
  {"id":"hrt_profile_extra_info_b"},
  {"id":"hrt_profile_extra_info_tl"},
  {"id":"hrt_profile_imports"},
  {"id":"hrt_profile_interests"},
  {"id":"hrt_profile_item_history"},
  {"id":"hrt_profile_item_sync_details"},
  {"id":"hrt_profile_items"},
  {"id":"hrt_profile_items_"},
  {"id":"hrt_profile_items_bk"},
  {"id":"hrt_profile_keywords"},
  {"id":"hrt_profile_keywords_"},
  {"id":"hrt_profile_logs"},
  {"id":"hrt_profile_map_columns"},
  {"id":"hrt_profile_map_contents"},
  {"id":"hrt_profile_map_defaults"},
  {"id":"hrt_profile_map_requests"},
  {"id":"hrt_profile_match_crit"},
  {"id":"hrt_profile_relations"},
  {"id":"hrt_profile_sections_b"},
  {"id":"hrt_profile_sections_tl"},
  {"id":"hrt_profile_srch_keywords"},
  {"id":"hrt_profile_sync_logs"},
  {"id":"hrt_profile_tags"},
  {"id":"hrt_profile_tags_"},
  {"id":"hrt_profile_tp_sc_prp_b"},
  {"id":"hrt_profile_tp_sc_prp_b_"},
  {"id":"hrt_profile_tp_sc_prp_b_bk"},
  {"id":"hrt_profile_tp_sc_prp_b["},
  {"id":"hrt_profile_tp_sc_prp_tl"},
  {"id":"hrt_profile_tp_sc_prp_tl_"},
  {"id":"hrt_profile_tp_sc_prp_tl_bk"},
  {"id":"hrt_profile_tp_sc_prp_tl["},
  {"id":"hrt_profile_typ_sections"},
  {"id":"hrt_profile_typ_sections_bk"},
  {"id":"hrt_profile_typ_sections_tl"},
  {"id":"hrt_profile_typ_sections_tl_bk"},
  {"id":"hrt_profile_typ_sections_tl["},
  {"id":"hrt_profile_typ_sections["},
  {"id":"hrt_profile_type_grants"},
  {"id":"hrt_profile_type_grants_bk"},
  {"id":"hrt_profile_type_rels"},
  {"id":"hrt_profile_type_rels["},
  {"id":"hrt_profile_type_roles"},
  {"id":"hrt_profile_type_roles_bk"},
  {"id":"hrt_profile_type_text_b"},
  {"id":"hrt_profile_type_text_b["},
  {"id":"hrt_profile_type_text_tl"},
  {"id":"hrt_profile_type_text_tl["},
  {"id":"hrt_profile_types_b"},
  {"id":"hrt_profile_types_b_bk"},
  {"id":"hrt_profile_types_b["},
  {"id":"hrt_profile_types_tl"},
  {"id":"hrt_profile_types_tl_bk"},
  {"id":"hrt_profile_types_tl["},
  {"id":"hrt_profile_vbcs_lists"},
  {"id":"hrt_profiles_b"},
  {"id":"hrt_profiles_b_bk"},
  {"id":"hrt_profiles_tl"},
  {"id":"hrt_profiles_tl_bk"},
  {"id":"hrt_qualifier_sets_b"},
  {"id":"hrt_qualifier_sets_b["},
  {"id":"hrt_qualifier_sets_b]"},
  {"id":"hrt_qualifier_sets_tl"},
  {"id":"hrt_qualifier_sets_tl["},
  {"id":"hrt_qualifier_sets_tl]"},
  {"id":"hrt_qualifiers_b"},
  {"id":"hrt_qualifiers_b["},
  {"id":"hrt_qualifiers_b]"},
  {"id":"hrt_qualifiers_tl"},
  {"id":"hrt_qualifiers_tl["},
  {"id":"hrt_qualifiers_tl]"},
  {"id":"hrt_rating_categories_b"},
  {"id":"hrt_rating_categories_tl"},
  {"id":"hrt_rating_distributions"},
  {"id":"hrt_rating_levels_b"},
  {"id":"hrt_rating_levels_b_"},
  {"id":"hrt_rating_levels_tl"},
  {"id":"hrt_rating_levels_tl_"},
  {"id":"hrt_rating_models_b"},
  {"id":"hrt_rating_models_b_"},
  {"id":"hrt_rating_models_tl"},
  {"id":"hrt_rating_models_tl_"},
  {"id":"hrt_relation_config_b"},
  {"id":"hrt_relation_config_b["},
  {"id":"hrt_relation_config_b]"},
  {"id":"hrt_relation_config_tl"},
  {"id":"hrt_relation_config_tl["},
  {"id":"hrt_relation_config_tl]"},
  {"id":"hrt_review_periods_b"},
  {"id":"hrt_review_periods_tl"},
  {"id":"hrt_skills_assignee"},
  {"id":"hrt_skills_assignments"},
  {"id":"hrt_skills_criteria"},
  {"id":"hrt_skills_criteria_dn"},
  {"id":"hrt_skills_details"},
  {"id":"hrt_skills_endorsements"},
  {"id":"hrt_skills_items_v_"},
  {"id":"hrt_skills_requirements"},
  {"id":"hrt_skills_score_config"},
  {"id":"hrt_skills_score_config["},
  {"id":"hrt_skills_settings"},
  {"id":"hrt_sources_b"},
  {"id":"hrt_sources_tl"},
  {"id":"hrt_special_project_items_v_"},
  {"id":"hrt_sync_log_details"},
  {"id":"hrt_talent_rating_items_v_"},
  {"id":"hrt_task_obj_relations"},
  {"id":"hrt_task_users"},
  {"id":"hrt_tasks"},
  {"id":"hrt_work_preference_items_v_"},
  {"id":"hrw_business_units"},
  {"id":"hrw_configurations"},
  {"id":"hrw_country_division_matrix"},
  {"id":"hrw_divisions"},
  {"id":"hrw_enterprise_countries"},
  {"id":"hrw_enterprises"},
  {"id":"hrw_functions"},
  {"id":"hrw_industries"},
  {"id":"hrw_industry_groups"},
  {"id":"hrw_job_grp_members"},
  {"id":"hrw_job_pos_structures"},
  {"id":"hrw_job_position_details"},
  {"id":"hrw_job_position_global"},
  {"id":"hrw_legal_entities"},
  {"id":"hrw_locations"},
  {"id":"hrw_position_grp_members"},
  {"id":"hrw_reference_data_sets"},
  {"id":"hrw_run_details"},
  {"id":"hrw_run_log"},
  {"id":"hrw_set_assign_override"},
  {"id":"hry_action_inf_purge_info"},
  {"id":"hry_config_prop_dtls_override"},
  {"id":"hry_event_cat_type_mappings"},
  {"id":"hry_event_categories"},
  {"id":"hry_event_categories_tl"},
  {"id":"hry_event_categories_tl]"},
  {"id":"hry_event_categories]"},
  {"id":"hry_event_ext_runs"},
  {"id":"hry_event_process_details"},
  {"id":"hry_ext_parse_dtls"},
  {"id":"hry_ext_transformation"},
  {"id":"hry_ext_transformation_dtls"},
  {"id":"hry_interface_data"},
  {"id":"hry_interface_message_details"},
  {"id":"hry_interface_run_dtls"},
  {"id":"hry_interface_runs"},
  {"id":"hry_object_act_purge_info"},
  {"id":"hry_payroll_act_purge_info"},
  {"id":"hry_pi_config_events_mapping"},
  {"id":"hry_pi_config_properties"},
  {"id":"hry_pi_config_properties["},
  {"id":"hry_pi_config_properties]"},
  {"id":"hry_pi_delivery_result_dtls"},
  {"id":"hry_pi_inbd_record_information"},
  {"id":"hry_pi_inbd_records"},
  {"id":"hry_pi_integ_event_payloads"},
  {"id":"hry_pi_integ_payevents_mapping"},
  {"id":"hry_pi_integ_properties"},
  {"id":"hry_pi_integ_setup"},
  {"id":"hry_pi_payload_rules"},
  {"id":"hry_pi_rti_process_log"},
  {"id":"hry_pi_rti_transaction_status"},
  {"id":"hry_pi_setup_payloads_b"},
  {"id":"hry_pi_setup_payloads_tl"},
  {"id":"hry_setup_config_features"},
  {"id":"hry_setup_config_features_tl"},
  {"id":"hry_setup_config_prop_dtls"},
  {"id":"hry_setup_config_prop_dtls_tl"},
  {"id":"hry_setup_config_prop_dtls_tl["},
  {"id":"hry_setup_config_prop_dtls_tl]"},
  {"id":"hry_setup_config_prop_dtls["},
  {"id":"hry_setup_config_prop_dtls]"},
  {"id":"hry_setup_config_properties"},
  {"id":"hry_setup_config_properties_t["},
  {"id":"hry_setup_config_properties_t]"},
  {"id":"hry_setup_config_properties_tl"},
  {"id":"hry_setup_config_properties["},
  {"id":"hry_setup_config_properties]"},
  {"id":"hry_value_map_ruleset_b"},
  {"id":"hry_value_map_ruleset_dtls"},
  {"id":"hry_value_map_ruleset_tl"},
  {"id":"inv_abc_assgn_group_classes"},
  {"id":"inv_abc_assignment_groups"},
  {"id":"inv_abc_assignments"},
  {"id":"inv_abc_assignments_int"},
  {"id":"inv_abc_classes"},
  {"id":"inv_abc_classes_seeddata_b"},
  {"id":"inv_abc_classes_seeddata_tl"},
  {"id":"inv_abc_comp_hdrs_seeddata_b"},
  {"id":"inv_abc_comp_hdrs_seeddata_tl"},
  {"id":"inv_abc_compile_headers"},
  {"id":"inv_abc_compiles"},
  {"id":"inv_accessible_orgs_gt"},
  {"id":"inv_accounting_transactions"},
  {"id":"inv_actions_b"},
  {"id":"inv_actions_tl"},
  {"id":"inv_advanced_inv_params"},
  {"id":"inv_assgn_groups_seeddata_b"},
  {"id":"inv_assgn_groups_seeddata_tl"},
  {"id":"inv_assgn_grp_cls_seeddata_b"},
  {"id":"inv_assgn_grp_cls_seeddata_tl"},
  {"id":"inv_attr_controls"},
  {"id":"inv_attr_update_headers"},
  {"id":"inv_attr_update_lines"},
  {"id":"inv_balance_txns_int"},
  {"id":"inv_balance_txns_lot_int"},
  {"id":"inv_balance_txns_serial_int"},
  {"id":"inv_barcode_format_headers"},
  {"id":"inv_barcode_format_lines"},
  {"id":"inv_cc_entries_history"},
  {"id":"inv_cc_entries_interface"},
  {"id":"inv_cc_interface_errors"},
  {"id":"inv_cc_sched_count_xrefs"},
  {"id":"inv_cc_schedule_requests"},
  {"id":"inv_cc_serial_history"},
  {"id":"inv_cc_serial_numbers"},
  {"id":"inv_cc_sub_locators"},
  {"id":"inv_cc_subinventories"},
  {"id":"inv_child_lot_numbers"},
  {"id":"inv_cons_advice_headers"},
  {"id":"inv_cons_advice_lines"},
  {"id":"inv_cons_advice_lots"},
  {"id":"inv_cons_advice_revisions"},
  {"id":"inv_cons_advice_serials"},
  {"id":"inv_consumption_rules"},
  {"id":"inv_count_task"},
  {"id":"inv_cst_cancel_history"},
  {"id":"inv_cst_cons_advice_gt"},
  {"id":"inv_cst_consld_sales_orders_gt"},
  {"id":"inv_cst_intf_stats"},
  {"id":"inv_cst_material_txns_gt"},
  {"id":"inv_cst_sales_credits_gt"},
  {"id":"inv_cst_sales_order_details_gt"},
  {"id":"inv_cycle_count_classes"},
  {"id":"inv_cycle_count_entries"},
  {"id":"inv_cycle_count_headers"},
  {"id":"inv_cycle_count_items"},
  {"id":"inv_db_obj_ref_members"},
  {"id":"inv_db_object_joins"},
  {"id":"inv_db_object_references"},
  {"id":"inv_db_objects"},
  {"id":"inv_db_objects_parents"},
  {"id":"inv_do_check_gt"},
  {"id":"inv_event_configurations"},
  {"id":"inv_flex_context"},
  {"id":"inv_generic_dispositions"},
  {"id":"inv_grades_b"},
  {"id":"inv_grades_tl"},
  {"id":"inv_interface_proc_controls"},
  {"id":"inv_interorg_parameters"},
  {"id":"inv_interorg_parameters_"},
  {"id":"inv_intersub_parameters"},
  {"id":"inv_intersub_parameters_"},
  {"id":"inv_item_loc_def_headers_int"},
  {"id":"inv_item_loc_def_lines_int"},
  {"id":"inv_item_loc_defaults"},
  {"id":"inv_item_loc_maint_details"},
  {"id":"inv_item_locations"},
  {"id":"inv_item_locations_"},
  {"id":"inv_item_sub_inventories"},
  {"id":"inv_item_sub_loc_del_history"},
  {"id":"inv_item_sub_maint_details"},
  {"id":"inv_license_plate_numbers"},
  {"id":"inv_locator_maint_details"},
  {"id":"inv_lot_grade_history"},
  {"id":"inv_lot_item_controls"},
  {"id":"inv_lot_numbers"},
  {"id":"inv_lot_numbers_"},
  {"id":"inv_lot_update_draft"},
  {"id":"inv_lpn_contents"},
  {"id":"inv_lpn_history"},
  {"id":"inv_lpn_interface"},
  {"id":"inv_material_status_history"},
  {"id":"inv_material_statuses_b"},
  {"id":"inv_material_statuses_tl"},
  {"id":"inv_material_txns"},
  {"id":"inv_material_txns_exceptions"},
  {"id":"inv_material_txns_temp"},
  {"id":"inv_min_max_gt"},
  {"id":"inv_msn_gt"},
  {"id":"inv_onhand_actions"},
  {"id":"inv_onhand_lock_gt"},
  {"id":"inv_onhand_quantities_cons_bkp"},
  {"id":"inv_onhand_quantities_detail"},
  {"id":"inv_onhand_quantities_summary"},
  {"id":"inv_onhand_summary_tmp"},
  {"id":"inv_org_parameters"},
  {"id":"inv_org_parameters_"},
  {"id":"inv_perf_plan_reward_points"},
  {"id":"inv_perform_pick_txns_int"},
  {"id":"inv_physical_adjustments"},
  {"id":"inv_physical_inventories"},
  {"id":"inv_physical_inventory_tags"},
  {"id":"inv_physical_subinventories"},
  {"id":"inv_pick_confirm_int"},
  {"id":"inv_pick_grouping_rules_b"},
  {"id":"inv_pick_grouping_rules_b["},
  {"id":"inv_pick_grouping_rules_b]"},
  {"id":"inv_pick_grouping_rules_tl"},
  {"id":"inv_pick_grouping_rules_tl["},
  {"id":"inv_pick_grouping_rules_tl]"},
  {"id":"inv_pick_slip_numbers"},
  {"id":"inv_picking_rules"},
  {"id":"inv_print_label_headers"},
  {"id":"inv_print_label_lines"},
  {"id":"inv_print_label_types"},
  {"id":"inv_print_label_types["},
  {"id":"inv_processing_errors"},
  {"id":"inv_replenish_request"},
  {"id":"inv_replenish_request_group"},
  {"id":"inv_replenishments"},
  {"id":"inv_reservations"},
  {"id":"inv_reservations_interface"},
  {"id":"inv_restrictions"},
  {"id":"inv_rfid_configurations"},
  {"id":"inv_rfid_device_events"},
  {"id":"inv_rfid_device_processes"},
  {"id":"inv_rfid_devices"},
  {"id":"inv_rfid_event_actions"},
  {"id":"inv_rfid_events"},
  {"id":"inv_rfid_tag_mappings"},
  {"id":"inv_rsv_gt"},
  {"id":"inv_rule_config_headers"},
  {"id":"inv_rule_config_lines"},
  {"id":"inv_rule_consistencies"},
  {"id":"inv_rule_list_package"},
  {"id":"inv_rule_parameters"},
  {"id":"inv_rule_trace_headers"},
  {"id":"inv_rule_trace_lines"},
  {"id":"inv_rules_b"},
  {"id":"inv_rules_tl"},
  {"id":"inv_sales_orders"},
  {"id":"inv_schedules_data_gt"},
  {"id":"inv_secondary_inventories"},
  {"id":"inv_secondary_inventories_"},
  {"id":"inv_secondary_inventories_tl"},
  {"id":"inv_secondary_locators"},
  {"id":"inv_selection_criteria_txn"},
  {"id":"inv_serial_item_controls"},
  {"id":"inv_serial_numbers"},
  {"id":"inv_serial_numbers_"},
  {"id":"inv_serial_numbers_interface"},
  {"id":"inv_serial_numbers_temp"},
  {"id":"inv_serial_update_draft"},
  {"id":"inv_shortage_item_details"},
  {"id":"inv_shortage_item_locations"},
  {"id":"inv_sort_criteria"},
  {"id":"inv_spoke_pub_date_history"},
  {"id":"inv_spoke_publication_history"},
  {"id":"inv_status_transaction_control"},
  {"id":"inv_strategies_b"},
  {"id":"inv_strategies_tl"},
  {"id":"inv_strategy_members"},
  {"id":"inv_subinv_maint_details"},
  {"id":"inv_subinv_mass_maint_actions"},
  {"id":"inv_subinventories_seeddata_b"},
  {"id":"inv_subinventories_seeddata_tl"},
  {"id":"inv_supply"},
  {"id":"inv_supply_demand_temp"},
  {"id":"inv_supply_summary"},
  {"id":"inv_task_perf_plan_periods"},
  {"id":"inv_task_perf_plan_rewards"},
  {"id":"inv_task_perf_plan_standards"},
  {"id":"inv_task_perf_plan_workers"},
  {"id":"inv_task_perf_plans"},
  {"id":"inv_task_plan_period_summary"},
  {"id":"inv_task_plan_worker_summary"},
  {"id":"inv_trans_order_dist_int"},
  {"id":"inv_trans_order_transprice_int"},
  {"id":"inv_transaction_flow_headers"},
  {"id":"inv_transaction_flow_lines"},
  {"id":"inv_transaction_lot_numbers"},
  {"id":"inv_transaction_lots_interface"},
  {"id":"inv_transaction_lots_temp"},
  {"id":"inv_transaction_reasons_b"},
  {"id":"inv_transaction_reasons_tl"},
  {"id":"inv_transaction_types_b"},
  {"id":"inv_transaction_types_b["},
  {"id":"inv_transaction_types_b]"},
  {"id":"inv_transaction_types_tl"},
  {"id":"inv_transaction_types_tl["},
  {"id":"inv_transaction_types_tl]"},
  {"id":"inv_transactions_gt"},
  {"id":"inv_transactions_interface"},
  {"id":"inv_transfer_order_distribs"},
  {"id":"inv_transfer_order_headers"},
  {"id":"inv_transfer_order_lines"},
  {"id":"inv_transfer_order_status_gt"},
  {"id":"inv_transfer_orders_int"},
  {"id":"inv_txn_context_gt"},
  {"id":"inv_txn_request_headers"},
  {"id":"inv_txn_request_lines"},
  {"id":"inv_txn_source_types_b"},
  {"id":"inv_txn_source_types_b["},
  {"id":"inv_txn_source_types_b]"},
  {"id":"inv_txn_source_types_tl"},
  {"id":"inv_txn_source_types_tl["},
  {"id":"inv_txn_source_types_tl]"},
  {"id":"inv_unit_transactions"},
  {"id":"inv_units_of_measure_b"},
  {"id":"inv_units_of_measure_tl"},
  {"id":"inv_uom_class_conversions"},
  {"id":"inv_uom_classes_b"},
  {"id":"inv_uom_classes_tl"},
  {"id":"inv_uom_conversions"},
  {"id":"inv_uom_usages"},
  {"id":"inv_zone_activity_usages"},
  {"id":"inv_zone_configurations"},
  {"id":"inv_zone_subinv_locators"},
  {"id":"inv_zone_task_assignees"},
  {"id":"inv_zone_task_scopes"},
  {"id":"inv_zone_tasks"},
  {"id":"inv_zone_worker_activities"},
  {"id":"inv_zone_worker_history"},
  {"id":"inv_zone_workers"},
  {"id":"inv_zones"},
  {"id":"irc_access_tokens"},
  {"id":"irc_admin_alert_tracking"},
  {"id":"irc_af_blocks_b"},
  {"id":"irc_af_blocks_b["},
  {"id":"irc_af_blocks_b]"},
  {"id":"irc_af_blocks_tl"},
  {"id":"irc_af_blocks_tl["},
  {"id":"irc_af_blocks_tl]"},
  {"id":"irc_af_page_blk_doctypes"},
  {"id":"irc_af_page_blk_ja_eff"},
  {"id":"irc_af_page_blk_miscdocs"},
  {"id":"irc_af_page_blk_prf_scs"},
  {"id":"irc_af_page_blk_qstnrs"},
  {"id":"irc_af_page_blk_sensinfo"},
  {"id":"irc_af_page_blk_supdocs"},
  {"id":"irc_af_page_blocks_b"},
  {"id":"irc_af_page_blocks_tl"},
  {"id":"irc_af_pages_b"},
  {"id":"irc_af_pages_tl"},
  {"id":"irc_af_sections_b"},
  {"id":"irc_af_sections_tl"},
  {"id":"irc_af_versions"},
  {"id":"irc_agencies"},
  {"id":"irc_agency_pool"},
  {"id":"irc_agent_requisitions"},
  {"id":"irc_agents"},
  {"id":"irc_ai_dismissed_recoms"},
  {"id":"irc_ai_gig_filters"},
  {"id":"irc_aievents_tracking"},
  {"id":"irc_aimatching_enty_trk"},
  {"id":"irc_aimatching_queue"},
  {"id":"irc_aimatching_trk"},
  {"id":"irc_applicant_scores"},
  {"id":"irc_applicant_scores_debug"},
  {"id":"irc_apply_flows_b"},
  {"id":"irc_apply_flows_tl"},
  {"id":"irc_asmt_acct_packages"},
  {"id":"irc_asmt_package_results"},
  {"id":"irc_asmt_partner_config"},
  {"id":"irc_asmt_req_config"},
  {"id":"irc_asmt_req_packages"},
  {"id":"irc_asmt_results"},
  {"id":"irc_auto_sync_to_hr"},
  {"id":"irc_auto_sync_to_hr_tracking"},
  {"id":"irc_avail_context"},
  {"id":"irc_avail_cxt_job"},
  {"id":"irc_avail_cxt_job_fam"},
  {"id":"irc_avail_cxt_job_func"},
  {"id":"irc_avail_cxt_loc"},
  {"id":"irc_avail_cxt_org"},
  {"id":"irc_avail_cxt_per_type"},
  {"id":"irc_avail_cxt_rec_type"},
  {"id":"irc_avail_cxt_req_dff"},
  {"id":"irc_avail_cxt_site"},
  {"id":"irc_availability_context"},
  {"id":"irc_batch_offer_items"},
  {"id":"irc_batch_offers"},
  {"id":"irc_bc_acct_sp_assgmnts"},
  {"id":"irc_bc_activation_config"},
  {"id":"irc_bc_cand_results"},
  {"id":"irc_bc_cand_screenings"},
  {"id":"irc_bc_req_accounts"},
  {"id":"irc_bc_req_sp_assgmnts"},
  {"id":"irc_blocked_contacts"},
  {"id":"irc_bot_job_keywords"},
  {"id":"irc_bot_qr_codes"},
  {"id":"irc_bot_questions_config_b"},
  {"id":"irc_bot_questions_config_tl"},
  {"id":"irc_bot_setting_values"},
  {"id":"irc_bot_settings"},
  {"id":"irc_bulk_action_items"},
  {"id":"irc_bulk_actions"},
  {"id":"irc_camp_asset_audience"},
  {"id":"irc_camp_asset_channels"},
  {"id":"irc_camp_asset_segments"},
  {"id":"irc_camp_asset_urls"},
  {"id":"irc_camp_asset_urls_b"},
  {"id":"irc_camp_asset_urls_tl"},
  {"id":"irc_camp_assets_b"},
  {"id":"irc_camp_assets_tl"},
  {"id":"irc_camp_aud_source_items"},
  {"id":"irc_camp_audience"},
  {"id":"irc_camp_audience_metrics"},
  {"id":"irc_camp_audience_source"},
  {"id":"irc_camp_audience_status"},
  {"id":"irc_camp_bo_assoc_items"},
  {"id":"irc_camp_bo_assoc_metrics"},
  {"id":"irc_camp_bo_associations"},
  {"id":"irc_camp_category_mapping"},
  {"id":"irc_camp_comm_teams_b"},
  {"id":"irc_camp_comm_teams_tl"},
  {"id":"irc_camp_conversions"},
  {"id":"irc_camp_deep_links_b"},
  {"id":"irc_camp_deep_links_tl"},
  {"id":"irc_camp_elig_bu_metrics"},
  {"id":"irc_camp_elig_loc_metrics"},
  {"id":"irc_camp_elig_mapping"},
  {"id":"irc_camp_goal_resp_b"},
  {"id":"irc_camp_goal_resp_tl"},
  {"id":"irc_camp_goals_b"},
  {"id":"irc_camp_goals_tl"},
  {"id":"irc_camp_journey_metrics"},
  {"id":"irc_camp_languages"},
  {"id":"irc_camp_person_journey_status"},
  {"id":"irc_camp_post_content_b"},
  {"id":"irc_camp_post_content_tl"},
  {"id":"irc_camp_post_views"},
  {"id":"irc_camp_requisitions"},
  {"id":"irc_camp_saved_searches"},
  {"id":"irc_camp_team_audience_source"},
  {"id":"irc_camp_team_contact_prefs"},
  {"id":"irc_camp_team_elig_prfl"},
  {"id":"irc_camp_team_purposes"},
  {"id":"irc_camp_team_templates"},
  {"id":"irc_camp_team_vanity_cfg"},
  {"id":"irc_camp_track_response"},
  {"id":"irc_camp_vanity_config"},
  {"id":"irc_campaign_tracking"},
  {"id":"irc_campaigns_b"},
  {"id":"irc_campaigns_tl"},
  {"id":"irc_cand_actions"},
  {"id":"irc_cand_alt_details"},
  {"id":"irc_cand_attributes_b"},
  {"id":"irc_cand_attributes_tl"},
  {"id":"irc_cand_closeout_occurrences"},
  {"id":"irc_cand_closeout_scans"},
  {"id":"irc_cand_dup_check_details"},
  {"id":"irc_cand_dup_check_summary"},
  {"id":"irc_cand_dup_col_types"},
  {"id":"irc_cand_dup_notif_config"},
  {"id":"irc_cand_email_attachments"},
  {"id":"irc_cand_email_message_dump"},
  {"id":"irc_cand_email_messages"},
  {"id":"irc_cand_email_recipients"},
  {"id":"irc_cand_geographies_b"},
  {"id":"irc_cand_geographies_tl"},
  {"id":"irc_cand_locations_b"},
  {"id":"irc_cand_locations_tl"},
  {"id":"irc_cand_merge_logs"},
  {"id":"irc_cand_msg_logs"},
  {"id":"irc_cand_msg_store"},
  {"id":"irc_cand_optin_history"},
  {"id":"irc_cand_pool_alert_config"},
  {"id":"irc_cand_pool_bo_associations"},
  {"id":"irc_cand_pool_members"},
  {"id":"irc_cand_pool_members_"},
  {"id":"irc_cand_pool_rules"},
  {"id":"irc_cand_pool_sync_tracking"},
  {"id":"irc_cand_pref_job_family"},
  {"id":"irc_cand_pref_job_function"},
  {"id":"irc_cand_pref_jobs"},
  {"id":"irc_cand_pref_locations"},
  {"id":"irc_cand_pref_organizations"},
  {"id":"irc_cand_pref_workplace_types"},
  {"id":"irc_cand_preferences"},
  {"id":"irc_cand_profile_usages_m"},
  {"id":"irc_cand_sec_profile_values"},
  {"id":"irc_cand_sec_profiles"},
  {"id":"irc_candidate_search_tracking"},
  {"id":"irc_candidates"},
  {"id":"irc_candidates_dn"},
  {"id":"irc_cc_elements_b"},
  {"id":"irc_cc_elements_tl"},
  {"id":"irc_cc_settings"},
  {"id":"irc_cmt_launch_contents"},
  {"id":"irc_cmt_launch_results"},
  {"id":"irc_cmt_launch_status_logs"},
  {"id":"irc_cmt_launches"},
  {"id":"irc_cmt_recipients"},
  {"id":"irc_comm_accounts"},
  {"id":"irc_comm_providers"},
  {"id":"irc_comm_providers["},
  {"id":"irc_contingent_submissions"},
  {"id":"irc_conversation_participants"},
  {"id":"irc_cs_progress_history"},
  {"id":"irc_cx_app_drafts"},
  {"id":"irc_cx_cndt_email_tkns"},
  {"id":"irc_cx_cookies_b"},
  {"id":"irc_cx_cookies_tl"},
  {"id":"irc_cx_ctm_fonts_b"},
  {"id":"irc_cx_ctm_fonts_files_b"},
  {"id":"irc_cx_ctm_fonts_files_tl"},
  {"id":"irc_cx_ctm_fonts_set_b"},
  {"id":"irc_cx_ctm_fonts_set_tl"},
  {"id":"irc_cx_ctm_fonts_tl"},
  {"id":"irc_cx_element_asset_cache"},
  {"id":"irc_cx_gjs_config"},
  {"id":"irc_cx_header_settings"},
  {"id":"irc_cx_headers_b"},
  {"id":"irc_cx_headers_tl"},
  {"id":"irc_cx_icon_settings"},
  {"id":"irc_cx_icons"},
  {"id":"irc_cx_jobs_queue"},
  {"id":"irc_cx_map_cfg_settings"},
  {"id":"irc_cx_map_configs"},
  {"id":"irc_cx_map_prov_settings"},
  {"id":"irc_cx_map_providers"},
  {"id":"irc_cx_pages_b"},
  {"id":"irc_cx_pages_tl"},
  {"id":"irc_cx_prov_configs"},
  {"id":"irc_cx_prov_settings"},
  {"id":"irc_cx_providers"},
  {"id":"irc_cx_site_brands_b"},
  {"id":"irc_cx_site_brands_tl"},
  {"id":"irc_cx_site_favicons"},
  {"id":"irc_cx_site_font_styles"},
  {"id":"irc_cx_site_langs"},
  {"id":"irc_cx_site_links_b"},
  {"id":"irc_cx_site_links_tl"},
  {"id":"irc_cx_site_settings"},
  {"id":"irc_cx_site_styles"},
  {"id":"irc_cx_site_templates_b"},
  {"id":"irc_cx_site_templates_tl"},
  {"id":"irc_cx_site_theme_links_b"},
  {"id":"irc_cx_site_theme_links_tl"},
  {"id":"irc_cx_site_themes"},
  {"id":"irc_cx_sites_b"},
  {"id":"irc_cx_sites_tl"},
  {"id":"irc_cx_tc_signup_b"},
  {"id":"irc_cx_tc_signup_tl"},
  {"id":"irc_cx_template_settings"},
  {"id":"irc_cx_user_trk_data"},
  {"id":"irc_cx_user_trk_devices"},
  {"id":"irc_cx_widget_settings"},
  {"id":"irc_cx_widgets_b"},
  {"id":"irc_cx_widgets_tl"},
  {"id":"irc_da_partner_config"},
  {"id":"irc_da_partner_ja_tracking"},
  {"id":"irc_da_partner_notif"},
  {"id":"irc_da_partner_notif_config"},
  {"id":"irc_desc_versions_b"},
  {"id":"irc_desc_versions_b_"},
  {"id":"irc_desc_versions_b["},
  {"id":"irc_desc_versions_b]"},
  {"id":"irc_desc_versions_tl"},
  {"id":"irc_desc_versions_tl_"},
  {"id":"irc_desc_versions_tl["},
  {"id":"irc_desc_versions_tl]"},
  {"id":"irc_descriptions_b"},
  {"id":"irc_descriptions_b_"},
  {"id":"irc_descriptions_b["},
  {"id":"irc_descriptions_b]"},
  {"id":"irc_descriptions_tl"},
  {"id":"irc_descriptions_tl_"},
  {"id":"irc_descriptions_tl["},
  {"id":"irc_descriptions_tl]"},
  {"id":"irc_dimension_def_b"},
  {"id":"irc_dimension_def_tl"},
  {"id":"irc_document_indexing_trk"},
  {"id":"irc_document_types"},
  {"id":"irc_emp_event_action_trk"},
  {"id":"irc_emp_event_messages"},
  {"id":"irc_emp_event_msg_content"},
  {"id":"irc_emp_events_actvty_trk"},
  {"id":"irc_emp_events_addl_attrs"},
  {"id":"irc_emp_events_b"},
  {"id":"irc_emp_events_locations"},
  {"id":"irc_emp_events_owners"},
  {"id":"irc_emp_events_respondents"},
  {"id":"irc_emp_events_tl"},
  {"id":"irc_emp_to_cand_queue"},
  {"id":"irc_endorsements"},
  {"id":"irc_entity_labels"},
  {"id":"irc_error_logs"},
  {"id":"irc_error_tracking"},
  {"id":"irc_esignatures"},
  {"id":"irc_ext_api_conn_pool"},
  {"id":"irc_ext_api_conn_pool_count"},
  {"id":"irc_favorite_jobs"},
  {"id":"irc_feature_config_b"},
  {"id":"irc_feature_config_b["},
  {"id":"irc_feature_config_b]"},
  {"id":"irc_feature_config_tl"},
  {"id":"irc_feature_config_tl["},
  {"id":"irc_feature_config_tl]"},
  {"id":"irc_feature_usage"},
  {"id":"irc_fn_expression_refs"},
  {"id":"irc_followup_tasks"},
  {"id":"irc_geo_coordinates"},
  {"id":"irc_geo_hier_nodes"},
  {"id":"irc_geo_hier_nodes_iden"},
  {"id":"irc_geo_hier_nodes_opti"},
  {"id":"irc_geo_hierarchies"},
  {"id":"irc_geo_level_mappings"},
  {"id":"irc_geographies"},
  {"id":"irc_geography_locations"},
  {"id":"irc_gv_categories_b"},
  {"id":"irc_gv_categories_b["},
  {"id":"irc_gv_categories_b]"},
  {"id":"irc_gv_categories_tl"},
  {"id":"irc_gv_categories_tl["},
  {"id":"irc_gv_categories_tl]"},
  {"id":"irc_gv_column_fields"},
  {"id":"irc_gv_column_fields["},
  {"id":"irc_gv_column_fields]"},
  {"id":"irc_gv_columns_b"},
  {"id":"irc_gv_columns_b["},
  {"id":"irc_gv_columns_b]"},
  {"id":"irc_gv_columns_tl"},
  {"id":"irc_gv_columns_tl["},
  {"id":"irc_gv_columns_tl]"},
  {"id":"irc_gv_compound_fields"},
  {"id":"irc_gv_compound_fields["},
  {"id":"irc_gv_compound_fields]"},
  {"id":"irc_gv_default_views"},
  {"id":"irc_gv_fields_b"},
  {"id":"irc_gv_fields_b["},
  {"id":"irc_gv_fields_b]"},
  {"id":"irc_gv_fields_tl"},
  {"id":"irc_gv_fields_tl["},
  {"id":"irc_gv_fields_tl]"},
  {"id":"irc_gv_mask_field_rules"},
  {"id":"irc_gv_mask_fields"},
  {"id":"irc_gv_view_owners"},
  {"id":"irc_gv_view_owners["},
  {"id":"irc_gv_view_owners]"},
  {"id":"irc_gv_views_b"},
  {"id":"irc_gv_views_b["},
  {"id":"irc_gv_views_b]"},
  {"id":"irc_gv_views_tl"},
  {"id":"irc_gv_views_tl["},
  {"id":"irc_gv_views_tl]"},
  {"id":"irc_hist_event_b"},
  {"id":"irc_hist_event_tl"},
  {"id":"irc_hist_source_objects"},
  {"id":"irc_http_body_tokens"},
  {"id":"irc_http_headers"},
  {"id":"irc_http_requests"},
  {"id":"irc_ice_app_drafts"},
  {"id":"irc_im_auto_fdbk_config"},
  {"id":"irc_im_auto_fdbk_qstnrs"},
  {"id":"irc_im_feedbacks"},
  {"id":"irc_im_feedbk_partcpts"},
  {"id":"irc_im_feedbk_requests"},
  {"id":"irc_im_feedbk_resp_dtls"},
  {"id":"irc_im_feedbk_reviews"},
  {"id":"irc_im_qstnr_attchmnts"},
  {"id":"irc_im_qstnr_info"},
  {"id":"irc_im_req_qstnrs"},
  {"id":"irc_in_app_config"},
  {"id":"irc_interact_recipients"},
  {"id":"irc_interactions"},
  {"id":"irc_is_availability"},
  {"id":"irc_is_coordntr_requests"},
  {"id":"irc_is_interview_part"},
  {"id":"irc_is_interview_qstnr"},
  {"id":"irc_is_interviews"},
  {"id":"irc_is_intrvw_requests"},
  {"id":"irc_is_locations"},
  {"id":"irc_is_properties_b"},
  {"id":"irc_is_properties_tl"},
  {"id":"irc_is_req_auto_schedule"},
  {"id":"irc_is_schedule_mapping"},
  {"id":"irc_is_schedules_b"},
  {"id":"irc_is_schedules_tl"},
  {"id":"irc_is_zoom_tokens"},
  {"id":"irc_ja_attachment_status"},
  {"id":"irc_ja_auto_notif_config"},
  {"id":"irc_ja_computed_fields"},
  {"id":"irc_ja_extra_info"},
  {"id":"irc_ja_notif_config"},
  {"id":"irc_ja_notif_occur"},
  {"id":"irc_ja_notif_process"},
  {"id":"irc_ja_notif_scans"},
  {"id":"irc_ja_pref_locations"},
  {"id":"irc_ja_rank_config"},
  {"id":"irc_ja_secondary_flows"},
  {"id":"irc_jd_activation_config"},
  {"id":"irc_jd_req_post_history"},
  {"id":"irc_jd_req_post_results"},
  {"id":"irc_jd_req_postings"},
  {"id":"irc_labels"},
  {"id":"irc_labels_b"},
  {"id":"irc_labels_tl"},
  {"id":"irc_lc_action_usages_b"},
  {"id":"irc_lc_action_usages_tl"},
  {"id":"irc_lc_actions_b"},
  {"id":"irc_lc_actions_b["},
  {"id":"irc_lc_actions_b]"},
  {"id":"irc_lc_actions_tl"},
  {"id":"irc_lc_actions_tl["},
  {"id":"irc_lc_actions_tl]"},
  {"id":"irc_lc_event_msg"},
  {"id":"irc_lc_history"},
  {"id":"irc_lc_next_action_items"},
  {"id":"irc_lc_next_actions"},
  {"id":"irc_lc_process_def_history"},
  {"id":"irc_lc_reason_groups_b"},
  {"id":"irc_lc_reason_groups_tl"},
  {"id":"irc_lc_reason_usages"},
  {"id":"irc_lc_reasons_b"},
  {"id":"irc_lc_reasons_tl"},
  {"id":"irc_lc_setting_items"},
  {"id":"irc_lc_settings"},
  {"id":"irc_li_activation_config"},
  {"id":"irc_li_activation_config_"},
  {"id":"irc_li_app_config_urls"},
  {"id":"irc_li_app_config_urls["},
  {"id":"irc_li_app_config_urls]"},
  {"id":"irc_li_candidate_mapping"},
  {"id":"irc_li_contracts"},
  {"id":"irc_li_job_submission_mapping"},
  {"id":"irc_li_requisition_mapping"},
  {"id":"irc_li_rsc_batch_history"},
  {"id":"irc_li_rsc_sync_history"},
  {"id":"irc_li_rsc_sync_queue"},
  {"id":"irc_li_rsc_users"},
  {"id":"irc_media_asset_properties"},
  {"id":"irc_media_assets_b"},
  {"id":"irc_media_assets_tl"},
  {"id":"irc_media_link_languages"},
  {"id":"irc_media_links_b"},
  {"id":"irc_media_links_tl"},
  {"id":"irc_message_content"},
  {"id":"irc_message_detail_logs"},
  {"id":"irc_message_geo_permissions"},
  {"id":"irc_message_tracking"},
  {"id":"irc_mp_benefits_b"},
  {"id":"irc_mp_benefits_tl"},
  {"id":"irc_mp_favourites"},
  {"id":"irc_mp_gig_applications"},
  {"id":"irc_mp_gig_classifications"},
  {"id":"irc_mp_gig_media_links"},
  {"id":"irc_mp_gigs_b"},
  {"id":"irc_mp_gigs_tl"},
  {"id":"irc_mp_ignored_candidates"},
  {"id":"irc_mp_optyseeker_preferences"},
  {"id":"irc_mp_prospects"},
  {"id":"irc_mp_site_config_b"},
  {"id":"irc_mp_site_config_tl"},
  {"id":"irc_mp_team_members_b"},
  {"id":"irc_mp_team_members_tl"},
  {"id":"irc_msg_design_metadata"},
  {"id":"irc_msg_design_metadata["},
  {"id":"irc_msg_design_metadata]"},
  {"id":"irc_msg_design_types"},
  {"id":"irc_msg_design_types["},
  {"id":"irc_msg_design_types]"},
  {"id":"irc_msg_designs_b"},
  {"id":"irc_msg_designs_b["},
  {"id":"irc_msg_designs_b]"},
  {"id":"irc_msg_designs_tl"},
  {"id":"irc_msg_designs_tl["},
  {"id":"irc_msg_designs_tl]"},
  {"id":"irc_offers"},
  {"id":"irc_onboarding_osn"},
  {"id":"irc_phases_b"},
  {"id":"irc_phases_tl"},
  {"id":"irc_phone_country_codes"},
  {"id":"irc_phone_country_codes]"},
  {"id":"irc_pi_stats"},
  {"id":"irc_pools_dn"},
  {"id":"irc_processes_b"},
  {"id":"irc_processes_b["},
  {"id":"irc_processes_tl"},
  {"id":"irc_processes_tl["},
  {"id":"irc_prospects"},
  {"id":"irc_published_jobs"},
  {"id":"irc_published_jobs_"},
  {"id":"irc_purge_entities"},
  {"id":"irc_purge_entities["},
  {"id":"irc_purge_entities]"},
  {"id":"irc_purge_history"},
  {"id":"irc_rac_act_item_viewers"},
  {"id":"irc_rac_action_items"},
  {"id":"irc_rac_rule_actions"},
  {"id":"irc_rac_rule_viewers"},
  {"id":"irc_rac_subscr_rules_b"},
  {"id":"irc_rac_subscr_rules_tl"},
  {"id":"irc_rac_subscribers"},
  {"id":"irc_rec_event_intrv_dtls"},
  {"id":"irc_rec_event_intrv_mbrs"},
  {"id":"irc_rec_event_intrv_parts"},
  {"id":"irc_rec_event_languages"},
  {"id":"irc_rec_event_loc_usages"},
  {"id":"irc_rec_event_media"},
  {"id":"irc_rec_event_pool_members"},
  {"id":"irc_rec_event_sites"},
  {"id":"irc_rec_events_b"},
  {"id":"irc_rec_events_tl"},
  {"id":"irc_reg_tn_agencies"},
  {"id":"irc_reg_tnetwork_config"},
  {"id":"irc_reg_tnetwork_settings"},
  {"id":"irc_regulatory_responses"},
  {"id":"irc_req_info_reserved"},
  {"id":"irc_req_languages"},
  {"id":"irc_req_locations"},
  {"id":"irc_req_media_links"},
  {"id":"irc_req_sec_prof_tmt"},
  {"id":"irc_req_sec_profiles"},
  {"id":"irc_req_work_locations"},
  {"id":"irc_requisitions_b"},
  {"id":"irc_requisitions_b_"},
  {"id":"irc_requisitions_dn"},
  {"id":"irc_requisitions_tl"},
  {"id":"irc_requisitions_tl_"},
  {"id":"irc_rf_referrals"},
  {"id":"irc_rf_req_hits"},
  {"id":"irc_rf_shares"},
  {"id":"irc_routing_steps_b"},
  {"id":"irc_routing_steps_b["},
  {"id":"irc_rp_activation_config"},
  {"id":"irc_rp_activation_config["},
  {"id":"irc_rp_activation_config]"},
  {"id":"irc_saved_searches"},
  {"id":"irc_search_action_details"},
  {"id":"irc_search_actions"},
  {"id":"irc_search_inc_indexing_trk"},
  {"id":"irc_search_index_upg_trk"},
  {"id":"irc_search_index_upgrades"},
  {"id":"irc_search_index_upgrades["},
  {"id":"irc_search_index_upgrades]"},
  {"id":"irc_search_queue"},
  {"id":"irc_search_results"},
  {"id":"irc_search_synonym_config"},
  {"id":"irc_searches"},
  {"id":"irc_searches_dn"},
  {"id":"irc_sec_flow_config"},
  {"id":"irc_service_scan_log"},
  {"id":"irc_service_scan_status"},
  {"id":"irc_setting_values"},
  {"id":"irc_setting_values["},
  {"id":"irc_setting_values]"},
  {"id":"irc_settings"},
  {"id":"irc_settings["},
  {"id":"irc_settings]"},
  {"id":"irc_sgas_entries"},
  {"id":"irc_source_tracking"},
  {"id":"irc_sql_tracking"},
  {"id":"irc_states_b"},
  {"id":"irc_states_b["},
  {"id":"irc_states_tl"},
  {"id":"irc_states_tl["},
  {"id":"irc_step_transitions"},
  {"id":"irc_submissions"},
  {"id":"irc_synonyms_b"},
  {"id":"irc_synonyms_tl"},
  {"id":"irc_tc_account_packages"},
  {"id":"irc_tc_cand_addl_results"},
  {"id":"irc_tc_cand_pkg_results"},
  {"id":"irc_tc_partner_config"},
  {"id":"irc_tc_req_config"},
  {"id":"irc_tc_req_packages"},
  {"id":"irc_tc_screening_orders"},
  {"id":"irc_team_members"},
  {"id":"irc_tn_agy_terms_conditions"},
  {"id":"irc_tn_ja_agent_actions"},
  {"id":"irc_tn_ja_request_more_info"},
  {"id":"irc_tn_job_agencies"},
  {"id":"irc_tn_job_agency_actions"},
  {"id":"irc_tn_job_app_bid_info"},
  {"id":"irc_tn_job_applications"},
  {"id":"irc_tn_job_certifications_b"},
  {"id":"irc_tn_job_certifications_tl"},
  {"id":"irc_tn_job_posting_locs_b"},
  {"id":"irc_tn_job_posting_locs_tl"},
  {"id":"irc_tn_job_refs"},
  {"id":"irc_tn_job_skills_b"},
  {"id":"irc_tn_job_skills_tl"},
  {"id":"irc_tn_job_work_locs_b"},
  {"id":"irc_tn_job_work_locs_tl"},
  {"id":"irc_tn_jobs_b"},
  {"id":"irc_tn_jobs_tl"},
  {"id":"irc_tn_subscriber_agencies"},
  {"id":"irc_tn_subscriber_settings"},
  {"id":"irc_tn_subscribers"},
  {"id":"irc_tnetwork_agency_req_info"},
  {"id":"irc_tp_categories_b"},
  {"id":"irc_tp_categories_b["},
  {"id":"irc_tp_categories_tl"},
  {"id":"irc_tp_categories_tl["},
  {"id":"irc_tp_category_phases"},
  {"id":"irc_tp_category_phases["},
  {"id":"irc_tp_category_services"},
  {"id":"irc_tp_category_services["},
  {"id":"irc_tp_event_logs"},
  {"id":"irc_tp_events"},
  {"id":"irc_tp_partner_accounts"},
  {"id":"irc_tp_partner_notifs"},
  {"id":"irc_tp_partner_provisngs"},
  {"id":"irc_tp_partner_provisngs["},
  {"id":"irc_tp_partner_provisngs]"},
  {"id":"irc_tp_partner_services"},
  {"id":"irc_tp_partner_services["},
  {"id":"irc_tp_partner_services]"},
  {"id":"irc_tp_partners"},
  {"id":"irc_tp_partners["},
  {"id":"irc_tp_partners]"},
  {"id":"irc_track_user_views"},
  {"id":"irc_user_favorites"},
  {"id":"irc_waba_template_details"},
  {"id":"irc_waba_template_token_map"},
  {"id":"irc_wfmodel_requisitions"},
  {"id":"irc_whatsapp_template_b"},
  {"id":"irc_whatsapp_template_tl"},
  {"id":"pay_action_classes"},
  {"id":"pay_action_contexts"},
  {"id":"pay_action_contexts_var"},
  {"id":"pay_action_details"},
  {"id":"pay_action_information"},
  {"id":"pay_action_interlocks"},
  {"id":"pay_action_log_lines"},
  {"id":"pay_action_logs"},
  {"id":"pay_action_matrix"},
  {"id":"pay_action_param_groups"},
  {"id":"pay_action_param_groups["},
  {"id":"pay_action_param_groups]"},
  {"id":"pay_action_param_values"},
  {"id":"pay_action_param_values["},
  {"id":"pay_action_param_values]"},
  {"id":"pay_action_types"},
  {"id":"pay_action_types["},
  {"id":"pay_adjusted_costing_details"},
  {"id":"pay_all_payrolls_f"},
  {"id":"pay_allow_overrides_f"},
  {"id":"pay_allow_overrides_f["},
  {"id":"pay_allow_overrides_f]"},
  {"id":"pay_allow_overrides_tl"},
  {"id":"pay_allow_overrides_tl["},
  {"id":"pay_allow_overrides_tl]"},
  {"id":"pay_amer_geographies"},
  {"id":"pay_amer_geography_ranges"},
  {"id":"pay_amer_interface_parameters"},
  {"id":"pay_archive_items"},
  {"id":"pay_archive_sort_values"},
  {"id":"pay_assigned_payrolls_dn"},
  {"id":"pay_assigned_payrolls_dn_"},
  {"id":"pay_assigned_payrolls_f"},
  {"id":"pay_assigned_payrolls_f_"},
  {"id":"pay_auto_indirects_f"},
  {"id":"pay_auto_indirects_f["},
  {"id":"pay_auto_indirects_f]"},
  {"id":"pay_bal_adj_groups"},
  {"id":"pay_bal_adj_headers"},
  {"id":"pay_bal_adj_line_actions"},
  {"id":"pay_bal_adj_lines"},
  {"id":"pay_bal_adj_values"},
  {"id":"pay_bal_att_defaults"},
  {"id":"pay_bal_att_defaults["},
  {"id":"pay_bal_att_defaults]"},
  {"id":"pay_bal_att_definitions"},
  {"id":"pay_bal_att_definitions_tl"},
  {"id":"pay_bal_att_definitions_tl["},
  {"id":"pay_bal_att_definitions_tl]"},
  {"id":"pay_bal_att_definitions["},
  {"id":"pay_bal_att_definitions]"},
  {"id":"pay_bal_batch_headers"},
  {"id":"pay_bal_batch_lines"},
  {"id":"pay_bal_classifications"},
  {"id":"pay_bal_classifications["},
  {"id":"pay_bal_classifications]"},
  {"id":"pay_bal_excep_report_entries"},
  {"id":"pay_bal_exception_reports_b"},
  {"id":"pay_bal_exception_reports_tl"},
  {"id":"pay_bal_exceptions_b"},
  {"id":"pay_bal_exceptions_tl"},
  {"id":"pay_bal_grp_inclusions"},
  {"id":"pay_bal_grp_inclusions["},
  {"id":"pay_bal_grp_inclusions]"},
  {"id":"pay_bal_grp_usage_items"},
  {"id":"pay_bal_grp_usage_items["},
  {"id":"pay_bal_grp_usage_items]"},
  {"id":"pay_bal_grp_usages"},
  {"id":"pay_bal_grp_usages_tl"},
  {"id":"pay_bal_grp_usages_tl["},
  {"id":"pay_bal_grp_usages_tl]"},
  {"id":"pay_bal_grp_usages["},
  {"id":"pay_bal_grp_usages]"},
  {"id":"pay_balance_attributes"},
  {"id":"pay_balance_attributes["},
  {"id":"pay_balance_attributes]"},
  {"id":"pay_balance_categories_f"},
  {"id":"pay_balance_categories_f["},
  {"id":"pay_balance_categories_f]"},
  {"id":"pay_balance_categories_tl"},
  {"id":"pay_balance_categories_tl["},
  {"id":"pay_balance_categories_tl]"},
  {"id":"pay_balance_dimensions"},
  {"id":"pay_balance_dimensions["},
  {"id":"pay_balance_dimensions]"},
  {"id":"pay_balance_feeds_f"},
  {"id":"pay_balance_feeds_f["},
  {"id":"pay_balance_feeds_f]"},
  {"id":"pay_balance_groups"},
  {"id":"pay_balance_groups_tl"},
  {"id":"pay_balance_groups_tl["},
  {"id":"pay_balance_groups_tl]"},
  {"id":"pay_balance_groups["},
  {"id":"pay_balance_groups]"},
  {"id":"pay_balance_logs"},
  {"id":"pay_balance_types"},
  {"id":"pay_balance_types_tl"},
  {"id":"pay_balance_types_tl["},
  {"id":"pay_balance_types_tl]"},
  {"id":"pay_balance_types["},
  {"id":"pay_balance_types]"},
  {"id":"pay_balance_validation"},
  {"id":"pay_bank_account_prenotes"},
  {"id":"pay_batch_headers"},
  {"id":"pay_batch_line_values"},
  {"id":"pay_batch_lines"},
  {"id":"pay_calc_methods_f"},
  {"id":"pay_calc_methods_tl"},
  {"id":"pay_calc_parts_f"},
  {"id":"pay_calc_parts_f["},
  {"id":"pay_calc_parts_f]"},
  {"id":"pay_calc_parts_tl"},
  {"id":"pay_calc_parts_tl["},
  {"id":"pay_calc_parts_tl]"},
  {"id":"pay_calc_types"},
  {"id":"pay_calc_types_tl"},
  {"id":"pay_calculation_units_f"},
  {"id":"pay_calculation_units_f["},
  {"id":"pay_calculation_units_f]"},
  {"id":"pay_ce_transactions"},
  {"id":"pay_checklist_instances"},
  {"id":"pay_checklists"},
  {"id":"pay_checklists_tl"},
  {"id":"pay_checklists_tl["},
  {"id":"pay_checklists_tl]"},
  {"id":"pay_checklists["},
  {"id":"pay_checklists]"},
  {"id":"pay_chklst_annotations"},
  {"id":"pay_chklst_annotations_tl"},
  {"id":"pay_chunk_status"},
  {"id":"pay_cir_data_backup_glb_trx"},
  {"id":"pay_coin_breakdowns"},
  {"id":"pay_connected_flows"},
  {"id":"pay_consolidation_sets"},
  {"id":"pay_context_usages"},
  {"id":"pay_context_usages_tl"},
  {"id":"pay_context_usages_tl["},
  {"id":"pay_context_usages_tl]"},
  {"id":"pay_context_usages["},
  {"id":"pay_context_usages]"},
  {"id":"pay_contrib_payments"},
  {"id":"pay_cost_adjust_lines"},
  {"id":"pay_cost_adjustments"},
  {"id":"pay_cost_alloc_accounts"},
  {"id":"pay_cost_alloc_keyflex"},
  {"id":"pay_cost_allocations_f"},
  {"id":"pay_cost_classifications"},
  {"id":"pay_cost_classifications_tl"},
  {"id":"pay_cost_info_f"},
  {"id":"pay_costs"},
  {"id":"pay_cust_objects"},
  {"id":"pay_cust_rules"},
  {"id":"pay_daemon_actions"},
  {"id":"pay_dates"},
  {"id":"pay_datetracked_events"},
  {"id":"pay_datetracked_events["},
  {"id":"pay_datetracked_events]"},
  {"id":"pay_ded_context_usages"},
  {"id":"pay_ded_context_usages["},
  {"id":"pay_ded_context_usages]"},
  {"id":"pay_dedn_report_use"},
  {"id":"pay_deduction_groups"},
  {"id":"pay_deduction_groups_tl"},
  {"id":"pay_deduction_groups_tl["},
  {"id":"pay_deduction_groups_tl]"},
  {"id":"pay_deduction_groups["},
  {"id":"pay_deduction_groups]"},
  {"id":"pay_deduction_types"},
  {"id":"pay_deduction_types_tl"},
  {"id":"pay_deduction_types_tl["},
  {"id":"pay_deduction_types_tl]"},
  {"id":"pay_deduction_types["},
  {"id":"pay_deduction_types]"},
  {"id":"pay_defined_balances"},
  {"id":"pay_defined_balances["},
  {"id":"pay_defined_balances]"},
  {"id":"pay_dim_context_usages"},
  {"id":"pay_dim_context_usages["},
  {"id":"pay_dim_context_usages]"},
  {"id":"pay_dimension_routes"},
  {"id":"pay_dimension_routes["},
  {"id":"pay_dimension_routes]"},
  {"id":"pay_dimension_usages"},
  {"id":"pay_dimension_usages_tl"},
  {"id":"pay_dimension_usages_tl["},
  {"id":"pay_dimension_usages_tl]"},
  {"id":"pay_dimension_usages["},
  {"id":"pay_dimension_usages]"},
  {"id":"pay_dir_card_comp_defs_f"},
  {"id":"pay_dir_card_comp_defs_f["},
  {"id":"pay_dir_card_comp_defs_f]"},
  {"id":"pay_dir_card_comp_defs_tl"},
  {"id":"pay_dir_card_comp_defs_tl["},
  {"id":"pay_dir_card_comp_defs_tl]"},
  {"id":"pay_dir_card_components_f"},
  {"id":"pay_dir_card_components_f_"},
  {"id":"pay_dir_card_definitions"},
  {"id":"pay_dir_card_definitions_tl"},
  {"id":"pay_dir_card_definitions_tl["},
  {"id":"pay_dir_card_definitions_tl]"},
  {"id":"pay_dir_card_definitions["},
  {"id":"pay_dir_card_definitions]"},
  {"id":"pay_dir_card_levels_f"},
  {"id":"pay_dir_card_levels_f["},
  {"id":"pay_dir_card_levels_f]"},
  {"id":"pay_dir_cards_f"},
  {"id":"pay_dir_cards_f_"},
  {"id":"pay_dir_comp_details_f"},
  {"id":"pay_dir_comp_details_f_"},
  {"id":"pay_dir_comp_flex_rships_f"},
  {"id":"pay_dir_comp_flex_rships_f["},
  {"id":"pay_dir_comp_flex_rships_f]"},
  {"id":"pay_dir_comp_flexs_f"},
  {"id":"pay_dir_comp_flexs_f["},
  {"id":"pay_dir_comp_flexs_f]"},
  {"id":"pay_dir_flex_segments_f"},
  {"id":"pay_dir_flex_segments_f["},
  {"id":"pay_dir_flex_segments_f]"},
  {"id":"pay_dir_flex_usages_f"},
  {"id":"pay_dir_flex_usages_f["},
  {"id":"pay_dir_flex_usages_f]"},
  {"id":"pay_dir_override_usages_f"},
  {"id":"pay_dir_override_usages_f["},
  {"id":"pay_dir_override_usages_f]"},
  {"id":"pay_dir_rep_card_usages_f"},
  {"id":"pay_dir_rep_card_usages_f_"},
  {"id":"pay_dir_rep_cards_f"},
  {"id":"pay_dir_rep_cards_f_"},
  {"id":"pay_ele_class_usages_f"},
  {"id":"pay_ele_class_usages_f["},
  {"id":"pay_ele_classifications"},
  {"id":"pay_ele_classifications_tl"},
  {"id":"pay_ele_classifications_tl["},
  {"id":"pay_ele_classifications_tl]"},
  {"id":"pay_ele_classifications["},
  {"id":"pay_ele_classifications]"},
  {"id":"pay_ele_pay_freq_rules"},
  {"id":"pay_ele_security_details"},
  {"id":"pay_ele_security_details_"},
  {"id":"pay_ele_security_profiles"},
  {"id":"pay_ele_security_profiles_"},
  {"id":"pay_ele_tmplt_class_usages"},
  {"id":"pay_ele_tmplt_class_usages_tl"},
  {"id":"pay_ele_tmplt_class_usages_tl["},
  {"id":"pay_ele_tmplt_class_usages_tl]"},
  {"id":"pay_ele_tmplt_class_usages["},
  {"id":"pay_ele_tmplt_class_usages]"},
  {"id":"pay_ele_type_extra_info"},
  {"id":"pay_ele_type_info_types"},
  {"id":"pay_element_criteria"},
  {"id":"pay_element_entries_f"},
  {"id":"pay_element_entries_f_"},
  {"id":"pay_element_entry_values_f"},
  {"id":"pay_element_entry_values_f_"},
  {"id":"pay_element_links_f"},
  {"id":"pay_element_span_usages"},
  {"id":"pay_element_span_usages["},
  {"id":"pay_element_span_usages]"},
  {"id":"pay_element_type_usages_f"},
  {"id":"pay_element_types_f"},
  {"id":"pay_element_types_f["},
  {"id":"pay_element_types_f]"},
  {"id":"pay_element_types_tl"},
  {"id":"pay_element_types_tl["},
  {"id":"pay_element_types_tl]"},
  {"id":"pay_entry_pct_dist"},
  {"id":"pay_entry_proc_details"},
  {"id":"pay_entry_usages"},
  {"id":"pay_event_action_criteria_f"},
  {"id":"pay_event_action_types"},
  {"id":"pay_event_action_types_tl"},
  {"id":"pay_event_action_types_tl["},
  {"id":"pay_event_action_types_tl]"},
  {"id":"pay_event_action_types["},
  {"id":"pay_event_action_types]"},
  {"id":"pay_event_actions_f"},
  {"id":"pay_event_actions_f["},
  {"id":"pay_event_actions_tl"},
  {"id":"pay_event_actions_tl["},
  {"id":"pay_event_group_actions_f"},
  {"id":"pay_event_group_actions_f["},
  {"id":"pay_event_group_usages"},
  {"id":"pay_event_groups"},
  {"id":"pay_event_groups_tl"},
  {"id":"pay_event_groups_tl["},
  {"id":"pay_event_groups_tl]"},
  {"id":"pay_event_groups["},
  {"id":"pay_event_groups]"},
  {"id":"pay_event_people"},
  {"id":"pay_event_qualifiers_f"},
  {"id":"pay_event_qualifiers_f["},
  {"id":"pay_event_qualifiers_f]"},
  {"id":"pay_event_relationships"},
  {"id":"pay_event_temp_proc_actions"},
  {"id":"pay_event_usages"},
  {"id":"pay_event_value_changes_f"},
  {"id":"pay_event_value_changes_f["},
  {"id":"pay_event_value_changes_f]"},
  {"id":"pay_event_value_qual_f"},
  {"id":"pay_event_value_qual_f["},
  {"id":"pay_event_value_qual_f]"},
  {"id":"pay_file_details"},
  {"id":"pay_flow_inst_interactns"},
  {"id":"pay_flow_instances"},
  {"id":"pay_flow_metrics"},
  {"id":"pay_flow_outbound_config"},
  {"id":"pay_flow_param_values"},
  {"id":"pay_flow_parameter_properties"},
  {"id":"pay_flow_parameters"},
  {"id":"pay_flow_parameters_tl"},
  {"id":"pay_flow_parameters_tl["},
  {"id":"pay_flow_parameters_tl]"},
  {"id":"pay_flow_parameters["},
  {"id":"pay_flow_parameters]"},
  {"id":"pay_flow_task_instances"},
  {"id":"pay_flow_task_interactns"},
  {"id":"pay_flow_task_interactns["},
  {"id":"pay_flow_task_interactns]"},
  {"id":"pay_flow_task_notifications"},
  {"id":"pay_flow_task_param_vals"},
  {"id":"pay_flow_task_parameters"},
  {"id":"pay_flow_task_parameters_tl"},
  {"id":"pay_flow_task_parameters_tl["},
  {"id":"pay_flow_task_parameters_tl]"},
  {"id":"pay_flow_task_parameters["},
  {"id":"pay_flow_task_parameters]"},
  {"id":"pay_flow_tasks"},
  {"id":"pay_flow_tasks_tl"},
  {"id":"pay_flow_tasks_tl["},
  {"id":"pay_flow_tasks_tl]"},
  {"id":"pay_flow_tasks["},
  {"id":"pay_flow_tasks]"},
  {"id":"pay_flows"},
  {"id":"pay_flows_tl"},
  {"id":"pay_flows_tl["},
  {"id":"pay_flows_tl]"},
  {"id":"pay_flows["},
  {"id":"pay_flows]"},
  {"id":"pay_flw_security_profile_pays"},
  {"id":"pay_flw_security_profile_pays_"},
  {"id":"pay_flw_security_profiles"},
  {"id":"pay_flw_security_profiles_"},
  {"id":"pay_formula_result_rules_f"},
  {"id":"pay_formula_result_rules_f["},
  {"id":"pay_formula_result_rules_f]"},
  {"id":"pay_freq_rule_periods"},
  {"id":"pay_generic_ana_att_defs"},
  {"id":"pay_generic_ana_att_defs_tl"},
  {"id":"pay_generic_ana_data"},
  {"id":"pay_generic_ana_types"},
  {"id":"pay_generic_ana_types_tl"},
  {"id":"pay_generic_mappings_f"},
  {"id":"pay_geographies"},
  {"id":"pay_geography_boundaries"},
  {"id":"pay_geography_interface"},
  {"id":"pay_geography_spans"},
  {"id":"pay_gi_interface_types"},
  {"id":"pay_gi_mapping_usages"},
  {"id":"pay_gi_mappings"},
  {"id":"pay_grossup_bal_excls"},
  {"id":"pay_input_values_f"},
  {"id":"pay_input_values_f["},
  {"id":"pay_input_values_f]"},
  {"id":"pay_input_values_tl"},
  {"id":"pay_input_values_tl["},
  {"id":"pay_input_values_tl]"},
  {"id":"pay_installed_legislations"},
  {"id":"pay_installed_legislations["},
  {"id":"pay_installed_legislations]"},
  {"id":"pay_iterative_rules_f"},
  {"id":"pay_job_submissions"},
  {"id":"pay_latest_balances"},
  {"id":"pay_leg_update_files"},
  {"id":"pay_leg_update_merge_errors"},
  {"id":"pay_leg_updates"},
  {"id":"pay_leg_updates_tl"},
  {"id":"pay_leg_updates_tl["},
  {"id":"pay_leg_updates_tl]"},
  {"id":"pay_leg_updates["},
  {"id":"pay_leg_updates]"},
  {"id":"pay_legislation_rules"},
  {"id":"pay_legislation_rules["},
  {"id":"pay_legislation_rules]"},
  {"id":"pay_link_input_values_f"},
  {"id":"pay_marked_objects"},
  {"id":"pay_mass_glb_transfer_config"},
  {"id":"pay_message_lines"},
  {"id":"pay_mig_staging_elements"},
  {"id":"pay_mig_std_templ_ques"},
  {"id":"pay_monetary_units"},
  {"id":"pay_monetary_units_tl"},
  {"id":"pay_object_actions"},
  {"id":"pay_object_group_amends"},
  {"id":"pay_object_group_levels"},
  {"id":"pay_object_group_levels["},
  {"id":"pay_object_group_params"},
  {"id":"pay_object_group_params["},
  {"id":"pay_object_group_rules"},
  {"id":"pay_object_group_rules["},
  {"id":"pay_object_group_store"},
  {"id":"pay_object_group_store["},
  {"id":"pay_object_group_store]"},
  {"id":"pay_object_group_type_paras"},
  {"id":"pay_object_group_type_paras["},
  {"id":"pay_object_group_types"},
  {"id":"pay_object_group_types["},
  {"id":"pay_object_groups"},
  {"id":"pay_object_groups_tl"},
  {"id":"pay_object_groups_tl["},
  {"id":"pay_object_groups["},
  {"id":"pay_obsolete"},
  {"id":"pay_old_range_items_f"},
  {"id":"pay_old_range_items_f_"},
  {"id":"pay_old_value_defns_f"},
  {"id":"pay_old_value_defns_f_"},
  {"id":"pay_old_value_defns_tl"},
  {"id":"pay_org_pay_method_usages_f"},
  {"id":"pay_org_pay_methods_f"},
  {"id":"pay_org_pay_methods_tl"},
  {"id":"pay_org_payer_mappings_f"},
  {"id":"pay_pay_relationships_dn"},
  {"id":"pay_pay_relationships_f"},
  {"id":"pay_pay_security_profile_pays"},
  {"id":"pay_pay_security_profile_pays_"},
  {"id":"pay_pay_security_profiles"},
  {"id":"pay_pay_security_profiles_"},
  {"id":"pay_pay_security_profiles["},
  {"id":"pay_payment_costs"},
  {"id":"pay_payment_types"},
  {"id":"pay_payment_types_tl"},
  {"id":"pay_payment_types_tl["},
  {"id":"pay_payment_types["},
  {"id":"pay_payroll_actions"},
  {"id":"pay_payroll_rel_actions"},
  {"id":"pay_people_groups"},
  {"id":"pay_person_pay_methods_f"},
  {"id":"pay_person_pay_methods_f_"},
  {"id":"pay_population_ranges"},
  {"id":"pay_pre_payments"},
  {"id":"pay_process_changes"},
  {"id":"pay_process_events"},
  {"id":"pay_process_timings"},
  {"id":"pay_processes"},
  {"id":"pay_processes["},
  {"id":"pay_purge_objects"},
  {"id":"pay_qualifier_criteria"},
  {"id":"pay_quickpay_exclusions"},
  {"id":"pay_range_defs_f"},
  {"id":"pay_range_defs_f["},
  {"id":"pay_range_defs_f]"},
  {"id":"pay_range_insts_f"},
  {"id":"pay_rate_contributors_f"},
  {"id":"pay_rate_contributors_f["},
  {"id":"pay_rate_contributors_f]"},
  {"id":"pay_rate_definitions_f"},
  {"id":"pay_rate_definitions_f_tl"},
  {"id":"pay_rate_definitions_f_tl["},
  {"id":"pay_rate_definitions_f_tl]"},
  {"id":"pay_rate_definitions_f["},
  {"id":"pay_rate_definitions_f]"},
  {"id":"pay_rate_element_indirects"},
  {"id":"pay_rate_values"},
  {"id":"pay_recorded_requests"},
  {"id":"pay_rel_groups_dn"},
  {"id":"pay_rel_groups_f"},
  {"id":"pay_rel_groups_used"},
  {"id":"pay_rel_type_maps"},
  {"id":"pay_relationship_types"},
  {"id":"pay_relationship_types_tl"},
  {"id":"pay_rep_archive_items"},
  {"id":"pay_rep_cat_components"},
  {"id":"pay_rep_cat_components["},
  {"id":"pay_rep_cat_components]"},
  {"id":"pay_rep_context_usages"},
  {"id":"pay_rep_criteria_f"},
  {"id":"pay_rep_criteria_f["},
  {"id":"pay_rep_criteria_f]"},
  {"id":"pay_rep_format_hierarchy_f"},
  {"id":"pay_rep_format_items_f"},
  {"id":"pay_rep_record_rules_f"},
  {"id":"pay_rep_select_f"},
  {"id":"pay_rep_select_f["},
  {"id":"pay_rep_select_f]"},
  {"id":"pay_report_blocks"},
  {"id":"pay_report_blocks_tl"},
  {"id":"pay_report_blocks_tl["},
  {"id":"pay_report_blocks_tl]"},
  {"id":"pay_report_blocks["},
  {"id":"pay_report_blocks]"},
  {"id":"pay_report_categories"},
  {"id":"pay_report_categories_tl"},
  {"id":"pay_report_categories_tl["},
  {"id":"pay_report_categories_tl]"},
  {"id":"pay_report_categories["},
  {"id":"pay_report_categories]"},
  {"id":"pay_report_definitions"},
  {"id":"pay_report_definitions["},
  {"id":"pay_report_definitions]"},
  {"id":"pay_report_format_maps_f"},
  {"id":"pay_report_format_maps_f["},
  {"id":"pay_report_format_maps_f]"},
  {"id":"pay_report_format_maps_tl"},
  {"id":"pay_report_format_maps_tl["},
  {"id":"pay_report_format_maps_tl]"},
  {"id":"pay_report_format_params"},
  {"id":"pay_report_format_params["},
  {"id":"pay_report_format_params]"},
  {"id":"pay_report_groups"},
  {"id":"pay_report_groups["},
  {"id":"pay_report_groups]"},
  {"id":"pay_report_records_f"},
  {"id":"pay_report_records_f["},
  {"id":"pay_report_records_f]"},
  {"id":"pay_report_records_tl"},
  {"id":"pay_report_records_tl["},
  {"id":"pay_report_records_tl]"},
  {"id":"pay_report_register_gt"},
  {"id":"pay_report_sort_items"},
  {"id":"pay_report_sort_items["},
  {"id":"pay_report_sort_items]"},
  {"id":"pay_report_sort_orders"},
  {"id":"pay_report_sort_orders["},
  {"id":"pay_report_sort_orders]"},
  {"id":"pay_report_sort_types"},
  {"id":"pay_report_sort_types_tl"},
  {"id":"pay_report_sort_types_tl["},
  {"id":"pay_report_sort_types_tl]"},
  {"id":"pay_report_sort_types["},
  {"id":"pay_report_sort_types]"},
  {"id":"pay_report_variables"},
  {"id":"pay_request_actions"},
  {"id":"pay_requests"},
  {"id":"pay_rest_security"},
  {"id":"pay_rest_security_usages"},
  {"id":"pay_rest_security_usages["},
  {"id":"pay_rest_security_usages]"},
  {"id":"pay_rest_vos"},
  {"id":"pay_rest_vos["},
  {"id":"pay_rest_vos]"},
  {"id":"pay_retro_comp_usages"},
  {"id":"pay_retro_comp_usages["},
  {"id":"pay_retro_comp_usages]"},
  {"id":"pay_retro_components"},
  {"id":"pay_retro_definitions"},
  {"id":"pay_retro_defn_comps"},
  {"id":"pay_retro_entries"},
  {"id":"pay_rule_qual_lines_f"},
  {"id":"pay_rule_qualifiers_f"},
  {"id":"pay_rule_result_lines_f"},
  {"id":"pay_rule_results_f"},
  {"id":"pay_rule_segments_f"},
  {"id":"pay_rules_f"},
  {"id":"pay_run_balances"},
  {"id":"pay_run_result_values"},
  {"id":"pay_run_results"},
  {"id":"pay_run_type_org_methods_f"},
  {"id":"pay_run_type_usages_f"},
  {"id":"pay_run_type_usages_f["},
  {"id":"pay_run_types_f"},
  {"id":"pay_run_types_f["},
  {"id":"pay_run_types_tl"},
  {"id":"pay_run_types_tl["},
  {"id":"pay_shdw_dir_card_components_f"},
  {"id":"pay_shdw_dir_comp_details_f"},
  {"id":"pay_shdw_dir_rep_card_usages_f"},
  {"id":"pay_shdw_dir_rep_cards_f"},
  {"id":"pay_shdw_old_range_items_f"},
  {"id":"pay_shdw_old_value_defns_f"},
  {"id":"pay_statistic_context_value_tl"},
  {"id":"pay_statistic_context_values"},
  {"id":"pay_statistic_contexts"},
  {"id":"pay_statistic_contexts_tl"},
  {"id":"pay_statistic_types"},
  {"id":"pay_statistic_types_tl"},
  {"id":"pay_statistics"},
  {"id":"pay_stats_flow_actions"},
  {"id":"pay_status_proc_rules_f"},
  {"id":"pay_status_proc_rules_f["},
  {"id":"pay_status_proc_rules_f]"},
  {"id":"pay_sub_classn_rules_f"},
  {"id":"pay_submit_related_flows"},
  {"id":"pay_task_actions"},
  {"id":"pay_task_actions_tl"},
  {"id":"pay_task_actions_tl["},
  {"id":"pay_task_actions_tl]"},
  {"id":"pay_task_actions["},
  {"id":"pay_task_actions]"},
  {"id":"pay_task_parameters"},
  {"id":"pay_task_parameters_tl"},
  {"id":"pay_task_parameters_tl["},
  {"id":"pay_task_parameters_tl]"},
  {"id":"pay_task_parameters["},
  {"id":"pay_task_parameters]"},
  {"id":"pay_task_properties"},
  {"id":"pay_task_properties_tl"},
  {"id":"pay_task_properties_tl["},
  {"id":"pay_task_properties_tl]"},
  {"id":"pay_task_properties["},
  {"id":"pay_task_properties]"},
  {"id":"pay_task_usage"},
  {"id":"pay_task_usage["},
  {"id":"pay_task_usage]"},
  {"id":"pay_tasks"},
  {"id":"pay_tasks_tl"},
  {"id":"pay_tasks_tl["},
  {"id":"pay_tasks_tl]"},
  {"id":"pay_tasks["},
  {"id":"pay_tasks]"},
  {"id":"pay_taxability_rules_f"},
  {"id":"pay_taxability_rules_f["},
  {"id":"pay_taxability_rules_f]"},
  {"id":"pay_temp_action_information"},
  {"id":"pay_temp_bal_adjustments"},
  {"id":"pay_temp_object_actions"},
  {"id":"pay_temp_payroll_actions"},
  {"id":"pay_template_core_objects"},
  {"id":"pay_templates"},
  {"id":"pay_templates["},
  {"id":"pay_temporal_values"},
  {"id":"pay_time_def_usages"},
  {"id":"pay_time_def_usages["},
  {"id":"pay_time_definitions"},
  {"id":"pay_time_definitions["},
  {"id":"pay_time_depend_values"},
  {"id":"pay_time_period_rules"},
  {"id":"pay_time_period_types"},
  {"id":"pay_time_periods"},
  {"id":"pay_time_spans"},
  {"id":"pay_tmplt_clmn_inst"},
  {"id":"pay_tmplt_clmn_inst_f"},
  {"id":"pay_tmplt_clmn_inst_f["},
  {"id":"pay_tmplt_clmn_inst_f]"},
  {"id":"pay_tmplt_clmn_inst_gt"},
  {"id":"pay_tmplt_clmn_inst_trans_b"},
  {"id":"pay_tmplt_clmn_inst_trans_f"},
  {"id":"pay_tmplt_clmn_inst_trans_f_t["},
  {"id":"pay_tmplt_clmn_inst_trans_f_t]"},
  {"id":"pay_tmplt_clmn_inst_trans_f_tl"},
  {"id":"pay_tmplt_clmn_inst_trans_f["},
  {"id":"pay_tmplt_clmn_inst_trans_f]"},
  {"id":"pay_tmplt_clmn_inst_trans_tl"},
  {"id":"pay_tmplt_col_info"},
  {"id":"pay_tmplt_col_info["},
  {"id":"pay_tmplt_col_info]"},
  {"id":"pay_tmplt_dsgn_ptrn"},
  {"id":"pay_tmplt_ent_rule_usgs"},
  {"id":"pay_tmplt_ent_rule_usgs_f"},
  {"id":"pay_tmplt_ent_rule_usgs_f["},
  {"id":"pay_tmplt_ent_rule_usgs_f]"},
  {"id":"pay_tmplt_exclude_list_gt"},
  {"id":"pay_tmplt_fun_areas"},
  {"id":"pay_tmplt_ptrn_ent_usgs"},
  {"id":"pay_tmplt_ptrn_rule_usgs"},
  {"id":"pay_tmplt_ptrn_select"},
  {"id":"pay_tmplt_row_inst"},
  {"id":"pay_tmplt_row_inst_f"},
  {"id":"pay_tmplt_row_inst_f["},
  {"id":"pay_tmplt_row_inst_f]"},
  {"id":"pay_tmplt_row_inst_gt"},
  {"id":"pay_tmplt_rule_dependencies"},
  {"id":"pay_tmplt_rule_dependencies_f"},
  {"id":"pay_tmplt_rule_dependencies_f["},
  {"id":"pay_tmplt_rule_dependencies_f]"},
  {"id":"pay_tmplt_rule_gr_usages"},
  {"id":"pay_tmplt_rule_gr_usages_f"},
  {"id":"pay_tmplt_rule_gr_usages_f["},
  {"id":"pay_tmplt_rule_gr_usages_f]"},
  {"id":"pay_tmplt_rule_groups"},
  {"id":"pay_tmplt_rule_groups_f"},
  {"id":"pay_tmplt_rule_groups_f_tl"},
  {"id":"pay_tmplt_rule_groups_f_tl["},
  {"id":"pay_tmplt_rule_groups_f_tl]"},
  {"id":"pay_tmplt_rule_groups_f["},
  {"id":"pay_tmplt_rule_groups_f]"},
  {"id":"pay_tmplt_rule_groups_tl"},
  {"id":"pay_tmplt_rule_values"},
  {"id":"pay_tmplt_rules"},
  {"id":"pay_tmplt_rules_f"},
  {"id":"pay_tmplt_rules_f_tl"},
  {"id":"pay_tmplt_rules_f_tl["},
  {"id":"pay_tmplt_rules_f_tl]"},
  {"id":"pay_tmplt_rules_f["},
  {"id":"pay_tmplt_rules_f]"},
  {"id":"pay_tmplt_rules_tl"},
  {"id":"pay_tmplt_table_info"},
  {"id":"pay_tmplt_table_info["},
  {"id":"pay_tmplt_table_info]"},
  {"id":"pay_tmplt_table_relate"},
  {"id":"pay_tmplt_table_relate["},
  {"id":"pay_tmplt_version_f"},
  {"id":"pay_tmplt_version_f_tl"},
  {"id":"pay_tmplt_version_f_tl["},
  {"id":"pay_tmplt_version_f_tl]"},
  {"id":"pay_tmplt_version_f["},
  {"id":"pay_tmplt_version_f]"},
  {"id":"pay_upgrade_legislations"},
  {"id":"pay_upgrade_object_status"},
  {"id":"pay_upgrade_objects"},
  {"id":"pay_upgrade_objects_tl"},
  {"id":"pay_upgrade_objects_tl["},
  {"id":"pay_upgrade_objects_tl]"},
  {"id":"pay_upgrade_objects["},
  {"id":"pay_upgrade_objects]"},
  {"id":"pay_used_in_process"},
  {"id":"pay_value_criteria_levels_f"},
  {"id":"pay_value_criteria_levels_tl"},
  {"id":"pay_value_defs_f"},
  {"id":"pay_value_defs_f["},
  {"id":"pay_value_defs_f]"},
  {"id":"pay_value_defs_tl"},
  {"id":"pay_value_defs_tl["},
  {"id":"pay_value_defs_tl]"},
  {"id":"pay_value_groups"},
  {"id":"pay_value_groups_tl"},
  {"id":"pay_value_groups_tl["},
  {"id":"pay_value_groups_tl]"},
  {"id":"pay_value_groups["},
  {"id":"pay_value_groups]"},
  {"id":"pay_value_insts_f"},
  {"id":"pay_value_usages"},
  {"id":"pay_value_usages["},
  {"id":"pay_value_usages]"},
  {"id":"pay_vbc_criteria_defs"},
  {"id":"pay_vbc_criteria_defs_tl"},
  {"id":"pay_vbc_criteria_defs_tl["},
  {"id":"pay_vbc_criteria_defs_tl]"},
  {"id":"pay_vbc_criteria_defs["},
  {"id":"pay_vbc_criteria_defs]"},
  {"id":"pay_vbc_definitions"},
  {"id":"pay_vbc_definitions_tl"},
  {"id":"pay_vbc_definitions_tl["},
  {"id":"pay_vbc_definitions_tl]"},
  {"id":"pay_vbc_definitions["},
  {"id":"pay_vbc_definitions]"},
  {"id":"pay_vbc_value_idents"},
  {"id":"pay_vbc_value_idents_tl"},
  {"id":"pay_vendor_mappings"},
  {"id":"pay_vendor_mappings["},
  {"id":"pay_vendor_mappings]"},
  {"id":"pay_xla_events"},
  {"id":"per_abs_attendance_reasons"},
  {"id":"per_abs_attendance_types_tl"},
  {"id":"per_absence_attendance_types_b"},
  {"id":"per_absence_attendances"},
  {"id":"per_absence_cases"},
  {"id":"per_accrual_bands"},
  {"id":"per_accrual_calc_rules"},
  {"id":"per_accrual_plans_b"},
  {"id":"per_accrual_plans_tl"},
  {"id":"per_acl_exclusions"},
  {"id":"per_act_occurrence_extra_info"},
  {"id":"per_action_headers_m"},
  {"id":"per_action_occurrences"},
  {"id":"per_action_occurrences_"},
  {"id":"per_action_reason_usages"},
  {"id":"per_action_reason_usages["},
  {"id":"per_action_reasons_b"},
  {"id":"per_action_reasons_b["},
  {"id":"per_action_reasons_tl"},
  {"id":"per_action_reasons_tl["},
  {"id":"per_action_role_mapping"},
  {"id":"per_action_types_b"},
  {"id":"per_action_types_tl"},
  {"id":"per_actions_b"},
  {"id":"per_actions_b["},
  {"id":"per_actions_tl"},
  {"id":"per_actions_tl["},
  {"id":"per_addresses"},
  {"id":"per_addresses_f"},
  {"id":"per_addresses_f_"},
  {"id":"per_all_assignments_m"},
  {"id":"per_all_assignments_m_"},
  {"id":"per_all_people_f"},
  {"id":"per_all_people_f_"},
  {"id":"per_alloc_chklst_contacts"},
  {"id":"per_alloc_chklst_contents"},
  {"id":"per_alloc_task_com_cndn_crit"},
  {"id":"per_alloc_task_com_condns_b"},
  {"id":"per_alloc_task_com_condns_tl"},
  {"id":"per_alloc_task_comments"},
  {"id":"per_alloc_task_notifs"},
  {"id":"per_alloc_task_performers"},
  {"id":"per_allocated_checklists"},
  {"id":"per_allocated_checklists_"},
  {"id":"per_allocated_checklists_tl"},
  {"id":"per_allocated_checklists_tl_"},
  {"id":"per_allocated_tasks"},
  {"id":"per_allocated_tasks_"},
  {"id":"per_allocated_tasks_tl"},
  {"id":"per_allocated_tasks_tl_"},
  {"id":"per_aor_asg_dn"},
  {"id":"per_aor_asg_gt"},
  {"id":"per_aor_auto_prov_history"},
  {"id":"per_aor_auto_provision"},
  {"id":"per_aor_autoprovision_gt"},
  {"id":"per_aor_rep_log"},
  {"id":"per_aor_rep_stmts"},
  {"id":"per_aor_res_dn"},
  {"id":"per_aor_template"},
  {"id":"per_aor_template_criteria"},
  {"id":"per_aor_template_details"},
  {"id":"per_asg_absence_recording"},
  {"id":"per_asg_eligible_jobs"},
  {"id":"per_asg_eligible_jobs_"},
  {"id":"per_asg_representatives"},
  {"id":"per_asg_responsibilities"},
  {"id":"per_asg_sec_matrlzed_cache"},
  {"id":"per_assign_grade_steps_f"},
  {"id":"per_assign_grade_steps_f_"},
  {"id":"per_assign_work_measures_f"},
  {"id":"per_assign_work_measures_f_"},
  {"id":"per_assignment_day_absences"},
  {"id":"per_assignment_extensions_f"},
  {"id":"per_assignment_extra_info_m"},
  {"id":"per_assignment_extra_info_m_"},
  {"id":"per_assignment_notes"},
  {"id":"per_assignment_notes_"},
  {"id":"per_assignment_status_types"},
  {"id":"per_assignment_status_types_tl"},
  {"id":"per_assignment_supervisors_f"},
  {"id":"per_assignment_supervisors_f_"},
  {"id":"per_bookings"},
  {"id":"per_business_object_limit"},
  {"id":"per_cal_event_coverage"},
  {"id":"per_calendar_events"},
  {"id":"per_calendar_events_tl"},
  {"id":"per_checklist_actions"},
  {"id":"per_checklist_alloc_criteria"},
  {"id":"per_checklist_allocations"},
  {"id":"per_checklist_allocations_tl"},
  {"id":"per_checklist_batch_actions"},
  {"id":"per_checklist_batch_chunks"},
  {"id":"per_checklist_batch_criteria"},
  {"id":"per_checklist_categories_b"},
  {"id":"per_checklist_categories_b["},
  {"id":"per_checklist_categories_b]"},
  {"id":"per_checklist_categories_tl"},
  {"id":"per_checklist_categories_tl["},
  {"id":"per_checklist_categories_tl]"},
  {"id":"per_checklist_contacts"},
  {"id":"per_checklist_contents"},
  {"id":"per_checklist_conversations"},
  {"id":"per_checklist_exceptions"},
  {"id":"per_checklist_integrations"},
  {"id":"per_checklist_periods"},
  {"id":"per_checklist_role_maps"},
  {"id":"per_checklist_schedules"},
  {"id":"per_checklist_slots"},
  {"id":"per_checklist_task_notifs"},
  {"id":"per_checklist_tasks_b"},
  {"id":"per_checklist_tasks_tl"},
  {"id":"per_checklist_usages"},
  {"id":"per_checklists_b"},
  {"id":"per_checklists_b["},
  {"id":"per_checklists_tl"},
  {"id":"per_chk_action_criteria"},
  {"id":"per_chk_action_occ_items"},
  {"id":"per_chk_action_occurrences"},
  {"id":"per_chk_alloc_results"},
  {"id":"per_chk_alloc_task_results"},
  {"id":"per_chk_arch_alloc_contacts"},
  {"id":"per_chk_arch_alloc_contents"},
  {"id":"per_chk_arch_alloc_task_perf"},
  {"id":"per_chk_arch_alloc_tasks"},
  {"id":"per_chk_arch_alloc_tasks_tl"},
  {"id":"per_chk_arch_alloc_tsk_ntfs"},
  {"id":"per_chk_arch_allocation_tl"},
  {"id":"per_chk_arch_allocations"},
  {"id":"per_chk_category_role_maps"},
  {"id":"per_chk_configurations"},
  {"id":"per_chk_content_defns_b"},
  {"id":"per_chk_content_defns_tl"},
  {"id":"per_chk_content_items_b"},
  {"id":"per_chk_content_items_tl"},
  {"id":"per_chk_guided_responses"},
  {"id":"per_chk_obj_group_items"},
  {"id":"per_chk_object_groups"},
  {"id":"per_chk_survey_qstn_summary"},
  {"id":"per_chk_survey_resp_summary"},
  {"id":"per_chk_survey_responses"},
  {"id":"per_chk_task_com_condn_crit"},
  {"id":"per_chk_task_com_condns_b"},
  {"id":"per_chk_task_com_condns_tl"},
  {"id":"per_chk_task_conditions"},
  {"id":"per_chk_task_condn_crit"},
  {"id":"per_citizenships"},
  {"id":"per_citizenships_"},
  {"id":"per_click_history"},
  {"id":"per_col_agreements_b"},
  {"id":"per_col_agreements_f"},
  {"id":"per_col_agreements_f_tl"},
  {"id":"per_col_agreements_tl"},
  {"id":"per_col_agrs_extra_info_f"},
  {"id":"per_comparison_sets_b"},
  {"id":"per_comparison_sets_tl"},
  {"id":"per_connection_links"},
  {"id":"per_contact_extra_info_f"},
  {"id":"per_contact_relships_f"},
  {"id":"per_contact_relships_f_"},
  {"id":"per_contracts_f"},
  {"id":"per_contracts_f_"},
  {"id":"per_country_sec_prof_countrie_"},
  {"id":"per_country_sec_prof_countries"},
  {"id":"per_country_security_profiles"},
  {"id":"per_country_security_profiles_"},
  {"id":"per_data_asgnmnts_rule_dtl"},
  {"id":"per_data_sec_compute_acl"},
  {"id":"per_data_sec_process_dtls"},
  {"id":"per_data_sec_process_dtls_"},
  {"id":"per_delegated_roles"},
  {"id":"per_delegated_roles_"},
  {"id":"per_dept_tree_node"},
  {"id":"per_dept_tree_node_cf"},
  {"id":"per_dept_tree_node_rf"},
  {"id":"per_diag_bkp_rows"},
  {"id":"per_disabilities_f"},
  {"id":"per_disabilities_f_"},
  {"id":"per_doc_type_sec_prof_doctype_"},
  {"id":"per_doc_type_sec_prof_doctypes"},
  {"id":"per_doc_type_security_profile_"},
  {"id":"per_doc_type_security_profiles"},
  {"id":"per_drivers_license_types"},
  {"id":"per_drivers_licenses"},
  {"id":"per_drivers_licenses_"},
  {"id":"per_edit_name_setup_b"},
  {"id":"per_edit_name_setup_tl"},
  {"id":"per_email_addresses"},
  {"id":"per_email_addresses_"},
  {"id":"per_empl_child_txn_data"},
  {"id":"per_empl_configurations"},
  {"id":"per_empl_configurations_"},
  {"id":"per_empl_custom_lov_sql"},
  {"id":"per_empl_delete_txn_data"},
  {"id":"per_empl_offer_hr_track"},
  {"id":"per_empl_transactions"},
  {"id":"per_esign_configuration"},
  {"id":"per_ethnicities"},
  {"id":"per_ethnicities_"},
  {"id":"per_event_process_stage"},
  {"id":"per_event_process_stage_detail"},
  {"id":"per_events"},
  {"id":"per_exclusion_rule_dtls"},
  {"id":"per_exclusion_rule_dtls_"},
  {"id":"per_exclusion_rules"},
  {"id":"per_exclusion_rules_"},
  {"id":"per_ext_actions"},
  {"id":"per_ext_app_identifiers"},
  {"id":"per_ext_audit_actions"},
  {"id":"per_ext_block_links"},
  {"id":"per_ext_block_links["},
  {"id":"per_ext_block_links]"},
  {"id":"per_ext_bus_objects_b"},
  {"id":"per_ext_bus_objects_tl"},
  {"id":"per_ext_data_elements_b"},
  {"id":"per_ext_data_elements_b["},
  {"id":"per_ext_data_elements_b]"},
  {"id":"per_ext_data_elements_tl"},
  {"id":"per_ext_data_elements_tl["},
  {"id":"per_ext_data_elements_tl]"},
  {"id":"per_ext_def_samples"},
  {"id":"per_ext_definitions_b"},
  {"id":"per_ext_definitions_b["},
  {"id":"per_ext_definitions_b]"},
  {"id":"per_ext_definitions_tl"},
  {"id":"per_ext_definitions_tl["},
  {"id":"per_ext_definitions_tl]"},
  {"id":"per_ext_delivery_option_dtls"},
  {"id":"per_ext_delivery_option_dtls["},
  {"id":"per_ext_delivery_option_dtls]"},
  {"id":"per_ext_delivery_options_b"},
  {"id":"per_ext_delivery_options_b["},
  {"id":"per_ext_delivery_options_b]"},
  {"id":"per_ext_delivery_options_tl"},
  {"id":"per_ext_delivery_options_tl["},
  {"id":"per_ext_delivery_options_tl]"},
  {"id":"per_ext_dict_attribute"},
  {"id":"per_ext_dict_dbis"},
  {"id":"per_ext_dict_object"},
  {"id":"per_ext_dict_ue_bus_objects"},
  {"id":"per_ext_dict_ues"},
  {"id":"per_ext_dict_ues["},
  {"id":"per_ext_dict_ues]"},
  {"id":"per_ext_future_run_pattern"},
  {"id":"per_ext_lrg_obj_processes"},
  {"id":"per_ext_parameters_b"},
  {"id":"per_ext_parameters_b["},
  {"id":"per_ext_parameters_b]"},
  {"id":"per_ext_parameters_tl"},
  {"id":"per_ext_parameters_tl["},
  {"id":"per_ext_parameters_tl]"},
  {"id":"per_ext_properties"},
  {"id":"per_ext_replacements"},
  {"id":"per_ext_replacements["},
  {"id":"per_ext_type_grp_b"},
  {"id":"per_ext_type_grp_tl"},
  {"id":"per_ext_type_params_b"},
  {"id":"per_ext_type_params_b["},
  {"id":"per_ext_type_params_b]"},
  {"id":"per_ext_type_params_tl"},
  {"id":"per_ext_type_params_tl["},
  {"id":"per_ext_type_params_tl]"},
  {"id":"per_ext_types_b"},
  {"id":"per_ext_types_b["},
  {"id":"per_ext_types_b]"},
  {"id":"per_ext_types_tl"},
  {"id":"per_ext_types_tl["},
  {"id":"per_ext_types_tl]"},
  {"id":"per_ext_ucm_purge_doc"},
  {"id":"per_ext_ue_dbi_mapping"},
  {"id":"per_flex_mapping_usages"},
  {"id":"per_flex_segment_mappings"},
  {"id":"per_gen_data_role_profiles"},
  {"id":"per_gen_data_role_profiles_"},
  {"id":"per_generated_data_roles"},
  {"id":"per_generated_data_roles_"},
  {"id":"per_geo_tree_node"},
  {"id":"per_geo_tree_node_rf"},
  {"id":"per_geo_tree_node["},
  {"id":"per_grade_extra_info_f"},
  {"id":"per_grade_ladder_leg_f"},
  {"id":"per_grade_ladders_f"},
  {"id":"per_grade_ladders_f_"},
  {"id":"per_grade_ladders_f_tl"},
  {"id":"per_grade_ladders_f_tl_"},
  {"id":"per_grade_leg_f"},
  {"id":"per_grade_sec_prof_grd_ladders"},
  {"id":"per_grade_sec_profile_grades"},
  {"id":"per_grade_security_profiles"},
  {"id":"per_grade_step_leg_f"},
  {"id":"per_grade_steps_f"},
  {"id":"per_grade_steps_f_"},
  {"id":"per_grade_steps_f_tl"},
  {"id":"per_grade_steps_f_tl_"},
  {"id":"per_grades_f"},
  {"id":"per_grades_f_"},
  {"id":"per_grades_f_tl"},
  {"id":"per_grades_f_tl_"},
  {"id":"per_grades_in_ladders_f"},
  {"id":"per_grades_in_ladders_f_"},
  {"id":"per_images"},
  {"id":"per_images_"},
  {"id":"per_incr_key_prsn_gt"},
  {"id":"per_info_types_b"},
  {"id":"per_info_types_tl"},
  {"id":"per_instance_set_mappings"},
  {"id":"per_instance_set_mappings["},
  {"id":"per_instance_set_mappings]"},
  {"id":"per_interface_regions"},
  {"id":"per_intg_inbound_data"},
  {"id":"per_intg_inbound_details"},
  {"id":"per_intg_outbound_data"},
  {"id":"per_intg_outbound_error"},
  {"id":"per_intg_outbound_success"},
  {"id":"per_intg_taleo_export_m"},
  {"id":"per_intg_user_cand_map"},
  {"id":"per_job_evaluations"},
  {"id":"per_job_evaluations_"},
  {"id":"per_job_extra_info_f"},
  {"id":"per_job_extra_info_f_"},
  {"id":"per_job_family_f"},
  {"id":"per_job_family_f_"},
  {"id":"per_job_family_f_tl"},
  {"id":"per_job_family_f_tl_"},
  {"id":"per_job_family_sub_families_f"},
  {"id":"per_job_family_sub_families_f_"},
  {"id":"per_job_leg_f"},
  {"id":"per_job_leg_f_"},
  {"id":"per_job_sec_prof_job_families"},
  {"id":"per_job_sec_prof_job_functions"},
  {"id":"per_job_sec_profile_jobs"},
  {"id":"per_job_security_profiles"},
  {"id":"per_job_temp_users"},
  {"id":"per_jobs_eit_category"},
  {"id":"per_jobs_eit_category_"},
  {"id":"per_jobs_f"},
  {"id":"per_jobs_f_"},
  {"id":"per_jobs_f_tl"},
  {"id":"per_jobs_f_tl_"},
  {"id":"per_keywords"},
  {"id":"per_keywords_dyn_gt"},
  {"id":"per_keywords_sh"},
  {"id":"per_ldap_data_asgns"},
  {"id":"per_ldap_requests"},
  {"id":"per_ldap_role_attr"},
  {"id":"per_ldap_role_memberships"},
  {"id":"per_ldap_roles"},
  {"id":"per_ldap_user_attr"},
  {"id":"per_ldap_users"},
  {"id":"per_ldg_security_profile_ldgs"},
  {"id":"per_ldg_security_profile_ldgs_"},
  {"id":"per_ldg_security_profiles"},
  {"id":"per_ldg_security_profiles_"},
  {"id":"per_legislative_data_groups"},
  {"id":"per_legislative_data_groups_tl"},
  {"id":"per_loc_address_usages_f"},
  {"id":"per_loc_address_usages_f_"},
  {"id":"per_loc_eit_category"},
  {"id":"per_loc_eit_category_"},
  {"id":"per_loc_sec_profile_locations"},
  {"id":"per_loc_sec_profile_locations_"},
  {"id":"per_location_details_f"},
  {"id":"per_location_details_f_"},
  {"id":"per_location_details_f_tl"},
  {"id":"per_location_details_f_tl_"},
  {"id":"per_location_extra_info_f"},
  {"id":"per_location_extra_info_f_"},
  {"id":"per_location_leg_f"},
  {"id":"per_location_leg_f_"},
  {"id":"per_location_security_profile_"},
  {"id":"per_location_security_profiles"},
  {"id":"per_locations"},
  {"id":"per_locations_"},
  {"id":"per_ma_assignment_flex"},
  {"id":"per_manager_hrchy_cf"},
  {"id":"per_manager_hrchy_dn"},
  {"id":"per_manager_hrchy_dn_split"},
  {"id":"per_manager_hrchy_reportees_dn"},
  {"id":"per_mass_action_header"},
  {"id":"per_mass_action_lines"},
  {"id":"per_mass_error_lines"},
  {"id":"per_mass_line_fut_updates"},
  {"id":"per_medical_assessments"},
  {"id":"per_name_styles_b"},
  {"id":"per_name_styles_tl"},
  {"id":"per_national_identifiers"},
  {"id":"per_national_identifiers_"},
  {"id":"per_nudge_archives"},
  {"id":"per_nudge_channel_details"},
  {"id":"per_nudge_chnl_dtl_archives"},
  {"id":"per_nudge_event_occurrences"},
  {"id":"per_nudge_plan_criteria"},
  {"id":"per_nudge_plan_exec_stats"},
  {"id":"per_nudge_plan_executions"},
  {"id":"per_nudge_plan_ndg_chnls_b"},
  {"id":"per_nudge_plan_ndg_chnls_tl"},
  {"id":"per_nudge_plan_nudges_b"},
  {"id":"per_nudge_plan_nudges_tl"},
  {"id":"per_nudge_plan_objects"},
  {"id":"per_nudge_plan_population"},
  {"id":"per_nudge_plans_b"},
  {"id":"per_nudge_plans_tl"},
  {"id":"per_nudges"},
  {"id":"per_obj_nudge_archives"},
  {"id":"per_object_nudges"},
  {"id":"per_org_sec_profile_classes"},
  {"id":"per_org_sec_profile_classes_"},
  {"id":"per_org_sec_profile_orgs"},
  {"id":"per_org_sec_profile_orgs_"},
  {"id":"per_org_security_profiles"},
  {"id":"per_org_security_profiles_"},
  {"id":"per_org_security_profiles["},
  {"id":"per_org_tree_node"},
  {"id":"per_org_tree_node_cf"},
  {"id":"per_org_tree_node_rf"},
  {"id":"per_passports"},
  {"id":"per_passports_"},
  {"id":"per_pay_scale_leg"},
  {"id":"per_pay_scale_point_leg"},
  {"id":"per_pay_scale_points"},
  {"id":"per_pay_scale_points_tl"},
  {"id":"per_pay_scales"},
  {"id":"per_pay_scales_tl"},
  {"id":"per_people_extra_info_f"},
  {"id":"per_people_extra_info_f_"},
  {"id":"per_people_groups"},
  {"id":"per_people_groups_"},
  {"id":"per_people_legislative_f"},
  {"id":"per_people_legislative_f_"},
  {"id":"per_periods_of_service"},
  {"id":"per_periods_of_service_"},
  {"id":"per_person_addr_usages_f"},
  {"id":"per_person_addr_usages_f_"},
  {"id":"per_person_dlvry_methods"},
  {"id":"per_person_dlvry_methods_"},
  {"id":"per_person_loc_flow_config"},
  {"id":"per_person_names_f"},
  {"id":"per_person_names_f_"},
  {"id":"per_person_relationships"},
  {"id":"per_person_sec_prof_mgr_types"},
  {"id":"per_person_sec_prof_mgr_types_"},
  {"id":"per_person_sec_prof_per_types"},
  {"id":"per_person_sec_prof_per_types_"},
  {"id":"per_person_sec_prof_per_types["},
  {"id":"per_person_sec_prof_per_types]"},
  {"id":"per_person_security_profiles"},
  {"id":"per_person_security_profiles_"},
  {"id":"per_person_security_profiles["},
  {"id":"per_person_security_profiles]"},
  {"id":"per_person_type_usages_m"},
  {"id":"per_person_type_usages_m_"},
  {"id":"per_person_types"},
  {"id":"per_person_types_tl"},
  {"id":"per_persons"},
  {"id":"per_persons_"},
  {"id":"per_phones"},
  {"id":"per_phones_"},
  {"id":"per_portrait_card_config"},
  {"id":"per_portrait_content_b"},
  {"id":"per_portrait_content_tl"},
  {"id":"per_portrait_messages_b"},
  {"id":"per_portrait_messages_tl"},
  {"id":"per_portrait_preferences"},
  {"id":"per_pos_eit_category"},
  {"id":"per_pos_eit_category_"},
  {"id":"per_pos_flatten_incr_gt"},
  {"id":"per_pos_funding_positions_f"},
  {"id":"per_pos_funding_positions_f_"},
  {"id":"per_pos_hrchy_ancestors_gt"},
  {"id":"per_pos_hrchy_descendants_gt"},
  {"id":"per_pos_sec_profile_positions"},
  {"id":"per_pos_sec_profile_positions_"},
  {"id":"per_pos_secprf_aorscope"},
  {"id":"per_pos_secprf_aorscope_"},
  {"id":"per_pos_tree_node"},
  {"id":"per_pos_tree_node_cf"},
  {"id":"per_pos_tree_node_rf"},
  {"id":"per_position_budgets"},
  {"id":"per_position_budgets_"},
  {"id":"per_position_budgets_tl"},
  {"id":"per_position_budgets_tl_"},
  {"id":"per_position_extra_info_f"},
  {"id":"per_position_extra_info_f_"},
  {"id":"per_position_hierarchy_f"},
  {"id":"per_position_hierarchy_f_"},
  {"id":"per_position_hrchy_rf"},
  {"id":"per_position_hrchy_rf_sh"},
  {"id":"per_position_leg_f"},
  {"id":"per_position_leg_f_"},
  {"id":"per_position_pending_txns"},
  {"id":"per_position_security_profile_"},
  {"id":"per_position_security_profiles"},
  {"id":"per_prev_job_extra_info"},
  {"id":"per_previous_employers"},
  {"id":"per_previous_job_usages"},
  {"id":"per_previous_jobs"},
  {"id":"per_prsn_sec_matrlzed_cache"},
  {"id":"per_prsn_sec_prof_aor_scopes"},
  {"id":"per_prsn_sec_prof_aor_scopes_"},
  {"id":"per_prsn_sec_prof_exclusions"},
  {"id":"per_prsn_sec_prof_exclusions_"},
  {"id":"per_public_prsn_sec_prof_dtls"},
  {"id":"per_public_prsn_sec_prof_dtls_"},
  {"id":"per_public_prsn_sec_profiles"},
  {"id":"per_public_prsn_sec_profiles_"},
  {"id":"per_rate_values_f"},
  {"id":"per_rate_values_f_"},
  {"id":"per_rates_f"},
  {"id":"per_rates_f_"},
  {"id":"per_rates_f_tl"},
  {"id":"per_rates_f_tl_"},
  {"id":"per_religions"},
  {"id":"per_religions_"},
  {"id":"per_rep_documents_b"},
  {"id":"per_rep_documents_tl"},
  {"id":"per_rep_level_hierarchy"},
  {"id":"per_rep_preferences"},
  {"id":"per_requisitions_interface_b"},
  {"id":"per_requisitions_interface_tl"},
  {"id":"per_resource_exceptions"},
  {"id":"per_role_mapping_roles"},
  {"id":"per_role_mappings"},
  {"id":"per_roles_dn"},
  {"id":"per_roles_dn_tl"},
  {"id":"per_sch_inherit_hier"},
  {"id":"per_schedule_assignments"},
  {"id":"per_schedule_assignments_"},
  {"id":"per_schedule_eligibility"},
  {"id":"per_schedule_exceptions"},
  {"id":"per_schedule_exceptions_"},
  {"id":"per_search_filter_mappings"},
  {"id":"per_search_filters"},
  {"id":"per_search_filters_"},
  {"id":"per_search_objects"},
  {"id":"per_sec_prof_pred_templates"},
  {"id":"per_securing_objects"},
  {"id":"per_securing_objects["},
  {"id":"per_securing_objects]"},
  {"id":"per_seniority_dates"},
  {"id":"per_seniority_dates_"},
  {"id":"per_seniority_dates_f"},
  {"id":"per_seniority_dates_f_"},
  {"id":"per_seniority_dates_setup"},
  {"id":"per_seniority_dates_setup_"},
  {"id":"per_seniority_hours"},
  {"id":"per_seniority_hours_"},
  {"id":"per_sensitive_data_audit"},
  {"id":"per_share_info_components"},
  {"id":"per_share_information"},
  {"id":"per_srm_history"},
  {"id":"per_srm_role_memberships"},
  {"id":"per_srm_runs"},
  {"id":"per_taleo_import_results"},
  {"id":"per_task_actions_b"},
  {"id":"per_task_actions_tl"},
  {"id":"per_task_dependencies"},
  {"id":"per_task_lib_com_condn_crit"},
  {"id":"per_task_lib_com_condns_b"},
  {"id":"per_task_lib_com_condns_tl"},
  {"id":"per_task_notifications"},
  {"id":"per_tasks_in_checklist_b"},
  {"id":"per_tasks_in_checklist_tl"},
  {"id":"per_user_history"},
  {"id":"per_user_roles"},
  {"id":"per_users"},
  {"id":"per_valid_grades_f"},
  {"id":"per_valid_grades_f_"},
  {"id":"per_visas_permits_f"},
  {"id":"per_visas_permits_f_"},
  {"id":"per_work_incidents"},
  {"id":"per_working_hour_patterns_f"},
  {"id":"per_working_hour_patterns_f_"},
  {"id":"po_action_history"},
  {"id":"po_agent_accesses"},
  {"id":"po_agent_assignments"},
  {"id":"po_agents"},
  {"id":"po_approved_supplier_list"},
  {"id":"po_asl_attributes"},
  {"id":"po_asl_documents"},
  {"id":"po_asl_statuses"},
  {"id":"po_attr_values_archive"},
  {"id":"po_attr_values_interface"},
  {"id":"po_attr_values_tlp_archive"},
  {"id":"po_attr_values_tlp_interface"},
  {"id":"po_attribute_values"},
  {"id":"po_attribute_values_draft"},
  {"id":"po_attribute_values_tlp"},
  {"id":"po_attribute_values_tlp_draft"},
  {"id":"po_bcea_data"},
  {"id":"po_buyer_assignment_rules"},
  {"id":"po_co_template_attr_values"},
  {"id":"po_co_template_attr_values["},
  {"id":"po_co_templates_b"},
  {"id":"po_co_templates_b["},
  {"id":"po_co_templates_tl"},
  {"id":"po_co_templates_tl["},
  {"id":"po_communication_gt"},
  {"id":"po_config_components"},
  {"id":"po_config_components_archive"},
  {"id":"po_config_components_draft"},
  {"id":"po_distributions_all"},
  {"id":"po_distributions_archive_all"},
  {"id":"po_distributions_draft_all"},
  {"id":"po_distributions_gt"},
  {"id":"po_distributions_interface"},
  {"id":"po_doc_style_headers"},
  {"id":"po_doc_style_lines_b"},
  {"id":"po_doc_style_lines_tl"},
  {"id":"po_doc_style_values"},
  {"id":"po_document_totals_gt"},
  {"id":"po_document_types_all_b"},
  {"id":"po_document_types_all_tl"},
  {"id":"po_event_audit"},
  {"id":"po_ga_org_assign_draft"},
  {"id":"po_ga_org_assign_interface"},
  {"id":"po_ga_org_assignments"},
  {"id":"po_ga_org_assignments_archive"},
  {"id":"po_gen_ai_summary"},
  {"id":"po_hazard_classes_b"},
  {"id":"po_hazard_classes_tl"},
  {"id":"po_headers_all"},
  {"id":"po_headers_archive_all"},
  {"id":"po_headers_draft_all"},
  {"id":"po_headers_gt"},
  {"id":"po_headers_interface"},
  {"id":"po_interface_errors"},
  {"id":"po_line_locations_all"},
  {"id":"po_line_locations_archive_all"},
  {"id":"po_line_locations_draft_all"},
  {"id":"po_line_locations_gt"},
  {"id":"po_line_locations_interface"},
  {"id":"po_line_types_b"},
  {"id":"po_line_types_tl"},
  {"id":"po_lines_all"},
  {"id":"po_lines_archive_all"},
  {"id":"po_lines_draft_all"},
  {"id":"po_lines_gt"},
  {"id":"po_lines_interface"},
  {"id":"po_mass_action_records"},
  {"id":"po_mass_action_requests"},
  {"id":"po_notification_controls"},
  {"id":"po_notification_ctrl_archive"},
  {"id":"po_notification_ctrl_draft"},
  {"id":"po_online_report_text"},
  {"id":"po_online_report_text_gt"},
  {"id":"po_pdoi_progress"},
  {"id":"po_recent_activities"},
  {"id":"po_req_split_lines_gt"},
  {"id":"po_retroprice_gt"},
  {"id":"po_search_suggestions_tlp"},
  {"id":"po_search_suggestions_tlp_gt"},
  {"id":"po_session_gt"},
  {"id":"po_spcl_handling_types_b"},
  {"id":"po_spcl_handling_types_b["},
  {"id":"po_spcl_handling_types_tl"},
  {"id":"po_spcl_handling_types_tl["},
  {"id":"po_staged_document_headers"},
  {"id":"po_staged_document_lines"},
  {"id":"po_system_parameters_all"},
  {"id":"po_un_numbers_b"},
  {"id":"po_un_numbers_tl"},
  {"id":"po_unique_identifier_cont_all"},
  {"id":"po_validation_results_gt"},
  {"id":"po_versions"},
  {"id":"po_wc_headers"},
  {"id":"po_wc_headers_history"},
  {"id":"po_wc_lines"},
  {"id":"po_wc_lines_history"},
  {"id":"poi_approved_results"},
  {"id":"poi_assisted_results"},
  {"id":"poi_batches"},
  {"id":"poi_classification_controls"},
  {"id":"poi_clsf_batches_b"},
  {"id":"poi_clsf_batches_tl"},
  {"id":"poi_dataset_attributes_map"},
  {"id":"poi_dataset_attributes_map["},
  {"id":"poi_dataset_attributes_map]"},
  {"id":"poi_dataset_definitions"},
  {"id":"poi_dataset_definitions["},
  {"id":"poi_dataset_definitions]"},
  {"id":"poi_dataset_ext_definitions"},
  {"id":"poi_dataset_headers"},
  {"id":"poi_dataset_source_tables"},
  {"id":"poi_dataset_source_tables["},
  {"id":"poi_dataset_source_tables]"},
  {"id":"poi_debug_log"},
  {"id":"poi_h_models"},
  {"id":"poi_h_models_history"},
  {"id":"poi_kb_datasets"},
  {"id":"poi_kb_excluded_words"},
  {"id":"poi_keywords"},
  {"id":"poi_keywords_map"},
  {"id":"poi_model_attr_stats"},
  {"id":"poi_model_metrics"},
  {"id":"poi_model_metrics_data"},
  {"id":"poi_model_statistics"},
  {"id":"poi_op_progress"},
  {"id":"poi_phrases_map"},
  {"id":"poi_profile_options"},
  {"id":"poi_req_cat_recom_train"},
  {"id":"poi_reset_activity_status"},
  {"id":"poi_results"},
  {"id":"poi_rule_conditions"},
  {"id":"poi_rule_run_hist"},
  {"id":"poi_rules"},
  {"id":"poi_rules_b"},
  {"id":"poi_rules_tl"},
  {"id":"poi_sa_model"},
  {"id":"poi_sa_model_op"},
  {"id":"poi_sa_op_jobs"},
  {"id":"poi_sa_op_progress"},
  {"id":"poi_sa_super_model"},
  {"id":"poi_sm_operation_metrics"},
  {"id":"poi_sm_table_columns"},
  {"id":"poi_sm_table_objects"},
  {"id":"poi_source_taxonomy"},
  {"id":"poi_spend_data"},
  {"id":"poi_spend_data_int"},
  {"id":"poi_taxonomy_data"},
  {"id":"poi_taxonomy_hdr"},
  {"id":"poi_taxonomy_segments"},
  {"id":"poi_transactions"},
  {"id":"poi_ts_batches"},
  {"id":"poi_ts_feture_counter_gt"},
  {"id":"poi_ts_km_param"},
  {"id":"poi_ts_out_result"},
  {"id":"poi_txnmy_seg_lookup"},
  {"id":"pon_acceptances"},
  {"id":"pon_acknowledgements"},
  {"id":"pon_action_history"},
  {"id":"pon_approval_user_comments"},
  {"id":"pon_attachment_summary"},
  {"id":"pon_attribute_lists"},
  {"id":"pon_attribute_scores"},
  {"id":"pon_attributes_interface"},
  {"id":"pon_auc_attr_scores_interface"},
  {"id":"pon_auc_attributes_interface"},
  {"id":"pon_auc_doctypes_b"},
  {"id":"pon_auc_doctypes_tl"},
  {"id":"pon_auc_headers_interface"},
  {"id":"pon_auc_items_interface"},
  {"id":"pon_auc_price_elements_int"},
  {"id":"pon_auc_price_tiers_int"},
  {"id":"pon_auc_shipments_interface"},
  {"id":"pon_auction_attributes"},
  {"id":"pon_auction_currency_rates"},
  {"id":"pon_auction_currency_rates_"},
  {"id":"pon_auction_headers_all"},
  {"id":"pon_auction_headers_all_"},
  {"id":"pon_auction_item_prices_all"},
  {"id":"pon_auction_item_prices_all_"},
  {"id":"pon_auction_sections"},
  {"id":"pon_auction_shipments_all"},
  {"id":"pon_auction_summary"},
  {"id":"pon_award_allocations"},
  {"id":"pon_award_allocations_history"},
  {"id":"pon_award_items_interface"},
  {"id":"pon_backing_req_history"},
  {"id":"pon_backing_requisitions"},
  {"id":"pon_bid_attr_values_interface"},
  {"id":"pon_bid_attribute_values"},
  {"id":"pon_bid_bus_classification_int"},
  {"id":"pon_bid_headers"},
  {"id":"pon_bid_headers_interface"},
  {"id":"pon_bid_item_prices"},
  {"id":"pon_bid_item_prices_interface"},
  {"id":"pon_bid_po_lines"},
  {"id":"pon_bid_po_lines_history"},
  {"id":"pon_bid_po_numbers"},
  {"id":"pon_bid_po_numbers_history"},
  {"id":"pon_bid_po_org_assignments"},
  {"id":"pon_bid_price_elements"},
  {"id":"pon_bid_price_elements_int"},
  {"id":"pon_bid_reqt_values_int"},
  {"id":"pon_bid_reqts_int"},
  {"id":"pon_bid_requirement_values"},
  {"id":"pon_bid_requirements"},
  {"id":"pon_bid_sections"},
  {"id":"pon_bid_shipments"},
  {"id":"pon_bid_shipments_int"},
  {"id":"pon_bidding_parties"},
  {"id":"pon_bidding_parties_"},
  {"id":"pon_bidding_party_contacts"},
  {"id":"pon_bidding_terms_b"},
  {"id":"pon_bidding_terms_tl"},
  {"id":"pon_buyer_activities"},
  {"id":"pon_doctype_styles_b"},
  {"id":"pon_doctype_styles_b["},
  {"id":"pon_doctype_styles_tl"},
  {"id":"pon_doctype_styles_tl["},
  {"id":"pon_fbdi_errors_int"},
  {"id":"pon_interface_errors"},
  {"id":"pon_iot_configuration"},
  {"id":"pon_iot_header_supp_recomm"},
  {"id":"pon_iot_learning_runs"},
  {"id":"pon_iot_line_supp_recomm"},
  {"id":"pon_iot_scoring_req_trail"},
  {"id":"pon_iot_supp_trans_ext"},
  {"id":"pon_item_prices_interface"},
  {"id":"pon_job_monitoring"},
  {"id":"pon_line_cost_factors_int"},
  {"id":"pon_line_icf_summary"},
  {"id":"pon_line_price_tiers_int"},
  {"id":"pon_lines_int"},
  {"id":"pon_list_price_elements"},
  {"id":"pon_neg_abstract_config"},
  {"id":"pon_neg_audit_activities"},
  {"id":"pon_neg_team_members"},
  {"id":"pon_neg_team_members_"},
  {"id":"pon_neg_terms_acceptance"},
  {"id":"pon_negotiation_abstracts"},
  {"id":"pon_negotiation_styles_b"},
  {"id":"pon_negotiation_styles_b["},
  {"id":"pon_negotiation_styles_tl"},
  {"id":"pon_negotiation_styles_tl["},
  {"id":"pon_notification_subscription"},
  {"id":"pon_objective_negotiations"},
  {"id":"pon_party_line_exclusions"},
  {"id":"pon_price_element_lists"},
  {"id":"pon_price_element_types_b"},
  {"id":"pon_price_element_types_tl"},
  {"id":"pon_price_elements"},
  {"id":"pon_program_headers"},
  {"id":"pon_program_objectives"},
  {"id":"pon_program_team_members"},
  {"id":"pon_requirement_scores"},
  {"id":"pon_requirement_scores_int"},
  {"id":"pon_requirement_sections"},
  {"id":"pon_requirement_sections_"},
  {"id":"pon_requirement_sections_int"},
  {"id":"pon_requirements"},
  {"id":"pon_requirements_"},
  {"id":"pon_requirements_int"},
  {"id":"pon_scoring_team_members"},
  {"id":"pon_scoring_teams"},
  {"id":"pon_search_suggestions_tlp"},
  {"id":"pon_seller_auc_bid_headers"},
  {"id":"pon_seller_auc_bid_lines"},
  {"id":"pon_seller_auction_bidders"},
  {"id":"pon_seller_auction_headers"},
  {"id":"pon_seller_auction_lines"},
  {"id":"pon_sfo_parameters_gt"},
  {"id":"pon_supplier_access"},
  {"id":"pon_supplier_activities"},
  {"id":"pon_supplier_activities_header"},
  {"id":"pon_supplier_icf_values"},
  {"id":"pon_team_bid_scores"},
  {"id":"pon_team_requirement_scores"},
  {"id":"pon_temp_lobs"},
  {"id":"pon_thread_message_recipients"},
  {"id":"pon_thread_messages"},
  {"id":"pon_threads"},
  {"id":"poq_action_objects_bu_accesses"},
  {"id":"poq_action_plan_tasks"},
  {"id":"poq_action_plans_b"},
  {"id":"poq_action_plans_tl"},
  {"id":"poq_action_task_assignments"},
  {"id":"poq_action_task_history"},
  {"id":"poq_action_tasks_b"},
  {"id":"poq_action_tasks_tl"},
  {"id":"poq_aggregate_rec_mapping"},
  {"id":"poq_assessment_quals"},
  {"id":"poq_assessments"},
  {"id":"poq_auto_error_attributes"},
  {"id":"poq_automation_errors"},
  {"id":"poq_evaluation_team"},
  {"id":"poq_init_multi_responders"},
  {"id":"poq_init_qual_areas"},
  {"id":"poq_initiative_suppliers"},
  {"id":"poq_initiatives"},
  {"id":"poq_qnaire_rule_entity"},
  {"id":"poq_qnaire_rules"},
  {"id":"poq_qual_area_bu_accesses"},
  {"id":"poq_qual_area_outcomes"},
  {"id":"poq_qual_area_questions"},
  {"id":"poq_qual_areas_b"},
  {"id":"poq_qual_areas_tl"},
  {"id":"poq_qual_model_areas"},
  {"id":"poq_qual_model_bu_accesses"},
  {"id":"poq_qual_model_outcomes"},
  {"id":"poq_qual_models"},
  {"id":"poq_qual_responses"},
  {"id":"poq_qualification_options"},
  {"id":"poq_qualifications"},
  {"id":"poq_ques_acc_responses_b"},
  {"id":"poq_ques_acc_responses_tl"},
  {"id":"poq_question_branches"},
  {"id":"poq_question_scores"},
  {"id":"poq_questions_b"},
  {"id":"poq_questions_tl"},
  {"id":"poq_questnaire_acc_resps"},
  {"id":"poq_questnaire_questions"},
  {"id":"poq_questnaire_resp_headers"},
  {"id":"poq_questnaire_resp_sections"},
  {"id":"poq_questnaire_resp_values"},
  {"id":"poq_questnaire_responses"},
  {"id":"poq_questnaire_sections_b"},
  {"id":"poq_questnaire_sections_tl"},
  {"id":"poq_questnaires_b"},
  {"id":"poq_questnaires_tl"},
  {"id":"poq_recent_activities"},
  {"id":"poq_removed_questions"},
  {"id":"poq_repos_survey_resp_values"},
  {"id":"poq_repos_survey_responses"},
  {"id":"poq_resp_repos_bus_class"},
  {"id":"poq_resp_repos_int"},
  {"id":"poq_resp_repos_value_int"},
  {"id":"poq_resp_repository_values"},
  {"id":"poq_response_repository"},
  {"id":"poq_rule_area_questions"},
  {"id":"poq_rule_set_bu_assignments"},
  {"id":"poq_rule_set_bu_event_rules"},
  {"id":"poq_rule_sets_b"},
  {"id":"poq_rule_sets_tl"},
  {"id":"poq_rules"},
  {"id":"poq_supplier_attributes_b"},
  {"id":"poq_supplier_attributes_tl"},
  {"id":"poq_supplier_elig_history"},
  {"id":"poq_supplier_eligibility"},
  {"id":"por_amx_actions"},
  {"id":"por_amx_aggregate_attributes"},
  {"id":"por_amx_approval_groups"},
  {"id":"por_amx_attributes"},
  {"id":"por_amx_attributes["},
  {"id":"por_amx_attributes]"},
  {"id":"por_amx_condition_ins"},
  {"id":"por_amx_conditions"},
  {"id":"por_amx_currency_attributes"},
  {"id":"por_amx_custom_attributes"},
  {"id":"por_amx_dimensions"},
  {"id":"por_amx_participants"},
  {"id":"por_amx_rule_attribute_usages"},
  {"id":"por_amx_rules"},
  {"id":"por_amx_rules_jobs"},
  {"id":"por_amx_ruleset_checksums"},
  {"id":"por_amx_stages"},
  {"id":"por_amx_tasks"},
  {"id":"por_approval_task_comments"},
  {"id":"por_browse_categories_b"},
  {"id":"por_browse_categories_tl"},
  {"id":"por_browse_normalized_trees"},
  {"id":"por_browse_trees"},
  {"id":"por_ca_gen_session_gt"},
  {"id":"por_catalog_assignments"},
  {"id":"por_catalog_search_objects"},
  {"id":"por_catalogs_all_b"},
  {"id":"por_catalogs_all_tl"},
  {"id":"por_content_zones_all_b"},
  {"id":"por_content_zones_all_tl"},
  {"id":"por_cur_conv_factor_session_gt"},
  {"id":"por_cz_assignments"},
  {"id":"por_cz_security_assignments"},
  {"id":"por_doc_parse_errors"},
  {"id":"por_doc_upload_jobs"},
  {"id":"por_info_catalogs"},
  {"id":"por_info_template_usages"},
  {"id":"por_info_templates_all_b"},
  {"id":"por_info_templates_all_tl"},
  {"id":"por_item_cat_parent_levels"},
  {"id":"por_items_ctx_dtls_tlp"},
  {"id":"por_items_ctx_hdrs_tlp"},
  {"id":"por_local_catalogs"},
  {"id":"por_map_set_headers_all_b"},
  {"id":"por_map_set_headers_all_tl"},
  {"id":"por_map_set_lines"},
  {"id":"por_one_time_locations"},
  {"id":"por_online_report_text"},
  {"id":"por_personal_list_headers"},
  {"id":"por_personal_list_lines"},
  {"id":"por_pl_info_template_values"},
  {"id":"por_public_list_headers_all_b"},
  {"id":"por_public_list_headers_all_tl"},
  {"id":"por_public_list_lines"},
  {"id":"por_punchout_catalogs"},
  {"id":"por_punchout_item_errors"},
  {"id":"por_punchout_items"},
  {"id":"por_purchase_req_event_history"},
  {"id":"por_purchasing_news"},
  {"id":"por_req_bcea_data"},
  {"id":"por_req_bu_options_all"},
  {"id":"por_req_config_comps_int"},
  {"id":"por_req_distributions_all"},
  {"id":"por_req_dists_interface_all"},
  {"id":"por_req_event_sequence"},
  {"id":"por_req_headers_interface_all"},
  {"id":"por_req_import_errors"},
  {"id":"por_req_import_hdrs_session_gt"},
  {"id":"por_req_info_template_values"},
  {"id":"por_req_lines_interface_all"},
  {"id":"por_req_split_lines_gt"},
  {"id":"por_requisition_headers_all"},
  {"id":"por_requisition_lines_all"},
  {"id":"por_search_index_options"},
  {"id":"por_search_phrases"},
  {"id":"por_search_phrases_log"},
  {"id":"por_session_gt"},
  {"id":"por_short_url_details"},
  {"id":"por_smart_form_cat_assignments"},
  {"id":"por_smart_forms_all_b"},
  {"id":"por_smart_forms_all_tl"},
  {"id":"por_upgrade_processes_history"},
  {"id":"por_user_pref_accounts_all"},
  {"id":"por_user_preferences_all"},
  {"id":"pos_user_access_val_requests"},
  {"id":"pos_user_access_values"},
  {"id":"poz_acnt_addr_reqs"},
  {"id":"poz_acnt_addr_summ_reqs"},
  {"id":"poz_acnt_gen_reqs"},
  {"id":"poz_address_requests"},
  {"id":"poz_approval_history"},
  {"id":"poz_approval_user_comments"},
  {"id":"poz_attachment_summary"},
  {"id":"poz_b2b_document_configs"},
  {"id":"poz_bus_class_reqs"},
  {"id":"poz_bus_classifications"},
  {"id":"poz_bus_classifications_"},
  {"id":"poz_cert_agency_classfns"},
  {"id":"poz_certifying_agencies"},
  {"id":"poz_cont_addr_requests"},
  {"id":"poz_contact_attribute_request"},
  {"id":"poz_contact_attributes"},
  {"id":"poz_contact_requests"},
  {"id":"poz_df_firmographic_mapping"},
  {"id":"poz_df_scoring_criteria"},
  {"id":"poz_ext_data_mapping"},
  {"id":"poz_ext_data_providers"},
  {"id":"poz_ext_data_sup_prov_ids"},
  {"id":"poz_infolet_counts"},
  {"id":"poz_new_supp_doc_config"},
  {"id":"poz_product_service_requests"},
  {"id":"poz_provisionable_roles"},
  {"id":"poz_reg_denied_parties"},
  {"id":"poz_search_suggestions_tlp"},
  {"id":"poz_search_suggestions_tlp_gt"},
  {"id":"poz_site_assignments_all_m"},
  {"id":"poz_site_assignments_all_m_"},
  {"id":"poz_site_assignments_int"},
  {"id":"poz_spend_auth_requests"},
  {"id":"poz_sup_addresses_int"},
  {"id":"poz_sup_attachments_int"},
  {"id":"poz_sup_bus_class_int"},
  {"id":"poz_sup_contact_addresses_int"},
  {"id":"poz_sup_contacts_int"},
  {"id":"poz_sup_prod_serv_int"},
  {"id":"poz_sup_products_services"},
  {"id":"poz_sup_products_services_"},
  {"id":"poz_sup_reg_pii"},
  {"id":"poz_sup_reg_session_tokens"},
  {"id":"poz_sup_thirdparty_int"},
  {"id":"poz_sup_thirdparty_payment_re_"},
  {"id":"poz_sup_thirdparty_payment_rel"},
  {"id":"poz_supp_acct_owner_requests"},
  {"id":"poz_supp_address_requests"},
  {"id":"poz_supp_bank_acct_requests"},
  {"id":"poz_supp_bus_class_requests"},
  {"id":"poz_supp_config_match"},
  {"id":"poz_supp_cont_addr_requests"},
  {"id":"poz_supp_contact_requests"},
  {"id":"poz_supp_interm_acct_requests"},
  {"id":"poz_supp_org_details_requests"},
  {"id":"poz_supp_pmt_method_requests"},
  {"id":"poz_supp_prod_serv_requests"},
  {"id":"poz_supp_requests"},
  {"id":"poz_supp_requests_pii"},
  {"id":"poz_supp_site_assign_requests"},
  {"id":"poz_supp_site_requests"},
  {"id":"poz_supp_tax_details_requests"},
  {"id":"poz_supp_temp_bank_requests"},
  {"id":"poz_supp_tpp_rel_requests"},
  {"id":"poz_supp_user_data_access_reqs"},
  {"id":"poz_supp_user_role_requests"},
  {"id":"poz_supplier_contacts"},
  {"id":"poz_supplier_contacts_"},
  {"id":"poz_supplier_entity_config"},
  {"id":"poz_supplier_int_rejections"},
  {"id":"poz_supplier_mappings"},
  {"id":"poz_supplier_merge_requests"},
  {"id":"poz_supplier_merge_requests_"},
  {"id":"poz_supplier_news_b"},
  {"id":"poz_supplier_news_tl"},
  {"id":"poz_supplier_options"},
  {"id":"poz_supplier_registrations"},
  {"id":"poz_supplier_sites_all_m"},
  {"id":"poz_supplier_sites_all_m_"},
  {"id":"poz_supplier_sites_int"},
  {"id":"poz_supplier_sites_pii"},
  {"id":"poz_suppliers"},
  {"id":"poz_suppliers_"},
  {"id":"poz_suppliers_denied_parties"},
  {"id":"poz_suppliers_denied_parties_"},
  {"id":"poz_suppliers_int"},
  {"id":"poz_suppliers_pii"},
  {"id":"poz_suppliers_pii_"},
  {"id":"poz_up_requests"},
  {"id":"poz_up_role_requests"},
  {"id":"poz_up_user_requests"}
];

// HWM schema tables (time cards etc) - shown when API fails so user can still search/use them
const HWM_TABLES = [
  {"id":"HWM.HWM_TIMECARDS"}, {"id":"HWM.HWM_TIME_ENTRIES"}, {"id":"HWM.HWM_TIMECARD_FIELDS"},
  {"id":"HWM.HWM_GRPS_B"}, {"id":"HWM.HWM_TM_HIS_ABS_ENTRY_V"}, {"id":"HWM.HWM_EXT_HEADERS"},
  {"id":"HWM.HWM_EXT_DAYS"}, {"id":"HWM.HWM_EXT_ENTRIES"}, {"id":"HWM.HWM_TIME_CARD_GROUPS_B"},
  {"id":"HWM.HWM_TIME_RECORDS"}, {"id":"HWM.HWM_ABSENCE_ENTRIES"}, {"id":"HWM.HWM_WORK_MEASURE_ENTRIES"}
];

const TableBrowser = ({ selectedConnection, tables = [], onTableSelect, onTablesChange, onColumnsLoaded }) => {
  const [filteredTables, setFilteredTables] = useState([]);
  const [filter, setFilter] = useState('');
  const [selectedTable, setSelectedTable] = useState(null);
  const [columns, setColumns] = useState([]);
  const [columnsLoading, setColumnsLoading] = useState(false);
  const [columnsError, setColumnsError] = useState(null);
  const [columnsManualQuery, setColumnsManualQuery] = useState(null);
  const [columnsExpanded, setColumnsExpanded] = useState(true);

  const [fetchedTables, setFetchedTables] = useState([]);
  const [tablesLoading, setTablesLoading] = useState(false);
  const [tablesError, setTablesError] = useState(null);

  const fetchTables = useCallback(async () => {
    if (!selectedConnection?.id) return;
    setTablesLoading(true);
    setTablesError(null);
    try {
      const { data } = await queryAPI.getTables(selectedConnection.id, '');
      const tablesList = data.tables || [];
      setFetchedTables(tablesList);
      if (tablesList.length === 0 && data.error) setTablesError(data.error);
    } catch (err) {
      setTablesError(err.response?.data?.error || err.message || 'Failed to load tables');
      setFetchedTables([]);
    } finally {
      setTablesLoading(false);
    }
  }, [selectedConnection?.id]);

  useEffect(() => {
    if (!selectedConnection?.id) {
      setFetchedTables([]);
      setTablesError(null);
      setColumns([]);
      if (onColumnsLoaded) onColumnsLoaded([]);
      return;
    }
    // Dashboard already fetches and caches tables per connection - use them when available
    if (tables.length > 0) {
      setFetchedTables(tables);
      return;
    }
    fetchTables();
  }, [selectedConnection?.id, tables, fetchTables, onColumnsLoaded]);

  const tableSource = useMemo(() => {
    const fromApi = fetchedTables.length > 0 ? fetchedTables : (tables.length > 0 ? tables : []);
    if (fromApi.length > 0) {
      return fromApi.map(t => typeof t === 'string' ? { id: t } : (t && (t.id || t.name) ? { id: t.id || t.name } : null)).filter(Boolean);
    }
    return [...TABLE_DATA, ...HWM_TABLES];
  }, [fetchedTables, tables]);

  useEffect(() => {
    if (onTablesChange) onTablesChange(tableSource);
  }, [tableSource, onTablesChange]);

  useEffect(() => {
    if (filter.length === 0) {
      setFilteredTables(tableSource);
    } else {
      const filtered = tableSource.filter(table => {
        const tableId = table.id || '';
        return tableId.toLowerCase().includes(filter.toLowerCase());
      });
      setFilteredTables(filtered);
    }
  }, [filter, tableSource]);

  const handleTableClick = async (table) => {
    const tableId = table.id || '';
    if (onTableSelect) {
      onTableSelect(tableId);
    }
    setSelectedTable(tableId);
    setColumns([]);
    setColumnsError(null);
    setColumnsManualQuery(null);
    setColumnsExpanded(true);

    if (selectedConnection?.id && tableId) {
      setColumnsLoading(true);
      try {
        const { data } = await queryAPI.getTableColumns(selectedConnection.id, tableId);
        const cols = data.columns || [];
        setColumns(cols);
        if (onColumnsLoaded) onColumnsLoaded(cols);
        if (data.error) {
          setColumnsError(data.error_detail || data.error);
          setColumnsManualQuery(data.manual_query || null);
        }
      } catch (err) {
        const errData = err.response?.data;
        setColumnsError(errData?.error_detail || errData?.error || err.message || 'Failed to load columns');
        setColumnsManualQuery(errData?.manual_query || null);
        setColumns([]);
      } finally {
        setColumnsLoading(false);
      }
    } else {
      setColumns([]);
      if (onColumnsLoaded) onColumnsLoaded([]);
      setColumnsError('Select a connection to view column names');
    }
  };

  return (
    <div className="table-browser">
      <div className="browser-header">
        <div>
          <h3>Tables Browser</h3>
        </div>
      </div>

      {tablesError && fetchedTables.length === 0 && (
        <div className="tables-api-error" role="alert">
          <strong>Could not load tables from database:</strong> {tablesError}
          <span className="tables-fallback-note"> Showing cached list instead. HXT, HWM and other schema tables may be missing.</span>
          <button type="button" className="btn-retry-tables" onClick={fetchTables} disabled={tablesLoading}>
            {tablesLoading ? 'Retrying…' : 'Retry'}
          </button>
        </div>
      )}

      <div className="browser-search">
        <input
          type="text"
          placeholder="Filter tables..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="search-input"
        />
        {filter && (
          <button 
            className="btn-clear-filter" 
            onClick={() => setFilter('')}
            title="Clear filter"
          >
            ✕
          </button>
        )}
      </div>

      <div className="browser-count">
        {tablesLoading ? (
          <span className="tables-loading-msg">Loading tables from database… (this can take 30–60 seconds)</span>
        ) : filter.length > 0 ? (
          <span>
            Showing {filteredTables.length} of {tableSource.length} tables
          </span>
        ) : (
          <span>{tableSource.length} tables available</span>
        )}
      </div>

      <div className="tables-list">
        {filteredTables.length === 0 && filter.length > 0 ? (
          <div className="no-results">
            <p>No tables match "{filter}"</p>
            <button onClick={() => setFilter('')} className="btn-clear">
              Clear Filter
            </button>
          </div>
        ) : (
          filteredTables.map((table, index) => {
            const tableId = table.id || '';
            const isSelected = selectedTable === tableId;
            const displayName = tableId.includes('.') ? tableId.split('.')[1] || tableId : tableId;
            return (
              <div key={index} className="table-item-wrapper">
                <div
                  className={`table-item ${isSelected ? 'table-item-selected' : ''}`}
                  onClick={() => handleTableClick(table)}
                  title={`Click to insert table and view columns: SELECT * FROM ${tableId}`}
                >
                  <span className="table-name">{displayName}</span>
                </div>
                {isSelected && (
                  <div className="table-columns-inline">
                    <div
                      className="columns-header"
                      onClick={() => setColumnsExpanded(!columnsExpanded)}
                      title={columnsExpanded ? 'Collapse columns' : 'Expand columns'}
                    >
                      <span className="columns-toggle">{columnsExpanded ? '▼' : '▶'}</span>
                      <span>Columns ({columns.length})</span>
                    </div>
                    {columnsExpanded && (
                      <>
                        {columnsLoading ? (
                          <div className="columns-loading">Loading columns...</div>
                        ) : columnsError ? (
                          <div className="columns-error-block">
                            <div className="columns-error">{columnsError}</div>
                            {columnsManualQuery && (
                              <div className="columns-manual-query">
                                <button
                                  type="button"
                                  className="btn-copy-query"
                                  onClick={() => {
                                    navigator.clipboard.writeText(columnsManualQuery);
                                    toast.success('Query copied to clipboard');
                                  }}
                                  title="Copy to clipboard"
                                >
                                  Copy query to run manually
                                </button>
                                <pre className="manual-query-text">{columnsManualQuery}</pre>
                              </div>
                            )}
                          </div>
                        ) : columns.length > 0 ? (
                          <div className="columns-list-scroll">
                            <div className="columns-list-header">
                              <span>Name</span>
                              <span>Type</span>
                              <span>Length</span>
                              <span>Nullable</span>
                            </div>
                            {columns.map((col, i) => (
                              <div key={i} className="column-row">
                                <span className="col-name">{col.column_name || col}</span>
                                <span className="col-type">{col.data_type || '-'}</span>
                                <span className="col-length">{col.data_length || '-'}</span>
                                <span className={`col-nullable col-nullable-${(col.nullable || '').toUpperCase() === 'YES' ? 'yes' : 'no'}`}>
                                  {col.nullable || '-'}
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="columns-empty">No columns found</div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default TableBrowser;
